export interface District {
  district: Array<{
     id: number,
     code: string,
     text: string,
     value: string,
     name: {
       th: string,
       en: string,
    },
    provinceId: number,
  }>
}

export function getDistrict(): District {
  return {
    district: [
      {
        id: 1,
        code: '1001',
        text: 'พระนคร',
        value: 'พระนคร',
        name: {
          th: 'พระนคร',
          en: 'Khet Phra Nakhon',
        },
        provinceId: 1,
     },
     {
        id: 2,
        code: '1002',
        text: 'ดุสิต',
        value: 'ดุสิต',
        name: {
          th: 'ดุสิต',
          en: 'Khet Dusit',
        },
        provinceId: 1,
     },
     {
        id: 3,
        code: '1003',
        text: 'หนองจอก',
        value: 'หนองจอก',
        name: {
          th: 'หนองจอก',
          en: 'Khet Nong Chok',
        },
        provinceId: 1,
     },
     {
        id: 4,
        code: '1004',
        text: 'บางรัก',
        value: 'บางรัก',
        name: {
          th: 'บางรัก',
          en: 'Khet Bang Rak',
        },
        provinceId: 1,
     },
     {
        id: 5,
        code: '1005',
        text: 'บางเขน',
        value: 'บางเขน',
        name: {
          th: 'บางเขน',
          en: 'Khet Bang Kh en',
        },
        provinceId: 1,
     },
     {
        id: 6,
        code: '1006',
        text: 'บางกะปิ',
        value: 'บางกะปิ',
        name: {
          th: 'บางกะปิ',
          en: 'Khet Bang Kapi',
        },
        provinceId: 1,
     },
     {
        id: 7,
        code: '1007',
        text: 'ปทุมวัน',
        value: 'ปทุมวัน',
        name: {
          th: 'ปทุมวัน',
          en: 'Khet Pa thum Wan',
        },
        provinceId: 1,
     },
     {
        id: 8,
        code: '1008',
        text: 'ป้อมปราบศัตรูพ่าย',
        value: 'ป้อมปราบศัตรูพ่าย',
        name: {
          th: 'ป้อมปราบศัตรูพ่าย',
          en: 'Khet Pom Prap Sattru Phai',
        },
        provinceId: 1,
     },
     {
        id: 9,
        code: '1009',
        text: 'พระโขนง',
        value: 'พระโขนง',
        name: {
          th: 'พระโขนง',
          en: 'Khet Phra Khanong',
        },
        provinceId: 1,
     },
     {
        id: 10,
        code: '1010',
        text: 'มีนบุรี',
        value: 'มีนบุรี',
        name: {
          th: 'มีนบุรี',
          en: 'Khet Min Buri',
        },
        provinceId: 1,
     },
     {
        id: 11,
        code: '1011',
        text: 'ลาดกระบัง',
        value: 'ลาดกระบัง',
        name: {
          th: 'ลาดกระบัง',
          en: 'Khet Lat Krabang',
        },
        provinceId: 1,
     },
     {
        id: 12,
        code: '1012',
        text: 'ยานนาวา',
        value: 'ยานนาวา',
        name: {
          th: 'ยานนาวา',
          en: 'Khet Yan Nawa',
        },
        provinceId: 1,
     },
     {
        id: 13,
        code: '1013',
        text: 'สัมพันธวงศ์',
        value: 'สัมพันธวงศ์',
        name: {
          th: 'สัมพันธวงศ์',
          en: 'Khet Samphan thawong',
        },
        provinceId: 1,
     },
     {
        id: 14,
        code: '1014',
        text: 'พญาไท',
        value: 'พญาไท',
        name: {
          th: 'พญาไท',
          en: 'Khet Phaya  thai',
        },
        provinceId: 1,
     },
     {
        id: 15,
        code: '1015',
        text: 'ธนบุรี',
        value: 'ธนบุรี',
        name: {
          th: 'ธนบุรี',
          en: 'Khet  thon Buri',
        },
        provinceId: 1,
     },
     {
        id: 16,
        code: '1016',
        text: 'บางกอกใหญ่',
        value: 'บางกอกใหญ่',
        name: {
          th: 'บางกอกใหญ่',
          en: 'Khet Bangkok Yai',
        },
        provinceId: 1,
     },
     {
        id: 17,
        code: '1017',
        text: 'ห้วยขวาง',
        value: 'ห้วยขวาง',
        name: {
          th: 'ห้วยขวาง',
          en: 'Khet Huai Khwang',
        },
        provinceId: 1,
     },
     {
        id: 18,
        code: '1018',
        text: 'คลองสาน',
        value: 'คลองสาน',
        name: {
          th: 'คลองสาน',
          en: 'Khet Khlong San',
        },
        provinceId: 1,
     },
     {
        id: 19,
        code: '1019',
        text: 'ตลิ่งชัน',
        value: 'ตลิ่งชัน',
        name: {
          th: 'ตลิ่งชัน',
          en: 'Khet Taling Chan',
        },
        provinceId: 1,
     },
     {
        id: 20,
        code: '1020',
        text: 'บางกอกน้อย',
        value: 'บางกอกน้อย',
        name: {
          th: 'บางกอกน้อย',
          en: 'Khet Bangkok Noi',
        },
        provinceId: 1,
     },
     {
        id: 21,
        code: '1021',
        text: 'บางขุนเทียน',
        value: 'บางขุนเทียน',
        name: {
          th: 'บางขุนเทียน',
          en: 'Khet Bang Khun  thian',
        },
        provinceId: 1,
     },
     {
        id: 22,
        code: '1022',
        text: 'ภาษีเจริญ',
        value: 'ภาษีเจริญ',
        name: {
          th: 'ภาษีเจริญ',
          en: 'Khet Phasi Charo en',
        },
        provinceId: 1,
     },
     {
        id: 23,
        code: '1023',
        text: 'หนองแขม',
        value: 'หนองแขม',
        name: {
          th: 'หนองแขม',
          en: 'Khet Nong Khaem',
        },
        provinceId: 1,
     },
     {
        id: 24,
        code: '1024',
        text: 'ราษฎร์บูรณะ',
        value: 'ราษฎร์บูรณะ',
        name: {
          th: 'ราษฎร์บูรณะ',
          en: 'Khet Rat Burana',
        },
        provinceId: 1,
     },
     {
        id: 25,
        code: '1025',
        text: 'บางพลัด',
        value: 'บางพลัด',
        name: {
          th: 'บางพลัด',
          en: 'Khet Bang Phlat',
        },
        provinceId: 1,
     },
     {
        id: 26,
        code: '1026',
        text: 'ดินแดง',
        value: 'ดินแดง',
        name: {
          th: 'ดินแดง',
          en: 'Khet Din Da eng',
        },
        provinceId: 1,
     },
     {
        id: 27,
        code: '1027',
        text: 'บึงกุ่ม',
        value: 'บึงกุ่ม',
        name: {
          th: 'บึงกุ่ม',
          en: 'Khet Bu eng Kum',
        },
        provinceId: 1,
     },
     {
        id: 28,
        code: '1028',
        text: 'สาทร',
        value: 'สาทร',
        name: {
          th: 'สาทร',
          en: 'Khet Sa thon',
        },
        provinceId: 1,
     },
     {
        id: 29,
        code: '1029',
        text: 'บางซื่อ',
        value: 'บางซื่อ',
        name: {
          th: 'บางซื่อ',
          en: 'Khet Bang Sue',
        },
        provinceId: 1,
     },
     {
        id: 30,
        code: '1030',
        text: 'จตุจักร',
        value: 'จตุจักร',
        name: {
          th: 'จตุจักร',
          en: 'Khet Chatuchak',
        },
        provinceId: 1,
     },
     {
        id: 31,
        code: '1031',
        text: 'บางคอแหลม',
        value: 'บางคอแหลม',
        name: {
          th: 'บางคอแหลม',
          en: 'Khet Bang Kho Laem',
        },
        provinceId: 1,
     },
     {
        id: 32,
        code: '1032',
        text: 'ประเวศ',
        value: 'ประเวศ',
        name: {
          th: 'ประเวศ',
          en: 'Khet Prawet',
        },
        provinceId: 1,
     },
     {
        id: 33,
        code: '1033',
        text: 'คลองเตย',
        value: 'คลองเตย',
        name: {
          th: 'คลองเตย',
          en: 'Khet Khlong Toei',
        },
        provinceId: 1,
     },
     {
        id: 34,
        code: '1034',
        text: 'สวนหลวง',
        value: 'สวนหลวง',
        name: {
          th: 'สวนหลวง',
          en: 'Khet Suan Luang',
        },
        provinceId: 1,
     },
     {
        id: 35,
        code: '1035',
        text: 'จอมทอง',
        value: 'จอมทอง',
        name: {
          th: 'จอมทอง',
          en: 'Khet Chom  thong',
        },
        provinceId: 1,
     },
     {
        id: 36,
        code: '1036',
        text: 'ดอนเมือง',
        value: 'ดอนเมือง',
        name: {
          th: 'ดอนเมือง',
          en: 'Khet Don Mueang',
        },
        provinceId: 1,
     },
     {
        id: 37,
        code: '1037',
        text: 'ราชเทวี',
        value: 'ราชเทวี',
        name: {
          th: 'ราชเทวี',
          en: 'Khet Ratcha thewi',
        },
        provinceId: 1,
     },
     {
        id: 38,
        code: '1038',
        text: 'ลาดพร้าว',
        value: 'ลาดพร้าว',
        name: {
          th: 'ลาดพร้าว',
          en: 'Khet Lat Phrao',
        },
        provinceId: 1,
     },
     {
        id: 39,
        code: '1039',
        text: 'วัฒนา',
        value: 'วัฒนา',
        name: {
          th: 'วัฒนา',
          en: 'Khet Wat thana',
        },
        provinceId: 1,
     },
     {
        id: 40,
        code: '1040',
        text: 'บางแค',
        value: 'บางแค',
        name: {
          th: 'บางแค',
          en: 'Khet Bang Khae',
        },
        provinceId: 1,
     },
     {
        id: 41,
        code: '1041',
        text: 'หลักสี่',
        value: 'หลักสี่',
        name: {
          th: 'หลักสี่',
          en: 'Khet Lak Si',
        },
        provinceId: 1,
     },
     {
        id: 42,
        code: '1042',
        text: 'สายไหม',
        value: 'สายไหม',
        name: {
          th: 'สายไหม',
          en: 'Khet Sai Mai',
        },
        provinceId: 1,
     },
     {
        id: 43,
        code: '1043',
        text: 'คันนายาว',
        value: 'คันนายาว',
        name: {
          th: 'คันนายาว',
          en: 'Khet Khan Na Yao',
        },
        provinceId: 1,
     },
     {
        id: 44,
        code: '1044',
        text: 'สะพานสูง',
        value: 'สะพานสูง',
        name: {
          th: 'สะพานสูง',
          en: 'Khet Saphan Sung',
        },
        provinceId: 1,
     },
     {
        id: 45,
        code: '1045',
        text: 'วังทองหลาง',
        value: 'วังทองหลาง',
        name: {
          th: 'วังทองหลาง',
          en: 'Khet Wang  thonglang',
        },
        provinceId: 1,
     },
     {
        id: 46,
        code: '1046',
        text: 'คลองสามวา',
        value: 'คลองสามวา',
        name: {
          th: 'คลองสามวา',
          en: 'Khet Khlong Sam Wa',
        },
        provinceId: 1,
     },
     {
        id: 47,
        code: '1047',
        text: 'บางนา',
        value: 'บางนา',
        name: {
          th: 'บางนา',
          en: 'Khet Bang Na',
        },
        provinceId: 1,
     },
     {
        id: 48,
        code: '1048',
        text: 'ทวีวัฒนา',
        value: 'ทวีวัฒนา',
        name: {
          th: 'ทวีวัฒนา',
          en: 'Khet  thawi Wat thana',
        },
        provinceId: 1,
     },
     {
        id: 49,
        code: '1049',
        text: 'ทุ่งครุ',
        value: 'ทุ่งครุ',
        name: {
          th: 'ทุ่งครุ',
          en: 'Khet  thung Khru',
        },
        provinceId: 1,
     },
     {
        id: 50,
        code: '1050',
        text: 'บางบอน',
        value: 'บางบอน',
        name: {
          th: 'บางบอน',
          en: 'Khet Bang Bon',
        },
        provinceId: 1,
     },
     {
        id: 51,
        code: '1081',
        text: 'บ้านทะวาย',
        value: 'บ้านทะวาย',
        name: {
          th: 'บ้านทะวาย',
          en: 'Bantawai',
        },
        provinceId: 1,
     },
     {
        id: 52,
        code: '1101',
        text: 'เมืองสมุทรปราการ',
        value: 'เมืองสมุทรปราการ',
        name: {
          th: 'เมืองสมุทรปราการ',
          en: 'Mueang Samut Prakan',
        },
        provinceId: 2,
     },
     {
        id: 53,
        code: '1102',
        text: 'บางบ่อ',
        value: 'บางบ่อ',
        name: {
          th: 'บางบ่อ',
          en: 'Bang Bo',
        },
        provinceId: 2,
     },
     {
        id: 54,
        code: '1103',
        text: 'บางพลี',
        value: 'บางพลี',
        name: {
          th: 'บางพลี',
          en: 'Bang Phli',
        },
        provinceId: 2,
     },
     {
        id: 55,
        code: '1104',
        text: 'พระประแดง',
        value: 'พระประแดง',
        name: {
          th: 'พระประแดง',
          en: 'Phra Prada eng',
        },
        provinceId: 2,
     },
     {
        id: 56,
        code: '1105',
        text: 'พระสมุทรเจดีย์',
        value: 'พระสมุทรเจดีย์',
        name: {
          th: 'พระสมุทรเจดีย์',
          en: 'Phra Samut Chedi',
        },
        provinceId: 2,
     },
     {
        id: 57,
        code: '1106',
        text: 'บางเสาธง',
        value: 'บางเสาธง',
        name: {
          th: 'บางเสาธง',
          en: 'Bang Sao  thong',
        },
        provinceId: 2,
     },
     {
        id: 58,
        code: '1201',
        text: 'เมืองนนทบุรี',
        value: 'เมืองนนทบุรี',
        name: {
          th: 'เมืองนนทบุรี',
          en: 'Mueang Non thaburi',
        },
        provinceId: 3,
     },
     {
        id: 59,
        code: '1202',
        text: 'บางกรวย',
        value: 'บางกรวย',
        name: {
          th: 'บางกรวย',
          en: 'Bang Kruai',
        },
        provinceId: 3,
     },
     {
        id: 60,
        code: '1203',
        text: 'บางใหญ่',
        value: 'บางใหญ่',
        name: {
          th: 'บางใหญ่',
          en: 'Bang Yai',
        },
        provinceId: 3,
     },
     {
        id: 61,
        code: '1204',
        text: 'บางบัวทอง',
        value: 'บางบัวทอง',
        name: {
          th: 'บางบัวทอง',
          en: 'Bang Bua  thong',
        },
        provinceId: 3,
     },
     {
        id: 62,
        code: '1205',
        text: 'ไทรน้อย',
        value: 'ไทรน้อย',
        name: {
          th: 'ไทรน้อย',
          en: 'Sai Noi',
        },
        provinceId: 3,
     },
     {
        id: 63,
        code: '1206',
        text: 'ปากเกร็ด',
        value: 'ปากเกร็ด',
        name: {
          th: 'ปากเกร็ด',
          en: 'Pak Kret',
        },
        provinceId: 3,
     },
     {
        id: 64,
        code: '1251',
        text: 'เทศบาลนครนนทบุรี (สาขาแขวงท่าทราย)',
        value: 'เทศบาลนครนนทบุรี (สาขาแขวงท่าทราย)',
        name: {
          th: 'เทศบาลนครนนทบุรี (สาขาแขวงท่าทราย)',
          en: 'Tetsaban Non thaburi',
        },
        provinceId: 3,
     },
     {
        id: 65,
        code: '1297',
        text: 'เทศบาลเมืองปากเกร็ด',
        value: 'เทศบาลเมืองปากเกร็ด',
        name: {
          th: 'เทศบาลเมืองปากเกร็ด',
          en: 'Tetsaban Pak Kret',
        },
        provinceId: 3,
     },
     {
        id: 66,
        code: '1301',
        text: 'เมืองปทุมธานี',
        value: 'เมืองปทุมธานี',
        name: {
          th: 'เมืองปทุมธานี',
          en: 'Mueang Pa thum  thani',
        },
        provinceId: 4,
     },
     {
        id: 67,
        code: '1302',
        text: 'คลองหลวง',
        value: 'คลองหลวง',
        name: {
          th: 'คลองหลวง',
          en: 'Khlong Luang',
        },
        provinceId: 4,
     },
     {
        id: 68,
        code: '1303',
        text: 'ธัญบุรี',
        value: 'ธัญบุรี',
        name: {
          th: 'ธัญบุรี',
          en: ' thanyaburi',
        },
        provinceId: 4,
     },
     {
        id: 69,
        code: '1304',
        text: 'หนองเสือ',
        value: 'หนองเสือ',
        name: {
          th: 'หนองเสือ',
          en: 'Nong Suea',
        },
        provinceId: 4,
     },
     {
        id: 70,
        code: '1305',
        text: 'ลาดหลุมแก้ว',
        value: 'ลาดหลุมแก้ว',
        name: {
          th: 'ลาดหลุมแก้ว',
          en: 'Lat Lum Kaeo',
        },
        provinceId: 4,
     },
     {
        id: 71,
        code: '1306',
        text: 'ลำลูกกา',
        value: 'ลำลูกกา',
        name: {
          th: 'ลำลูกกา',
          en: 'Lam Luk Ka',
        },
        provinceId: 4,
     },
     {
        id: 72,
        code: '1307',
        text: 'สามโคก',
        value: 'สามโคก',
        name: {
          th: 'สามโคก',
          en: 'Sam Khok',
        },
        provinceId: 4,
     },
     {
        id: 73,
        code: '1351',
        text: 'ลำลูกกา (สาขาตำบลคูคต)',
        value: 'ลำลูกกา (สาขาตำบลคูคต)',
        name: {
          th: 'ลำลูกกา (สาขาตำบลคูคต)',
          en: 'Khlong Luang(Kukod)',
        },
        provinceId: 4,
     },
     {
        id: 74,
        code: '1401',
        text: 'พระนครศรีอยุธยา',
        value: 'พระนครศรีอยุธยา',
        name: {
          th: 'พระนครศรีอยุธยา',
          en: 'Phra Nakhon Si Ayut thaya',
        },
        provinceId: 5,
     },
     {
        id: 75,
        code: '1402',
        text: 'ท่าเรือ',
        value: 'ท่าเรือ',
        name: {
          th: 'ท่าเรือ',
          en: ' tha Ruea',
        },
        provinceId: 5,
     },
     {
        id: 76,
        code: '1403',
        text: 'นครหลวง',
        value: 'นครหลวง',
        name: {
          th: 'นครหลวง',
          en: 'Nakhon Luang',
        },
        provinceId: 5,
     },
     {
        id: 77,
        code: '1404',
        text: 'บางไทร',
        value: 'บางไทร',
        name: {
          th: 'บางไทร',
          en: 'Bang Sai',
        },
        provinceId: 5,
     },
     {
        id: 78,
        code: '1405',
        text: 'บางบาล',
        value: 'บางบาล',
        name: {
          th: 'บางบาล',
          en: 'Bang Ban',
        },
        provinceId: 5,
     },
     {
        id: 79,
        code: '1406',
        text: 'บางปะอิน',
        value: 'บางปะอิน',
        name: {
          th: 'บางปะอิน',
          en: 'Bang Pa-in',
        },
        provinceId: 5,
     },
     {
        id: 80,
        code: '1407',
        text: 'บางปะหัน',
        value: 'บางปะหัน',
        name: {
          th: 'บางปะหัน',
          en: 'Bang Pahan',
        },
        provinceId: 5,
     },
     {
        id: 81,
        code: '1408',
        text: 'ผักไห่',
        value: 'ผักไห่',
        name: {
          th: 'ผักไห่',
          en: 'Phak Hai',
        },
        provinceId: 5,
     },
     {
        id: 82,
        code: '1409',
        text: 'ภาชี',
        value: 'ภาชี',
        name: {
          th: 'ภาชี',
          en: 'Phachi',
        },
        provinceId: 5,
     },
     {
        id: 83,
        code: '1410',
        text: 'ลาดบัวหลวง',
        value: 'ลาดบัวหลวง',
        name: {
          th: 'ลาดบัวหลวง',
          en: 'Lat Bua Luang',
        },
        provinceId: 5,
     },
     {
        id: 84,
        code: '1411',
        text: 'วังน้อย',
        value: 'วังน้อย',
        name: {
          th: 'วังน้อย',
          en: 'Wang Noi',
        },
        provinceId: 5,
     },
     {
        id: 85,
        code: '1412',
        text: 'เสนา',
        value: 'เสนา',
        name: {
          th: 'เสนา',
          en: 'S ena',
        },
        provinceId: 5,
     },
     {
        id: 86,
        code: '1413',
        text: 'บางซ้าย',
        value: 'บางซ้าย',
        name: {
          th: 'บางซ้าย',
          en: 'Bang Sai',
        },
        provinceId: 5,
     },
     {
        id: 87,
        code: '1414',
        text: 'อุทัย',
        value: 'อุทัย',
        name: {
          th: 'อุทัย',
          en: 'U thai',
        },
        provinceId: 5,
     },
     {
        id: 88,
        code: '1415',
        text: 'มหาราช',
        value: 'มหาราช',
        name: {
          th: 'มหาราช',
          en: 'Maha Rat',
        },
        provinceId: 5,
     },
     {
        id: 89,
        code: '1416',
        text: 'บ้านแพรก',
        value: 'บ้านแพรก',
        name: {
          th: 'บ้านแพรก',
          en: 'Ban Phraek',
        },
        provinceId: 5,
     },
     {
        id: 90,
        code: '1501',
        text: 'เมืองอ่างทอง',
        value: 'เมืองอ่างทอง',
        name: {
          th: 'เมืองอ่างทอง',
          en: 'Mueang Ang  thong',
        },
        provinceId: 6,
     },
     {
        id: 91,
        code: '1502',
        text: 'ไชโย',
        value: 'ไชโย',
        name: {
          th: 'ไชโย',
          en: 'Chaiyo',
        },
        provinceId: 6,
     },
     {
        id: 92,
        code: '1503',
        text: 'ป่าโมก',
        value: 'ป่าโมก',
        name: {
          th: 'ป่าโมก',
          en: 'Pa Mok',
        },
        provinceId: 6,
     },
     {
        id: 93,
        code: '1504',
        text: 'โพธิ์ทอง',
        value: 'โพธิ์ทอง',
        name: {
          th: 'โพธิ์ทอง',
          en: 'Pho  thong',
        },
        provinceId: 6,
     },
     {
        id: 94,
        code: '1505',
        text: 'แสวงหา',
        value: 'แสวงหา',
        name: {
          th: 'แสวงหา',
          en: 'Sawa eng Ha',
        },
        provinceId: 6,
     },
     {
        id: 95,
        code: '1506',
        text: 'วิเศษชัยชาญ',
        value: 'วิเศษชัยชาญ',
        name: {
          th: 'วิเศษชัยชาญ',
          en: 'Wiset Chai Chan',
        },
        provinceId: 6,
     },
     {
        id: 96,
        code: '1507',
        text: 'สามโก้',
        value: 'สามโก้',
        name: {
          th: 'สามโก้',
          en: 'Samko',
        },
        provinceId: 6,
     },
     {
        id: 97,
        code: '1601',
        text: 'เมืองลพบุรี',
        value: 'เมืองลพบุรี',
        name: {
          th: 'เมืองลพบุรี',
          en: 'Mueang Lop Buri',
        },
        provinceId: 7,
     },
     {
        id: 98,
        code: '1602',
        text: 'พัฒนานิคม',
        value: 'พัฒนานิคม',
        name: {
          th: 'พัฒนานิคม',
          en: 'Phat thana Nikhom',
        },
        provinceId: 7,
     },
     {
        id: 99,
        code: '1603',
        text: 'โคกสำโรง',
        value: 'โคกสำโรง',
        name: {
          th: 'โคกสำโรง',
          en: 'Khok Samrong',
        },
        provinceId: 7,
     },
     {
        id: 100,
        code: '1604',
        text: 'ชัยบาดาล',
        value: 'ชัยบาดาล',
        name: {
          th: 'ชัยบาดาล',
          en: 'Chai Badan',
        },
        provinceId: 7,
     },
     {
        id: 101,
        code: '1605',
        text: 'ท่าวุ้ง',
        value: 'ท่าวุ้ง',
        name: {
          th: 'ท่าวุ้ง',
          en: ' tha Wung',
        },
        provinceId: 7,
     },
     {
        id: 102,
        code: '1606',
        text: 'บ้านหมี่',
        value: 'บ้านหมี่',
        name: {
          th: 'บ้านหมี่',
          en: 'Ban Mi',
        },
        provinceId: 7,
     },
     {
        id: 103,
        code: '1607',
        text: 'ท่าหลวง',
        value: 'ท่าหลวง',
        name: {
          th: 'ท่าหลวง',
          en: ' tha Luang',
        },
        provinceId: 7,
     },
     {
        id: 104,
        code: '1608',
        text: 'สระโบสถ์',
        value: 'สระโบสถ์',
        name: {
          th: 'สระโบสถ์',
          en: 'Sa Bot',
        },
        provinceId: 7,
     },
     {
        id: 105,
        code: '1609',
        text: 'โคกเจริญ',
        value: 'โคกเจริญ',
        name: {
          th: 'โคกเจริญ',
          en: 'Khok Charo en',
        },
        provinceId: 7,
     },
     {
        id: 106,
        code: '1610',
        text: 'ลำสนธิ',
        value: 'ลำสนธิ',
        name: {
          th: 'ลำสนธิ',
          en: 'Lam Son thi',
        },
        provinceId: 7,
     },
     {
        id: 107,
        code: '1611',
        text: 'หนองม่วง',
        value: 'หนองม่วง',
        name: {
          th: 'หนองม่วง',
          en: 'Nong Muang',
        },
        provinceId: 7,
     },
     {
        id: 108,
        code: '1681',
        text: 'อ.บ้านเช่า  จ.ลพบุรี',
        value: 'อ.บ้านเช่า  จ.ลพบุรี',
        name: {
          th: 'อ.บ้านเช่า  จ.ลพบุรี',
          en: 'Amphoe Ban Chao',
        },
        provinceId: 7,
     },
     {
        id: 109,
        code: '1701',
        text: 'เมืองสิงห์บุรี',
        value: 'เมืองสิงห์บุรี',
        name: {
          th: 'เมืองสิงห์บุรี',
          en: 'Mueang Sing Buri',
        },
        provinceId: 8,
     },
     {
        id: 110,
        code: '1702',
        text: 'บางระจัน',
        value: 'บางระจัน',
        name: {
          th: 'บางระจัน',
          en: 'Bang Rachan',
        },
        provinceId: 8,
     },
     {
        id: 111,
        code: '1703',
        text: 'ค่ายบางระจัน',
        value: 'ค่ายบางระจัน',
        name: {
          th: 'ค่ายบางระจัน',
          en: 'Khai Bang Rachan',
        },
        provinceId: 8,
     },
     {
        id: 112,
        code: '1704',
        text: 'พรหมบุรี',
        value: 'พรหมบุรี',
        name: {
          th: 'พรหมบุรี',
          en: 'Phrom Buri',
        },
        provinceId: 8,
     },
     {
        id: 113,
        code: '1705',
        text: 'ท่าช้าง',
        value: 'ท่าช้าง',
        name: {
          th: 'ท่าช้าง',
          en: ' tha Chang',
        },
        provinceId: 8,
     },
     {
        id: 114,
        code: '1706',
        text: 'อินทร์บุรี',
        value: 'อินทร์บุรี',
        name: {
          th: 'อินทร์บุรี',
          en: 'In Buri',
        },
        provinceId: 8,
     },
     {
        id: 115,
        code: '1801',
        text: 'เมืองชัยนาท',
        value: 'เมืองชัยนาท',
        name: {
          th: 'เมืองชัยนาท',
          en: 'Mueang Chai Nat',
        },
        provinceId: 9,
     },
     {
        id: 116,
        code: '1802',
        text: 'มโนรมย์',
        value: 'มโนรมย์',
        name: {
          th: 'มโนรมย์',
          en: 'Manorom',
        },
        provinceId: 9,
     },
     {
        id: 117,
        code: '1803',
        text: 'วัดสิงห์',
        value: 'วัดสิงห์',
        name: {
          th: 'วัดสิงห์',
          en: 'Wat Sing',
        },
        provinceId: 9,
     },
     {
        id: 118,
        code: '1804',
        text: 'สรรพยา',
        value: 'สรรพยา',
        name: {
          th: 'สรรพยา',
          en: 'Sapphaya',
        },
        provinceId: 9,
     },
     {
        id: 119,
        code: '1805',
        text: 'สรรคบุรี',
        value: 'สรรคบุรี',
        name: {
          th: 'สรรคบุรี',
          en: 'Sankhaburi',
        },
        provinceId: 9,
     },
     {
        id: 120,
        code: '1806',
        text: 'หันคา',
        value: 'หันคา',
        name: {
          th: 'หันคา',
          en: 'Hankha',
        },
        provinceId: 9,
     },
     {
        id: 121,
        code: '1807',
        text: 'หนองมะโมง',
        value: 'หนองมะโมง',
        name: {
          th: 'หนองมะโมง',
          en: 'Nong Mamong',
        },
        provinceId: 9,
     },
     {
        id: 122,
        code: '1808',
        text: 'เนินขาม',
        value: 'เนินขาม',
        name: {
          th: 'เนินขาม',
          en: 'No en Kham',
        },
        provinceId: 9,
     },
     {
        id: 123,
        code: '1901',
        text: 'เมืองสระบุรี',
        value: 'เมืองสระบุรี',
        name: {
          th: 'เมืองสระบุรี',
          en: 'Mueang Saraburi',
        },
        provinceId: 10,
     },
     {
        id: 124,
        code: '1902',
        text: 'แก่งคอย',
        value: 'แก่งคอย',
        name: {
          th: 'แก่งคอย',
          en: 'Ka eng Khoi',
        },
        provinceId: 10,
     },
     {
        id: 125,
        code: '1903',
        text: 'หนองแค',
        value: 'หนองแค',
        name: {
          th: 'หนองแค',
          en: 'Nong Khae',
        },
        provinceId: 10,
     },
     {
        id: 126,
        code: '1904',
        text: 'วิหารแดง',
        value: 'วิหารแดง',
        name: {
          th: 'วิหารแดง',
          en: 'Wihan Da eng',
        },
        provinceId: 10,
     },
     {
        id: 127,
        code: '1905',
        text: 'หนองแซง',
        value: 'หนองแซง',
        name: {
          th: 'หนองแซง',
          en: 'Nong Sa eng',
        },
        provinceId: 10,
     },
     {
        id: 128,
        code: '1906',
        text: 'บ้านหมอ',
        value: 'บ้านหมอ',
        name: {
          th: 'บ้านหมอ',
          en: 'Ban Mo',
        },
        provinceId: 10,
     },
     {
        id: 129,
        code: '1907',
        text: 'ดอนพุด',
        value: 'ดอนพุด',
        name: {
          th: 'ดอนพุด',
          en: 'Don Phut',
        },
        provinceId: 10,
     },
     {
        id: 130,
        code: '1908',
        text: 'หนองโดน',
        value: 'หนองโดน',
        name: {
          th: 'หนองโดน',
          en: 'Nong Don',
        },
        provinceId: 10,
     },
     {
        id: 131,
        code: '1909',
        text: 'พระพุทธบาท',
        value: 'พระพุทธบาท',
        name: {
          th: 'พระพุทธบาท',
          en: 'Phra Phut thabat',
        },
        provinceId: 10,
     },
     {
        id: 132,
        code: '1910',
        text: 'เสาไห้',
        value: 'เสาไห้',
        name: {
          th: 'เสาไห้',
          en: 'Sao Hai',
        },
        provinceId: 10,
     },
     {
        id: 133,
        code: '1911',
        text: 'มวกเหล็ก',
        value: 'มวกเหล็ก',
        name: {
          th: 'มวกเหล็ก',
          en: 'Muak Lek',
        },
        provinceId: 10,
     },
     {
        id: 134,
        code: '1912',
        text: 'วังม่วง',
        value: 'วังม่วง',
        name: {
          th: 'วังม่วง',
          en: 'Wang Muang',
        },
        provinceId: 10,
     },
     {
        id: 135,
        code: '1913',
        text: 'เฉลิมพระเกียรติ',
        value: 'เฉลิมพระเกียรติ',
        name: {
          th: 'เฉลิมพระเกียรติ',
          en: 'Chaloem Phra Kiat',
        },
        provinceId: 10,
     },
     {
        id: 136,
        code: '2001',
        text: 'เมืองชลบุรี',
        value: 'เมืองชลบุรี',
        name: {
          th: 'เมืองชลบุรี',
          en: 'Mueang Chon Buri',
        },
        provinceId: 11,
     },
     {
        id: 137,
        code: '2002',
        text: 'บ้านบึง',
        value: 'บ้านบึง',
        name: {
          th: 'บ้านบึง',
          en: 'Ban Bu eng',
        },
        provinceId: 11,
     },
     {
        id: 138,
        code: '2003',
        text: 'หนองใหญ่',
        value: 'หนองใหญ่',
        name: {
          th: 'หนองใหญ่',
          en: 'Nong Yai',
        },
        provinceId: 11,
     },
     {
        id: 139,
        code: '2004',
        text: 'บางละมุง',
        value: 'บางละมุง',
        name: {
          th: 'บางละมุง',
          en: 'Bang Lamung',
        },
        provinceId: 11,
     },
     {
        id: 140,
        code: '2005',
        text: 'พานทอง',
        value: 'พานทอง',
        name: {
          th: 'พานทอง',
          en: 'Phan  thong',
        },
        provinceId: 11,
     },
     {
        id: 141,
        code: '2006',
        text: 'พนัสนิคม',
        value: 'พนัสนิคม',
        name: {
          th: 'พนัสนิคม',
          en: 'Phanat Nikhom',
        },
        provinceId: 11,
     },
     {
        id: 142,
        code: '2007',
        text: 'ศรีราชา',
        value: 'ศรีราชา',
        name: {
          th: 'ศรีราชา',
          en: 'Si Racha',
        },
        provinceId: 11,
     },
     {
        id: 143,
        code: '2008',
        text: 'เกาะสีชัง',
        value: 'เกาะสีชัง',
        name: {
          th: 'เกาะสีชัง',
          en: 'Ko Sichang',
        },
        provinceId: 11,
     },
     {
        id: 144,
        code: '2009',
        text: 'สัตหีบ',
        value: 'สัตหีบ',
        name: {
          th: 'สัตหีบ',
          en: 'Sattahip',
        },
        provinceId: 11,
     },
     {
        id: 145,
        code: '2010',
        text: 'บ่อทอง',
        value: 'บ่อทอง',
        name: {
          th: 'บ่อทอง',
          en: 'Bo  thong',
        },
        provinceId: 11,
     },
     {
        id: 146,
        code: '2011',
        text: 'เกาะจันทร์',
        value: 'เกาะจันทร์',
        name: {
          th: 'เกาะจันทร์',
          en: 'Ko Chan',
        },
        provinceId: 11,
     },
     {
        id: 147,
        code: '2051',
        text: 'สัตหีบ (สาขาตำบลบางเสร่)',
        value: 'สัตหีบ (สาขาตำบลบางเสร่)',
        name: {
          th: 'สัตหีบ (สาขาตำบลบางเสร่)',
          en: 'Sattahip(Bang Sre)',
        },
        provinceId: 11,
     },
     {
        id: 148,
        code: '2072',
        text: 'ท้องถิ่นเทศบาลเมืองหนองปรือ',
        value: 'ท้องถิ่นเทศบาลเมืองหนองปรือ',
        name: {
          th: 'ท้องถิ่นเทศบาลเมืองหนองปรือ',
          en: 'Tong Tin Tetsaban Mueang Nong Prue',
        },
        provinceId: 11,
     },
     {
        id: 149,
        code: '2093',
        text: 'เทศบาลตำบลแหลมฉบัง',
        value: 'เทศบาลตำบลแหลมฉบัง',
        name: {
          th: 'เทศบาลตำบลแหลมฉบัง',
          en: 'Tetsaban Tambon Lamsabang',
        },
        provinceId: 11,
     },
     {
        id: 150,
        code: '2099',
        text: 'เทศบาลเมืองชลบุรี',
        value: 'เทศบาลเมืองชลบุรี',
        name: {
          th: 'เทศบาลเมืองชลบุรี',
          en: 'Mueang Chon Buri',
        },
        provinceId: 11,
     },
     {
        id: 151,
        code: '2101',
        text: 'เมืองระยอง',
        value: 'เมืองระยอง',
        name: {
          th: 'เมืองระยอง',
          en: 'Mueang Rayong',
        },
        provinceId: 12,
     },
     {
        id: 152,
        code: '2102',
        text: 'บ้านฉาง',
        value: 'บ้านฉาง',
        name: {
          th: 'บ้านฉาง',
          en: 'Ban Chang',
        },
        provinceId: 12,
     },
     {
        id: 153,
        code: '2103',
        text: 'แกลง',
        value: 'แกลง',
        name: {
          th: 'แกลง',
          en: 'Kla eng',
        },
        provinceId: 12,
     },
     {
        id: 154,
        code: '2104',
        text: 'วังจันทร์',
        value: 'วังจันทร์',
        name: {
          th: 'วังจันทร์',
          en: 'Wang Chan',
        },
        provinceId: 12,
     },
     {
        id: 155,
        code: '2105',
        text: 'บ้านค่าย',
        value: 'บ้านค่าย',
        name: {
          th: 'บ้านค่าย',
          en: 'Ban Khai',
        },
        provinceId: 12,
     },
     {
        id: 156,
        code: '2106',
        text: 'ปลวกแดง',
        value: 'ปลวกแดง',
        name: {
          th: 'ปลวกแดง',
          en: 'Pluak Da eng',
        },
        provinceId: 12,
     },
     {
        id: 157,
        code: '2107',
        text: 'เขาชะเมา',
        value: 'เขาชะเมา',
        name: {
          th: 'เขาชะเมา',
          en: 'Khao Chamao',
        },
        provinceId: 12,
     },
     {
        id: 158,
        code: '2108',
        text: 'นิคมพัฒนา',
        value: 'นิคมพัฒนา',
        name: {
          th: 'นิคมพัฒนา',
          en: 'Nikhom Phat thana',
        },
        provinceId: 12,
     },
     {
        id: 159,
        code: '2151',
        text: 'สาขาตำบลมาบข่า',
        value: 'สาขาตำบลมาบข่า',
        name: {
          th: 'สาขาตำบลมาบข่า',
          en: 'Saka Tambon Mabka',
        },
        provinceId: 12,
     },
     {
        id: 160,
        code: '2201',
        text: 'เมืองจันทบุรี',
        value: 'เมืองจันทบุรี',
        name: {
          th: 'เมืองจันทบุรี',
          en: 'Mueang Chan thaburi',
        },
        provinceId: 13,
     },
     {
        id: 161,
        code: '2202',
        text: 'ขลุง',
        value: 'ขลุง',
        name: {
          th: 'ขลุง',
          en: 'Khlung',
        },
        provinceId: 13,
     },
     {
        id: 162,
        code: '2203',
        text: 'ท่าใหม่',
        value: 'ท่าใหม่',
        name: {
          th: 'ท่าใหม่',
          en: ' tha Mai',
        },
        provinceId: 13,
     },
     {
        id: 163,
        code: '2204',
        text: 'โป่งน้ำร้อน',
        value: 'โป่งน้ำร้อน',
        name: {
          th: 'โป่งน้ำร้อน',
          en: 'Pong Nam Ron',
        },
        provinceId: 13,
     },
     {
        id: 164,
        code: '2205',
        text: 'มะขาม',
        value: 'มะขาม',
        name: {
          th: 'มะขาม',
          en: 'Makham',
        },
        provinceId: 13,
     },
     {
        id: 165,
        code: '2206',
        text: 'แหลมสิงห์',
        value: 'แหลมสิงห์',
        name: {
          th: 'แหลมสิงห์',
          en: 'Laem Sing',
        },
        provinceId: 13,
     },
     {
        id: 166,
        code: '2207',
        text: 'สอยดาว',
        value: 'สอยดาว',
        name: {
          th: 'สอยดาว',
          en: 'Soi Dao',
        },
        provinceId: 13,
     },
     {
        id: 167,
        code: '2208',
        text: 'แก่งหางแมว',
        value: 'แก่งหางแมว',
        name: {
          th: 'แก่งหางแมว',
          en: 'Ka eng Hang Maeo',
        },
        provinceId: 13,
     },
     {
        id: 168,
        code: '2209',
        text: 'นายายอาม',
        value: 'นายายอาม',
        name: {
          th: 'นายายอาม',
          en: 'Na Yai Am',
        },
        provinceId: 13,
     },
     {
        id: 169,
        code: '2210',
        text: 'เขาคิชฌกูฏ',
        value: 'เขาคิชฌกูฏ',
        name: {
          th: 'เขาคิชฌกูฏ',
          en: 'Khoa Khitchakut',
        },
        provinceId: 13,
     },
     {
        id: 170,
        code: '2281',
        text: 'กิ่ง อ.กำพุธ  จ.จันทบุรี',
        value: 'กิ่ง อ.กำพุธ  จ.จันทบุรี',
        name: {
          th: 'กิ่ง อ.กำพุธ  จ.จันทบุรี',
          en: 'King Amphoe Kampud',
        },
        provinceId: 13,
     },
     {
        id: 171,
        code: '2301',
        text: 'เมืองตราด',
        value: 'เมืองตราด',
        name: {
          th: 'เมืองตราด',
          en: 'Mueang Trat',
        },
        provinceId: 14,
     },
     {
        id: 172,
        code: '2302',
        text: 'คลองใหญ่',
        value: 'คลองใหญ่',
        name: {
          th: 'คลองใหญ่',
          en: 'Khlong Yai',
        },
        provinceId: 14,
     },
     {
        id: 173,
        code: '2303',
        text: 'เขาสมิง',
        value: 'เขาสมิง',
        name: {
          th: 'เขาสมิง',
          en: 'Khao Saming',
        },
        provinceId: 14,
     },
     {
        id: 174,
        code: '2304',
        text: 'บ่อไร่',
        value: 'บ่อไร่',
        name: {
          th: 'บ่อไร่',
          en: 'Bo Rai',
        },
        provinceId: 14,
     },
     {
        id: 175,
        code: '2305',
        text: 'แหลมงอบ',
        value: 'แหลมงอบ',
        name: {
          th: 'แหลมงอบ',
          en: 'Laem Ngop',
        },
        provinceId: 14,
     },
     {
        id: 176,
        code: '2306',
        text: 'เกาะกูด',
        value: 'เกาะกูด',
        name: {
          th: 'เกาะกูด',
          en: 'Ko Kut',
        },
        provinceId: 14,
     },
     {
        id: 177,
        code: '2307',
        text: 'เกาะช้าง',
        value: 'เกาะช้าง',
        name: {
          th: 'เกาะช้าง',
          en: 'Ko Chang',
        },
        provinceId: 14,
     },
     {
        id: 178,
        code: '2401',
        text: 'เมืองฉะเชิงเทรา',
        value: 'เมืองฉะเชิงเทรา',
        name: {
          th: 'เมืองฉะเชิงเทรา',
          en: 'Mueang Chacho engsao',
        },
        provinceId: 15,
     },
     {
        id: 179,
        code: '2402',
        text: 'บางคล้า',
        value: 'บางคล้า',
        name: {
          th: 'บางคล้า',
          en: 'Bang Khla',
        },
        provinceId: 15,
     },
     {
        id: 180,
        code: '2403',
        text: 'บางน้ำเปรี้ยว',
        value: 'บางน้ำเปรี้ยว',
        name: {
          th: 'บางน้ำเปรี้ยว',
          en: 'Bang Nam Priao',
        },
        provinceId: 15,
     },
     {
        id: 181,
        code: '2404',
        text: 'บางปะกง',
        value: 'บางปะกง',
        name: {
          th: 'บางปะกง',
          en: 'Bang Pakong',
        },
        provinceId: 15,
     },
     {
        id: 182,
        code: '2405',
        text: 'บ้านโพธิ์',
        value: 'บ้านโพธิ์',
        name: {
          th: 'บ้านโพธิ์',
          en: 'Ban Pho',
        },
        provinceId: 15,
     },
     {
        id: 183,
        code: '2406',
        text: 'พนมสารคาม',
        value: 'พนมสารคาม',
        name: {
          th: 'พนมสารคาม',
          en: 'Phanom Sarakham',
        },
        provinceId: 15,
     },
     {
        id: 184,
        code: '2407',
        text: 'ราชสาส์น',
        value: 'ราชสาส์น',
        name: {
          th: 'ราชสาส์น',
          en: 'Ratchasan',
        },
        provinceId: 15,
     },
     {
        id: 185,
        code: '2408',
        text: 'สนามชัย',
        value: 'สนามชัย',
        name: {
          th: 'สนามชัย',
          en: 'Sanam Chai Khet',
        },
        provinceId: 15,
     },
     {
        id: 186,
        code: '2409',
        text: 'แปลงยาว',
        value: 'แปลงยาว',
        name: {
          th: 'แปลงยาว',
          en: 'Pla eng Yao',
        },
        provinceId: 15,
     },
     {
        id: 187,
        code: '2410',
        text: 'ท่าตะเกียบ',
        value: 'ท่าตะเกียบ',
        name: {
          th: 'ท่าตะเกียบ',
          en: ' tha Takiap',
        },
        provinceId: 15,
     },
     {
        id: 188,
        code: '2411',
        text: 'คลองเขื่อน',
        value: 'คลองเขื่อน',
        name: {
          th: 'คลองเขื่อน',
          en: 'Khlong Khuean',
        },
        provinceId: 15,
     },
     {
        id: 189,
        code: '2501',
        text: 'เมืองปราจีนบุรี',
        value: 'เมืองปราจีนบุรี',
        name: {
          th: 'เมืองปราจีนบุรี',
          en: 'Mueang Prachin Buri',
        },
        provinceId: 16,
     },
     {
        id: 190,
        code: '2502',
        text: 'กบินทร์บุรี',
        value: 'กบินทร์บุรี',
        name: {
          th: 'กบินทร์บุรี',
          en: 'Kabin Buri',
        },
        provinceId: 16,
     },
     {
        id: 191,
        code: '2503',
        text: 'นาดี',
        value: 'นาดี',
        name: {
          th: 'นาดี',
          en: 'Na Di',
        },
        provinceId: 16,
     },
     {
        id: 192,
        code: '2504',
        text: 'สระแก้ว',
        value: 'สระแก้ว',
        name: {
          th: 'สระแก้ว',
          en: 'Sa Kaeo',
        },
        provinceId: 16,
     },
     {
        id: 193,
        code: '2505',
        text: 'วังน้ำเย็น',
        value: 'วังน้ำเย็น',
        name: {
          th: 'วังน้ำเย็น',
          en: 'Wang Nam Y en',
        },
        provinceId: 16,
     },
     {
        id: 194,
        code: '2506',
        text: 'บ้านสร้าง',
        value: 'บ้านสร้าง',
        name: {
          th: 'บ้านสร้าง',
          en: 'Ban Sang',
        },
        provinceId: 16,
     },
     {
        id: 195,
        code: '2507',
        text: 'ประจันตคาม',
        value: 'ประจันตคาม',
        name: {
          th: 'ประจันตคาม',
          en: 'Prachantakham',
        },
        provinceId: 16,
     },
     {
        id: 196,
        code: '2508',
        text: 'ศรีมหาโพธิ',
        value: 'ศรีมหาโพธิ',
        name: {
          th: 'ศรีมหาโพธิ',
          en: 'Si Maha Phot',
        },
        provinceId: 16,
     },
     {
        id: 197,
        code: '2509',
        text: 'ศรีมโหสถ',
        value: 'ศรีมโหสถ',
        name: {
          th: 'ศรีมโหสถ',
          en: 'Si Mahosot',
        },
        provinceId: 16,
     },
     {
        id: 198,
        code: '2510',
        text: 'อรัญประเทศ',
        value: 'อรัญประเทศ',
        name: {
          th: 'อรัญประเทศ',
          en: 'Aranyapra thet',
        },
        provinceId: 16,
     },
     {
        id: 199,
        code: '2511',
        text: 'ตาพระยา',
        value: 'ตาพระยา',
        name: {
          th: 'ตาพระยา',
          en: 'Ta Phraya',
        },
        provinceId: 16,
     },
     {
        id: 200,
        code: '2512',
        text: 'วัฒนานคร',
        value: 'วัฒนานคร',
        name: {
          th: 'วัฒนานคร',
          en: 'Wat thana Nakhon',
        },
        provinceId: 16,
     },
     {
        id: 201,
        code: '2513',
        text: 'คลองหาด',
        value: 'คลองหาด',
        name: {
          th: 'คลองหาด',
          en: 'Khlong Hat',
        },
        provinceId: 16,
     },
     {
        id: 202,
        code: '2601',
        text: 'เมืองนครนายก',
        value: 'เมืองนครนายก',
        name: {
          th: 'เมืองนครนายก',
          en: 'Mueang Nakhon Nayok',
        },
        provinceId: 17,
     },
     {
        id: 203,
        code: '2602',
        text: 'ปากพลี',
        value: 'ปากพลี',
        name: {
          th: 'ปากพลี',
          en: 'Pak Phli',
        },
        provinceId: 17,
     },
     {
        id: 204,
        code: '2603',
        text: 'บ้านนา',
        value: 'บ้านนา',
        name: {
          th: 'บ้านนา',
          en: 'Ban Na',
        },
        provinceId: 17,
     },
     {
        id: 205,
        code: '2604',
        text: 'องครักษ์',
        value: 'องครักษ์',
        name: {
          th: 'องครักษ์',
          en: 'Ongkharak',
        },
        provinceId: 17,
     },
     {
        id: 206,
        code: '2701',
        text: 'เมืองสระแก้ว',
        value: 'เมืองสระแก้ว',
        name: {
          th: 'เมืองสระแก้ว',
          en: 'Mueang Sa Kaeo',
        },
        provinceId: 18,
     },
     {
        id: 207,
        code: '2702',
        text: 'คลองหาด',
        value: 'คลองหาด',
        name: {
          th: 'คลองหาด',
          en: 'Khlong Hat',
        },
        provinceId: 18,
     },
     {
        id: 208,
        code: '2703',
        text: 'ตาพระยา',
        value: 'ตาพระยา',
        name: {
          th: 'ตาพระยา',
          en: 'Ta Phraya',
        },
        provinceId: 18,
     },
     {
        id: 209,
        code: '2704',
        text: 'วังน้ำเย็น',
        value: 'วังน้ำเย็น',
        name: {
          th: 'วังน้ำเย็น',
          en: 'Wang Nam Y en',
        },
        provinceId: 18,
     },
     {
        id: 210,
        code: '2705',
        text: 'วัฒนานคร',
        value: 'วัฒนานคร',
        name: {
          th: 'วัฒนานคร',
          en: 'Wat thana Nakhon',
        },
        provinceId: 18,
     },
     {
        id: 211,
        code: '2706',
        text: 'อรัญประเทศ',
        value: 'อรัญประเทศ',
        name: {
          th: 'อรัญประเทศ',
          en: 'Aranyapra thet',
        },
        provinceId: 18,
     },
     {
        id: 212,
        code: '2707',
        text: 'เขาฉกรรจ์',
        value: 'เขาฉกรรจ์',
        name: {
          th: 'เขาฉกรรจ์',
          en: 'Khao Chakan',
        },
        provinceId: 18,
     },
     {
        id: 213,
        code: '2708',
        text: 'โคกสูง',
        value: 'โคกสูง',
        name: {
          th: 'โคกสูง',
          en: 'Khok Sung',
        },
        provinceId: 18,
     },
     {
        id: 214,
        code: '2709',
        text: 'วังสมบูรณ์',
        value: 'วังสมบูรณ์',
        name: {
          th: 'วังสมบูรณ์',
          en: 'Wang Sombun',
        },
        provinceId: 18,
     },
     {
        id: 215,
        code: '3001',
        text: 'เมืองนครราชสีมา',
        value: 'เมืองนครราชสีมา',
        name: {
          th: 'เมืองนครราชสีมา',
          en: 'Mueang Nakhon Ratchasima',
        },
        provinceId: 19,
     },
     {
        id: 216,
        code: '3002',
        text: 'ครบุรี',
        value: 'ครบุรี',
        name: {
          th: 'ครบุรี',
          en: 'Khon Buri',
        },
        provinceId: 19,
     },
     {
        id: 217,
        code: '3003',
        text: 'เสิงสาง',
        value: 'เสิงสาง',
        name: {
          th: 'เสิงสาง',
          en: 'So eng Sang',
        },
        provinceId: 19,
     },
     {
        id: 218,
        code: '3004',
        text: 'คง',
        value: 'คง',
        name: {
          th: 'คง',
          en: 'Khong',
        },
        provinceId: 19,
     },
     {
        id: 219,
        code: '3005',
        text: 'บ้านเหลื่อม',
        value: 'บ้านเหลื่อม',
        name: {
          th: 'บ้านเหลื่อม',
          en: 'Ban Lueam',
        },
        provinceId: 19,
     },
     {
        id: 220,
        code: '3006',
        text: 'จักราช',
        value: 'จักราช',
        name: {
          th: 'จักราช',
          en: 'Chakkarat',
        },
        provinceId: 19,
     },
     {
        id: 221,
        code: '3007',
        text: 'โชคชัย',
        value: 'โชคชัย',
        name: {
          th: 'โชคชัย',
          en: 'Chok Chai',
        },
        provinceId: 19,
     },
     {
        id: 222,
        code: '3008',
        text: 'ด่านขุนทด',
        value: 'ด่านขุนทด',
        name: {
          th: 'ด่านขุนทด',
          en: 'Dan Khun  thot',
        },
        provinceId: 19,
     },
     {
        id: 223,
        code: '3009',
        text: 'โนนไทย',
        value: 'โนนไทย',
        name: {
          th: 'โนนไทย',
          en: 'Non  thai',
        },
        provinceId: 19,
     },
     {
        id: 224,
        code: '3010',
        text: 'โนนสูง',
        value: 'โนนสูง',
        name: {
          th: 'โนนสูง',
          en: 'Non Sung',
        },
        provinceId: 19,
     },
     {
        id: 225,
        code: '3011',
        text: 'ขามสะแกแสง',
        value: 'ขามสะแกแสง',
        name: {
          th: 'ขามสะแกแสง',
          en: 'Kham Sakaesa eng',
        },
        provinceId: 19,
     },
     {
        id: 226,
        code: '3012',
        text: 'บัวใหญ่',
        value: 'บัวใหญ่',
        name: {
          th: 'บัวใหญ่',
          en: 'Bua Yai',
        },
        provinceId: 19,
     },
     {
        id: 227,
        code: '3013',
        text: 'ประทาย',
        value: 'ประทาย',
        name: {
          th: 'ประทาย',
          en: 'Pra thai',
        },
        provinceId: 19,
     },
     {
        id: 228,
        code: '3014',
        text: 'ปักธงชัย',
        value: 'ปักธงชัย',
        name: {
          th: 'ปักธงชัย',
          en: 'Pak  thong Chai',
        },
        provinceId: 19,
     },
     {
        id: 229,
        code: '3015',
        text: 'พิมาย',
        value: 'พิมาย',
        name: {
          th: 'พิมาย',
          en: 'Phimai',
        },
        provinceId: 19,
     },
     {
        id: 230,
        code: '3016',
        text: 'ห้วยแถลง',
        value: 'ห้วยแถลง',
        name: {
          th: 'ห้วยแถลง',
          en: 'Huai  thala eng',
        },
        provinceId: 19,
     },
     {
        id: 231,
        code: '3017',
        text: 'ชุมพวง',
        value: 'ชุมพวง',
        name: {
          th: 'ชุมพวง',
          en: 'Chum Phuang',
        },
        provinceId: 19,
     },
     {
        id: 232,
        code: '3018',
        text: 'สูงเนิน',
        value: 'สูงเนิน',
        name: {
          th: 'สูงเนิน',
          en: 'Sung No en',
        },
        provinceId: 19,
     },
     {
        id: 233,
        code: '3019',
        text: 'ขามทะเลสอ',
        value: 'ขามทะเลสอ',
        name: {
          th: 'ขามทะเลสอ',
          en: 'Kham  thale So',
        },
        provinceId: 19,
     },
     {
        id: 234,
        code: '3020',
        text: 'สีคิ้ว',
        value: 'สีคิ้ว',
        name: {
          th: 'สีคิ้ว',
          en: 'Sikhio',
        },
        provinceId: 19,
     },
     {
        id: 235,
        code: '3021',
        text: 'ปากช่อง',
        value: 'ปากช่อง',
        name: {
          th: 'ปากช่อง',
          en: 'Pak Chong',
        },
        provinceId: 19,
     },
     {
        id: 236,
        code: '3022',
        text: 'หนองบุญมาก',
        value: 'หนองบุญมาก',
        name: {
          th: 'หนองบุญมาก',
          en: 'Nong Bunnak',
        },
        provinceId: 19,
     },
     {
        id: 237,
        code: '3023',
        text: 'แก้งสนามนาง',
        value: 'แก้งสนามนาง',
        name: {
          th: 'แก้งสนามนาง',
          en: 'Ka eng Sanam Nang',
        },
        provinceId: 19,
     },
     {
        id: 238,
        code: '3024',
        text: 'โนนแดง',
        value: 'โนนแดง',
        name: {
          th: 'โนนแดง',
          en: 'Non Da eng',
        },
        provinceId: 19,
     },
     {
        id: 239,
        code: '3025',
        text: 'วังน้ำเขียว',
        value: 'วังน้ำเขียว',
        name: {
          th: 'วังน้ำเขียว',
          en: 'Wang Nam Khiao',
        },
        provinceId: 19,
     },
     {
        id: 240,
        code: '3026',
        text: 'เทพารักษ์',
        value: 'เทพารักษ์',
        name: {
          th: 'เทพารักษ์',
          en: ' thepharak',
        },
        provinceId: 19,
     },
     {
        id: 241,
        code: '3027',
        text: 'เมืองยาง',
        value: 'เมืองยาง',
        name: {
          th: 'เมืองยาง',
          en: 'Mueang Yang',
        },
        provinceId: 19,
     },
     {
        id: 242,
        code: '3028',
        text: 'พระทองคำ',
        value: 'พระทองคำ',
        name: {
          th: 'พระทองคำ',
          en: 'Phra  thong Kham',
        },
        provinceId: 19,
     },
     {
        id: 243,
        code: '3029',
        text: 'ลำทะเมนชัย',
        value: 'ลำทะเมนชัย',
        name: {
          th: 'ลำทะเมนชัย',
          en: 'Lam  tham enchai',
        },
        provinceId: 19,
     },
     {
        id: 244,
        code: '3030',
        text: 'บัวลาย',
        value: 'บัวลาย',
        name: {
          th: 'บัวลาย',
          en: 'Bua Lai',
        },
        provinceId: 19,
     },
     {
        id: 245,
        code: '3031',
        text: 'สีดา',
        value: 'สีดา',
        name: {
          th: 'สีดา',
          en: 'Sida',
        },
        provinceId: 19,
     },
     {
        id: 246,
        code: '3032',
        text: 'เฉลิมพระเกียรติ',
        value: 'เฉลิมพระเกียรติ',
        name: {
          th: 'เฉลิมพระเกียรติ',
          en: 'Chaloem Phra Kiat',
        },
        provinceId: 19,
     },
     {
        id: 247,
        code: '3049',
        text: 'ท้องถิ่นเทศบาลตำบลโพธิ์กลาง',
        value: 'ท้องถิ่นเทศบาลตำบลโพธิ์กลาง',
        name: {
          th: 'ท้องถิ่นเทศบาลตำบลโพธิ์กลาง',
          en: 'Pho Krang',
        },
        provinceId: 19,
     },
     {
        id: 248,
        code: '3051',
        text: 'สาขาตำบลมะค่า-พลสงคราม',
        value: 'สาขาตำบลมะค่า-พลสงคราม',
        name: {
          th: 'สาขาตำบลมะค่า-พลสงคราม',
          en: 'Ma Ka-Pon Songkram',
        },
        provinceId: 19,
     },
     {
        id: 249,
        code: '3081',
        text: 'โนนลาว',
        value: 'โนนลาว',
        name: {
          th: 'โนนลาว',
          en: 'Non Lao',
        },
        provinceId: 19,
     },
     {
        id: 250,
        code: '3101',
        text: 'เมืองบุรีรัมย์',
        value: 'เมืองบุรีรัมย์',
        name: {
          th: 'เมืองบุรีรัมย์',
          en: 'Mueang Buri Ram',
        },
        provinceId: 20,
     },
     {
        id: 251,
        code: '3102',
        text: 'คูเมือง',
        value: 'คูเมือง',
        name: {
          th: 'คูเมือง',
          en: 'Khu Mueang',
        },
        provinceId: 20,
     },
     {
        id: 252,
        code: '3103',
        text: 'กระสัง',
        value: 'กระสัง',
        name: {
          th: 'กระสัง',
          en: 'Krasang',
        },
        provinceId: 20,
     },
     {
        id: 253,
        code: '3104',
        text: 'นางรอง',
        value: 'นางรอง',
        name: {
          th: 'นางรอง',
          en: 'Nang Rong',
        },
        provinceId: 20,
     },
     {
        id: 254,
        code: '3105',
        text: 'หนองกี่',
        value: 'หนองกี่',
        name: {
          th: 'หนองกี่',
          en: 'Nong Ki',
        },
        provinceId: 20,
     },
     {
        id: 255,
        code: '3106',
        text: 'ละหานทราย',
        value: 'ละหานทราย',
        name: {
          th: 'ละหานทราย',
          en: 'Lahan Sai',
        },
        provinceId: 20,
     },
     {
        id: 256,
        code: '3107',
        text: 'ประโคนชัย',
        value: 'ประโคนชัย',
        name: {
          th: 'ประโคนชัย',
          en: 'Prakhon Chai',
        },
        provinceId: 20,
     },
     {
        id: 257,
        code: '3108',
        text: 'บ้านกรวด',
        value: 'บ้านกรวด',
        name: {
          th: 'บ้านกรวด',
          en: 'Ban Kruat',
        },
        provinceId: 20,
     },
     {
        id: 258,
        code: '3109',
        text: 'พุทไธสง',
        value: 'พุทไธสง',
        name: {
          th: 'พุทไธสง',
          en: 'Phut thaisong',
        },
        provinceId: 20,
     },
     {
        id: 259,
        code: '3110',
        text: 'ลำปลายมาศ',
        value: 'ลำปลายมาศ',
        name: {
          th: 'ลำปลายมาศ',
          en: 'Lam Plai Mat',
        },
        provinceId: 20,
     },
     {
        id: 260,
        code: '3111',
        text: 'สตึก',
        value: 'สตึก',
        name: {
          th: 'สตึก',
          en: 'Satuek',
        },
        provinceId: 20,
     },
     {
        id: 261,
        code: '3112',
        text: 'ปะคำ',
        value: 'ปะคำ',
        name: {
          th: 'ปะคำ',
          en: 'Pakham',
        },
        provinceId: 20,
     },
     {
        id: 262,
        code: '3113',
        text: 'นาโพธิ์',
        value: 'นาโพธิ์',
        name: {
          th: 'นาโพธิ์',
          en: 'Na Pho',
        },
        provinceId: 20,
     },
     {
        id: 263,
        code: '3114',
        text: 'หนองหงส์',
        value: 'หนองหงส์',
        name: {
          th: 'หนองหงส์',
          en: 'Nong Hong',
        },
        provinceId: 20,
     },
     {
        id: 264,
        code: '3115',
        text: 'พลับพลาชัย',
        value: 'พลับพลาชัย',
        name: {
          th: 'พลับพลาชัย',
          en: 'Phlapphla Chai',
        },
        provinceId: 20,
     },
     {
        id: 265,
        code: '3116',
        text: 'ห้วยราช',
        value: 'ห้วยราช',
        name: {
          th: 'ห้วยราช',
          en: 'Huai Rat',
        },
        provinceId: 20,
     },
     {
        id: 266,
        code: '3117',
        text: 'โนนสุวรรณ',
        value: 'โนนสุวรรณ',
        name: {
          th: 'โนนสุวรรณ',
          en: 'Non Suwan',
        },
        provinceId: 20,
     },
     {
        id: 267,
        code: '3118',
        text: 'ชำนิ',
        value: 'ชำนิ',
        name: {
          th: 'ชำนิ',
          en: 'Chamni',
        },
        provinceId: 20,
     },
     {
        id: 268,
        code: '3119',
        text: 'บ้านใหม่ไชยพจน์',
        value: 'บ้านใหม่ไชยพจน์',
        name: {
          th: 'บ้านใหม่ไชยพจน์',
          en: 'Ban Mai Chaiyaphot',
        },
        provinceId: 20,
     },
     {
        id: 269,
        code: '3120',
        text: 'โนนดินแดง',
        value: 'โนนดินแดง',
        name: {
          th: 'โนนดินแดง',
          en: 'Din Da eng',
        },
        provinceId: 20,
     },
     {
        id: 270,
        code: '3121',
        text: 'บ้านด่าน',
        value: 'บ้านด่าน',
        name: {
          th: 'บ้านด่าน',
          en: 'Ban Dan',
        },
        provinceId: 20,
     },
     {
        id: 271,
        code: '3122',
        text: 'แคนดง',
        value: 'แคนดง',
        name: {
          th: 'แคนดง',
          en: 'Kha en Dong',
        },
        provinceId: 20,
     },
     {
        id: 272,
        code: '3123',
        text: 'เฉลิมพระเกียรติ',
        value: 'เฉลิมพระเกียรติ',
        name: {
          th: 'เฉลิมพระเกียรติ',
          en: 'Chaloem Phra Kiat',
        },
        provinceId: 20,
     },
     {
        id: 273,
        code: '3201',
        text: 'เมืองสุรินทร์',
        value: 'เมืองสุรินทร์',
        name: {
          th: 'เมืองสุรินทร์',
          en: 'Mueang Surin',
        },
        provinceId: 21,
     },
     {
        id: 274,
        code: '3202',
        text: 'ชุมพลบุรี',
        value: 'ชุมพลบุรี',
        name: {
          th: 'ชุมพลบุรี',
          en: 'Chumphon Buri',
        },
        provinceId: 21,
     },
     {
        id: 275,
        code: '3203',
        text: 'ท่าตูม',
        value: 'ท่าตูม',
        name: {
          th: 'ท่าตูม',
          en: ' tha Tum',
        },
        provinceId: 21,
     },
     {
        id: 276,
        code: '3204',
        text: 'จอมพระ',
        value: 'จอมพระ',
        name: {
          th: 'จอมพระ',
          en: 'Chom Phra',
        },
        provinceId: 21,
     },
     {
        id: 277,
        code: '3205',
        text: 'ปราสาท',
        value: 'ปราสาท',
        name: {
          th: 'ปราสาท',
          en: 'Prasat',
        },
        provinceId: 21,
     },
     {
        id: 278,
        code: '3206',
        text: 'กาบเชิง',
        value: 'กาบเชิง',
        name: {
          th: 'กาบเชิง',
          en: 'Kap Cho eng',
        },
        provinceId: 21,
     },
     {
        id: 279,
        code: '3207',
        text: 'รัตนบุรี',
        value: 'รัตนบุรี',
        name: {
          th: 'รัตนบุรี',
          en: 'Rattanaburi',
        },
        provinceId: 21,
     },
     {
        id: 280,
        code: '3208',
        text: 'สนม',
        value: 'สนม',
        name: {
          th: 'สนม',
          en: 'Sanom',
        },
        provinceId: 21,
     },
     {
        id: 281,
        code: '3209',
        text: 'ศีขรภูมิ',
        value: 'ศีขรภูมิ',
        name: {
          th: 'ศีขรภูมิ',
          en: 'Sikhoraphum',
        },
        provinceId: 21,
     },
     {
        id: 282,
        code: '3210',
        text: 'สังขะ',
        value: 'สังขะ',
        name: {
          th: 'สังขะ',
          en: 'Sangkha',
        },
        provinceId: 21,
     },
     {
        id: 283,
        code: '3211',
        text: 'ลำดวน',
        value: 'ลำดวน',
        name: {
          th: 'ลำดวน',
          en: 'Lamduan',
        },
        provinceId: 21,
     },
     {
        id: 284,
        code: '3212',
        text: 'สำโรงทาบ',
        value: 'สำโรงทาบ',
        name: {
          th: 'สำโรงทาบ',
          en: 'Samrong  thap',
        },
        provinceId: 21,
     },
     {
        id: 285,
        code: '3213',
        text: 'บัวเชด',
        value: 'บัวเชด',
        name: {
          th: 'บัวเชด',
          en: 'Buachet',
        },
        provinceId: 21,
     },
     {
        id: 286,
        code: '3214',
        text: 'พนมดงรัก',
        value: 'พนมดงรัก',
        name: {
          th: 'พนมดงรัก',
          en: 'Phanom Dong Rak',
        },
        provinceId: 21,
     },
     {
        id: 287,
        code: '3215',
        text: 'ศรีณรงค์',
        value: 'ศรีณรงค์',
        name: {
          th: 'ศรีณรงค์',
          en: 'Si Narong',
        },
        provinceId: 21,
     },
     {
        id: 288,
        code: '3216',
        text: 'เขวาสินรินทร์',
        value: 'เขวาสินรินทร์',
        name: {
          th: 'เขวาสินรินทร์',
          en: 'Khwao Sinarin',
        },
        provinceId: 21,
     },
     {
        id: 289,
        code: '3217',
        text: 'โนนนารายณ์',
        value: 'โนนนารายณ์',
        name: {
          th: 'โนนนารายณ์',
          en: 'Non Narai',
        },
        provinceId: 21,
     },
     {
        id: 290,
        code: '3301',
        text: 'เมืองศรีสะเกษ',
        value: 'เมืองศรีสะเกษ',
        name: {
          th: 'เมืองศรีสะเกษ',
          en: 'Mueang Si Sa Ket',
        },
        provinceId: 22,
     },
     {
        id: 291,
        code: '3302',
        text: 'ยางชุมน้อย',
        value: 'ยางชุมน้อย',
        name: {
          th: 'ยางชุมน้อย',
          en: 'Yang Chum Noi',
        },
        provinceId: 22,
     },
     {
        id: 292,
        code: '3303',
        text: 'กันทรารมย์',
        value: 'กันทรารมย์',
        name: {
          th: 'กันทรารมย์',
          en: 'Kan thararom',
        },
        provinceId: 22,
     },
     {
        id: 293,
        code: '3304',
        text: 'กันทรลักษ์',
        value: 'กันทรลักษ์',
        name: {
          th: 'กันทรลักษ์',
          en: 'Kan tharalak',
        },
        provinceId: 22,
     },
     {
        id: 294,
        code: '3305',
        text: 'ขุขันธ์',
        value: 'ขุขันธ์',
        name: {
          th: 'ขุขันธ์',
          en: 'Khukhan',
        },
        provinceId: 22,
     },
     {
        id: 295,
        code: '3306',
        text: 'ไพรบึง',
        value: 'ไพรบึง',
        name: {
          th: 'ไพรบึง',
          en: 'Phrai Bu eng',
        },
        provinceId: 22,
     },
     {
        id: 296,
        code: '3307',
        text: 'ปรางค์กู่',
        value: 'ปรางค์กู่',
        name: {
          th: 'ปรางค์กู่',
          en: 'Prang Ku',
        },
        provinceId: 22,
     },
     {
        id: 297,
        code: '3308',
        text: 'ขุนหาญ',
        value: 'ขุนหาญ',
        name: {
          th: 'ขุนหาญ',
          en: 'Khun Han',
        },
        provinceId: 22,
     },
     {
        id: 298,
        code: '3309',
        text: 'ราษีไศล',
        value: 'ราษีไศล',
        name: {
          th: 'ราษีไศล',
          en: 'Rasi Salai',
        },
        provinceId: 22,
     },
     {
        id: 299,
        code: '3310',
        text: 'อุทุมพรพิสัย',
        value: 'อุทุมพรพิสัย',
        name: {
          th: 'อุทุมพรพิสัย',
          en: 'U thumphon Phisai',
        },
        provinceId: 22,
     },
     {
        id: 300,
        code: '3311',
        text: 'บึงบูรพ์',
        value: 'บึงบูรพ์',
        name: {
          th: 'บึงบูรพ์',
          en: 'Bu eng Bun',
        },
        provinceId: 22,
     },
     {
        id: 301,
        code: '3312',
        text: 'ห้วยทับทัน',
        value: 'ห้วยทับทัน',
        name: {
          th: 'ห้วยทับทัน',
          en: 'Huai  thap  than',
        },
        provinceId: 22,
     },
     {
        id: 302,
        code: '3313',
        text: 'โนนคูณ',
        value: 'โนนคูณ',
        name: {
          th: 'โนนคูณ',
          en: 'Non Khun',
        },
        provinceId: 22,
     },
     {
        id: 303,
        code: '3314',
        text: 'ศรีรัตนะ',
        value: 'ศรีรัตนะ',
        name: {
          th: 'ศรีรัตนะ',
          en: 'Si Rattana',
        },
        provinceId: 22,
     },
     {
        id: 304,
        code: '3315',
        text: 'น้ำเกลี้ยง',
        value: 'น้ำเกลี้ยง',
        name: {
          th: 'น้ำเกลี้ยง',
          en: 'Si Rattana',
        },
        provinceId: 22,
     },
     {
        id: 305,
        code: '3316',
        text: 'วังหิน',
        value: 'วังหิน',
        name: {
          th: 'วังหิน',
          en: 'Wang Hin',
        },
        provinceId: 22,
     },
     {
        id: 306,
        code: '3317',
        text: 'ภูสิงห์',
        value: 'ภูสิงห์',
        name: {
          th: 'ภูสิงห์',
          en: 'Phu Sing',
        },
        provinceId: 22,
     },
     {
        id: 307,
        code: '3318',
        text: 'เมืองจันทร์',
        value: 'เมืองจันทร์',
        name: {
          th: 'เมืองจันทร์',
          en: 'Mueang Chan',
        },
        provinceId: 22,
     },
     {
        id: 308,
        code: '3319',
        text: 'เบญจลักษ์',
        value: 'เบญจลักษ์',
        name: {
          th: 'เบญจลักษ์',
          en: 'B enchalak',
        },
        provinceId: 22,
     },
     {
        id: 309,
        code: '3320',
        text: 'พยุห์',
        value: 'พยุห์',
        name: {
          th: 'พยุห์',
          en: 'Phayu',
        },
        provinceId: 22,
     },
     {
        id: 310,
        code: '3321',
        text: 'โพธิ์ศรีสุวรรณ',
        value: 'โพธิ์ศรีสุวรรณ',
        name: {
          th: 'โพธิ์ศรีสุวรรณ',
          en: 'Pho Si Suwan',
        },
        provinceId: 22,
     },
     {
        id: 311,
        code: '3322',
        text: 'ศิลาลาด',
        value: 'ศิลาลาด',
        name: {
          th: 'ศิลาลาด',
          en: 'Sila Lat',
        },
        provinceId: 22,
     },
     {
        id: 312,
        code: '3401',
        text: 'เมืองอุบลราชธานี',
        value: 'เมืองอุบลราชธานี',
        name: {
          th: 'เมืองอุบลราชธานี',
          en: 'Mueang Ubon Ratcha thani',
        },
        provinceId: 23,
     },
     {
        id: 313,
        code: '3402',
        text: 'ศรีเมืองใหม่',
        value: 'ศรีเมืองใหม่',
        name: {
          th: 'ศรีเมืองใหม่',
          en: 'Si Mueang Mai',
        },
        provinceId: 23,
     },
     {
        id: 314,
        code: '3403',
        text: 'โขงเจียม',
        value: 'โขงเจียม',
        name: {
          th: 'โขงเจียม',
          en: 'Khong Chiam',
        },
        provinceId: 23,
     },
     {
        id: 315,
        code: '3404',
        text: 'เขื่องใน',
        value: 'เขื่องใน',
        name: {
          th: 'เขื่องใน',
          en: 'Khueang Nai',
        },
        provinceId: 23,
     },
     {
        id: 316,
        code: '3405',
        text: 'เขมราฐ',
        value: 'เขมราฐ',
        name: {
          th: 'เขมราฐ',
          en: 'Khemarat',
        },
        provinceId: 23,
     },
     {
        id: 317,
        code: '3406',
        text: 'ชานุมาน',
        value: 'ชานุมาน',
        name: {
          th: 'ชานุมาน',
          en: 'Shanuman',
        },
        provinceId: 23,
     },
     {
        id: 318,
        code: '3407',
        text: 'เดชอุดม',
        value: 'เดชอุดม',
        name: {
          th: 'เดชอุดม',
          en: 'Det Udom',
        },
        provinceId: 23,
     },
     {
        id: 319,
        code: '3408',
        text: 'นาจะหลวย',
        value: 'นาจะหลวย',
        name: {
          th: 'นาจะหลวย',
          en: 'Na Chaluai',
        },
        provinceId: 23,
     },
     {
        id: 320,
        code: '3409',
        text: 'น้ำยืน',
        value: 'น้ำยืน',
        name: {
          th: 'น้ำยืน',
          en: 'Nam Yu en',
        },
        provinceId: 23,
     },
     {
        id: 321,
        code: '3410',
        text: 'บุณฑริก',
        value: 'บุณฑริก',
        name: {
          th: 'บุณฑริก',
          en: 'Bun tharik',
        },
        provinceId: 23,
     },
     {
        id: 322,
        code: '3411',
        text: 'ตระการพืชผล',
        value: 'ตระการพืชผล',
        name: {
          th: 'ตระการพืชผล',
          en: 'Trakan Phuet Phon',
        },
        provinceId: 23,
     },
     {
        id: 323,
        code: '3412',
        text: 'กุดข้าวปุ้น',
        value: 'กุดข้าวปุ้น',
        name: {
          th: 'กุดข้าวปุ้น',
          en: 'Kut Khaopun',
        },
        provinceId: 23,
     },
     {
        id: 324,
        code: '3413',
        text: 'พนา',
        value: 'พนา',
        name: {
          th: 'พนา',
          en: 'Phana',
        },
        provinceId: 23,
     },
     {
        id: 325,
        code: '3414',
        text: 'ม่วงสามสิบ',
        value: 'ม่วงสามสิบ',
        name: {
          th: 'ม่วงสามสิบ',
          en: 'Muang Sam Sip',
        },
        provinceId: 23,
     },
     {
        id: 326,
        code: '3415',
        text: 'วารินชำราบ',
        value: 'วารินชำราบ',
        name: {
          th: 'วารินชำราบ',
          en: 'Warin Chamrap',
        },
        provinceId: 23,
     },
     {
        id: 327,
        code: '3416',
        text: 'อำนาจเจริญ',
        value: 'อำนาจเจริญ',
        name: {
          th: 'อำนาจเจริญ',
          en: 'Amnat Charo en',
        },
        provinceId: 23,
     },
     {
        id: 328,
        code: '3417',
        text: 'เสนางคนิคม',
        value: 'เสนางคนิคม',
        name: {
          th: 'เสนางคนิคม',
          en: 'S enangkhanikhom',
        },
        provinceId: 23,
     },
     {
        id: 329,
        code: '3418',
        text: 'หัวตะพาน',
        value: 'หัวตะพาน',
        name: {
          th: 'หัวตะพาน',
          en: 'Hua Taphan',
        },
        provinceId: 23,
     },
     {
        id: 330,
        code: '3419',
        text: 'พิบูลมังสาหาร',
        value: 'พิบูลมังสาหาร',
        name: {
          th: 'พิบูลมังสาหาร',
          en: 'Phibun Mangsahan',
        },
        provinceId: 23,
     },
     {
        id: 331,
        code: '3420',
        text: 'ตาลสุม',
        value: 'ตาลสุม',
        name: {
          th: 'ตาลสุม',
          en: 'Tan Sum',
        },
        provinceId: 23,
     },
     {
        id: 332,
        code: '3421',
        text: 'โพธิ์ไทร',
        value: 'โพธิ์ไทร',
        name: {
          th: 'โพธิ์ไทร',
          en: 'Pho Sai',
        },
        provinceId: 23,
     },
     {
        id: 333,
        code: '3422',
        text: 'สำโรง',
        value: 'สำโรง',
        name: {
          th: 'สำโรง',
          en: 'Samrong',
        },
        provinceId: 23,
     },
     {
        id: 334,
        code: '3423',
        text: 'กิ่งอำเภอลืออำนาจ',
        value: 'กิ่งอำเภอลืออำนาจ',
        name: {
          th: 'กิ่งอำเภอลืออำนาจ',
          en: 'King Amphoe Lue Amnat',
        },
        provinceId: 23,
     },
     {
        id: 335,
        code: '3424',
        text: 'ดอนมดแดง',
        value: 'ดอนมดแดง',
        name: {
          th: 'ดอนมดแดง',
          en: 'Don Mot Da eng',
        },
        provinceId: 23,
     },
     {
        id: 336,
        code: '3425',
        text: 'สิรินธร',
        value: 'สิรินธร',
        name: {
          th: 'สิรินธร',
          en: 'Sirindhorn',
        },
        provinceId: 23,
     },
     {
        id: 337,
        code: '3426',
        text: 'ทุ่งศรีอุดม',
        value: 'ทุ่งศรีอุดม',
        name: {
          th: 'ทุ่งศรีอุดม',
          en: ' thung Si Udom',
        },
        provinceId: 23,
     },
     {
        id: 338,
        code: '3427',
        text: 'ปทุมราชวงศา',
        value: 'ปทุมราชวงศา',
        name: {
          th: 'ปทุมราชวงศา',
          en: 'Pa thum Ratchawongsa',
        },
        provinceId: 23,
     },
     {
        id: 339,
        code: '3428',
        text: 'กิ่งอำเภอศรีหลักชัย',
        value: 'กิ่งอำเภอศรีหลักชัย',
        name: {
          th: 'กิ่งอำเภอศรีหลักชัย',
          en: 'King Amphoe Sri Lunk Chai',
        },
        provinceId: 23,
     },
     {
        id: 340,
        code: '3429',
        text: 'นาเยีย',
        value: 'นาเยีย',
        name: {
          th: 'นาเยีย',
          en: 'Na Yia',
        },
        provinceId: 23,
     },
     {
        id: 341,
        code: '3430',
        text: 'นาตาล',
        value: 'นาตาล',
        name: {
          th: 'นาตาล',
          en: 'Na Tan',
        },
        provinceId: 23,
     },
     {
        id: 342,
        code: '3431',
        text: 'เหล่าเสือโก้ก',
        value: 'เหล่าเสือโก้ก',
        name: {
          th: 'เหล่าเสือโก้ก',
          en: 'Lao Suea Kok',
        },
        provinceId: 23,
     },
     {
        id: 343,
        code: '3432',
        text: 'สว่างวีระวงศ์',
        value: 'สว่างวีระวงศ์',
        name: {
          th: 'สว่างวีระวงศ์',
          en: 'Sawang Wirawong',
        },
        provinceId: 23,
     },
     {
        id: 344,
        code: '3433',
        text: 'น้ำขุ่น',
        value: 'น้ำขุ่น',
        name: {
          th: 'น้ำขุ่น',
          en: 'Nam Khun',
        },
        provinceId: 23,
     },
     {
        id: 345,
        code: '3481',
        text: 'อ.สุวรรณวารี  จ.อุบลราชธานี',
        value: 'อ.สุวรรณวารี  จ.อุบลราชธานี',
        name: {
          th: 'อ.สุวรรณวารี  จ.อุบลราชธานี',
          en: 'Suwan Wari',
        },
        provinceId: 23,
     },
     {
        id: 346,
        code: '3501',
        text: 'เมืองยโสธร',
        value: 'เมืองยโสธร',
        name: {
          th: 'เมืองยโสธร',
          en: 'Mueang Yaso thon',
        },
        provinceId: 24,
     },
     {
        id: 347,
        code: '3502',
        text: 'ทรายมูล',
        value: 'ทรายมูล',
        name: {
          th: 'ทรายมูล',
          en: 'Sai Mun',
        },
        provinceId: 24,
     },
     {
        id: 348,
        code: '3503',
        text: 'กุดชุม',
        value: 'กุดชุม',
        name: {
          th: 'กุดชุม',
          en: 'Kut Chum',
        },
        provinceId: 24,
     },
     {
        id: 349,
        code: '3504',
        text: 'คำเขื่อนแก้ว',
        value: 'คำเขื่อนแก้ว',
        name: {
          th: 'คำเขื่อนแก้ว',
          en: 'Kham Khuean Kaeo',
        },
        provinceId: 24,
     },
     {
        id: 350,
        code: '3505',
        text: 'ป่าติ้ว',
        value: 'ป่าติ้ว',
        name: {
          th: 'ป่าติ้ว',
          en: 'Pa Tio',
        },
        provinceId: 24,
     },
     {
        id: 351,
        code: '3506',
        text: 'มหาชนะชัย',
        value: 'มหาชนะชัย',
        name: {
          th: 'มหาชนะชัย',
          en: 'Maha Chana Chai',
        },
        provinceId: 24,
     },
     {
        id: 352,
        code: '3507',
        text: 'ค้อวัง',
        value: 'ค้อวัง',
        name: {
          th: 'ค้อวัง',
          en: 'Kho Wang',
        },
        provinceId: 24,
     },
     {
        id: 353,
        code: '3508',
        text: 'เลิงนกทา',
        value: 'เลิงนกทา',
        name: {
          th: 'เลิงนกทา',
          en: 'Lo eng Nok  tha',
        },
        provinceId: 24,
     },
     {
        id: 354,
        code: '3509',
        text: 'ไทยเจริญ',
        value: 'ไทยเจริญ',
        name: {
          th: 'ไทยเจริญ',
          en: ' thai Charo en',
        },
        provinceId: 24,
     },
     {
        id: 355,
        code: '3601',
        text: 'เมืองชัยภูมิ',
        value: 'เมืองชัยภูมิ',
        name: {
          th: 'เมืองชัยภูมิ',
          en: 'Mueang Chaiyaphum',
        },
        provinceId: 25,
     },
     {
        id: 356,
        code: '3602',
        text: 'บ้านเขว้า',
        value: 'บ้านเขว้า',
        name: {
          th: 'บ้านเขว้า',
          en: 'Ban Khwao',
        },
        provinceId: 25,
     },
     {
        id: 357,
        code: '3603',
        text: 'คอนสวรรค์',
        value: 'คอนสวรรค์',
        name: {
          th: 'คอนสวรรค์',
          en: 'Khon Sawan',
        },
        provinceId: 25,
     },
     {
        id: 358,
        code: '3604',
        text: 'เกษตรสมบูรณ์',
        value: 'เกษตรสมบูรณ์',
        name: {
          th: 'เกษตรสมบูรณ์',
          en: 'Kaset Sombun',
        },
        provinceId: 25,
     },
     {
        id: 359,
        code: '3605',
        text: 'หนองบัวแดง',
        value: 'หนองบัวแดง',
        name: {
          th: 'หนองบัวแดง',
          en: 'Nong Bua Da eng',
        },
        provinceId: 25,
     },
     {
        id: 360,
        code: '3606',
        text: 'จัตุรัส',
        value: 'จัตุรัส',
        name: {
          th: 'จัตุรัส',
          en: 'Chatturat',
        },
        provinceId: 25,
     },
     {
        id: 361,
        code: '3607',
        text: 'บำเหน็จณรงค์',
        value: 'บำเหน็จณรงค์',
        name: {
          th: 'บำเหน็จณรงค์',
          en: 'Bamnet Narong',
        },
        provinceId: 25,
     },
     {
        id: 362,
        code: '3608',
        text: 'หนองบัวระเหว',
        value: 'หนองบัวระเหว',
        name: {
          th: 'หนองบัวระเหว',
          en: 'Nong Bua Rawe',
        },
        provinceId: 25,
     },
     {
        id: 363,
        code: '3609',
        text: 'เทพสถิต',
        value: 'เทพสถิต',
        name: {
          th: 'เทพสถิต',
          en: ' thep Sa thit',
        },
        provinceId: 25,
     },
     {
        id: 364,
        code: '3610',
        text: 'ภูเขียว',
        value: 'ภูเขียว',
        name: {
          th: 'ภูเขียว',
          en: 'Phu Khiao',
        },
        provinceId: 25,
     },
     {
        id: 365,
        code: '3611',
        text: 'บ้านแท่น',
        value: 'บ้านแท่น',
        name: {
          th: 'บ้านแท่น',
          en: 'Ban  tha en',
        },
        provinceId: 25,
     },
     {
        id: 366,
        code: '3612',
        text: 'แก้งคร้อ',
        value: 'แก้งคร้อ',
        name: {
          th: 'แก้งคร้อ',
          en: 'Ka eng Khro',
        },
        provinceId: 25,
     },
     {
        id: 367,
        code: '3613',
        text: 'คอนสาร',
        value: 'คอนสาร',
        name: {
          th: 'คอนสาร',
          en: 'Khon San',
        },
        provinceId: 25,
     },
     {
        id: 368,
        code: '3614',
        text: 'ภักดีชุมพล',
        value: 'ภักดีชุมพล',
        name: {
          th: 'ภักดีชุมพล',
          en: 'Phakdi Chumphon',
        },
        provinceId: 25,
     },
     {
        id: 369,
        code: '3615',
        text: 'เนินสง่า',
        value: 'เนินสง่า',
        name: {
          th: 'เนินสง่า',
          en: 'No en Sa-nga',
        },
        provinceId: 25,
     },
     {
        id: 370,
        code: '3616',
        text: 'ซับใหญ่',
        value: 'ซับใหญ่',
        name: {
          th: 'ซับใหญ่',
          en: 'Sap Yai',
        },
        provinceId: 25,
     },
     {
        id: 371,
        code: '3651',
        text: 'เมืองชัยภูมิ (สาขาตำบลโนนสำราญ)',
        value: 'เมืองชัยภูมิ (สาขาตำบลโนนสำราญ)',
        name: {
          th: 'เมืองชัยภูมิ (สาขาตำบลโนนสำราญ)',
          en: 'Mueang Chaiyaphum(Non Sumran)',
        },
        provinceId: 25,
     },
     {
        id: 372,
        code: '3652',
        text: 'สาขาตำบลบ้านหว่าเฒ่า',
        value: 'สาขาตำบลบ้านหว่าเฒ่า',
        name: {
          th: 'สาขาตำบลบ้านหว่าเฒ่า',
          en: 'Ban Wha Tao',
        },
        provinceId: 25,
     },
     {
        id: 373,
        code: '3653',
        text: 'หนองบัวแดง (สาขาตำบลวังชมภู)',
        value: 'หนองบัวแดง (สาขาตำบลวังชมภู)',
        name: {
          th: 'หนองบัวแดง (สาขาตำบลวังชมภู)',
          en: 'Nong Bua Da eng',
        },
        provinceId: 25,
     },
     {
        id: 374,
        code: '3654',
        text: 'กิ่งอำเภอซับใหญ่ (สาขาตำบลซับใหญ่)',
        value: 'กิ่งอำเภอซับใหญ่ (สาขาตำบลซับใหญ่)',
        name: {
          th: 'กิ่งอำเภอซับใหญ่ (สาขาตำบลซับใหญ่)',
          en: 'King Amphoe Sap Yai',
        },
        provinceId: 25,
     },
     {
        id: 375,
        code: '3655',
        text: 'สาขาตำบลโคกเพชร',
        value: 'สาขาตำบลโคกเพชร',
        name: {
          th: 'สาขาตำบลโคกเพชร',
          en: 'Coke Phet',
        },
        provinceId: 25,
     },
     {
        id: 376,
        code: '3656',
        text: 'เทพสถิต (สาขาตำบลนายางกลัก)',
        value: 'เทพสถิต (สาขาตำบลนายางกลัก)',
        name: {
          th: 'เทพสถิต (สาขาตำบลนายางกลัก)',
          en: ' thep Sa thit',
        },
        provinceId: 25,
     },
     {
        id: 377,
        code: '3657',
        text: 'บ้านแท่น (สาขาตำบลบ้านเต่า)',
        value: 'บ้านแท่น (สาขาตำบลบ้านเต่า)',
        name: {
          th: 'บ้านแท่น (สาขาตำบลบ้านเต่า)',
          en: 'Ban  tha en',
        },
        provinceId: 25,
     },
     {
        id: 378,
        code: '3658',
        text: 'แก้งคร้อ (สาขาตำบลท่ามะไฟหวาน)',
        value: 'แก้งคร้อ (สาขาตำบลท่ามะไฟหวาน)',
        name: {
          th: 'แก้งคร้อ (สาขาตำบลท่ามะไฟหวาน)',
          en: 'Ka eng Khro',
        },
        provinceId: 25,
     },
     {
        id: 379,
        code: '3659',
        text: 'คอนสาร (สาขาตำบลโนนคูณ)',
        value: 'คอนสาร (สาขาตำบลโนนคูณ)',
        name: {
          th: 'คอนสาร (สาขาตำบลโนนคูณ)',
          en: 'Khon San',
        },
        provinceId: 25,
     },
     {
        id: 380,
        code: '3701',
        text: 'เมืองอำนาจเจริญ',
        value: 'เมืองอำนาจเจริญ',
        name: {
          th: 'เมืองอำนาจเจริญ',
          en: 'Mueang Amnat Charo en',
        },
        provinceId: 26,
     },
     {
        id: 381,
        code: '3702',
        text: 'ชานุมาน',
        value: 'ชานุมาน',
        name: {
          th: 'ชานุมาน',
          en: 'Chanuman',
        },
        provinceId: 26,
     },
     {
        id: 382,
        code: '3703',
        text: 'ปทุมราชวงศา',
        value: 'ปทุมราชวงศา',
        name: {
          th: 'ปทุมราชวงศา',
          en: 'Pa thum Ratchawongsa',
        },
        provinceId: 26,
     },
     {
        id: 383,
        code: '3704',
        text: 'พนา',
        value: 'พนา',
        name: {
          th: 'พนา',
          en: 'Phana',
        },
        provinceId: 26,
     },
     {
        id: 384,
        code: '3705',
        text: 'เสนางคนิคม',
        value: 'เสนางคนิคม',
        name: {
          th: 'เสนางคนิคม',
          en: 'S enangkhanikhom',
        },
        provinceId: 26,
     },
     {
        id: 385,
        code: '3706',
        text: 'หัวตะพาน',
        value: 'หัวตะพาน',
        name: {
          th: 'หัวตะพาน',
          en: 'Hua Taphan',
        },
        provinceId: 26,
     },
     {
        id: 386,
        code: '3707',
        text: 'ลืออำนาจ',
        value: 'ลืออำนาจ',
        name: {
          th: 'ลืออำนาจ',
          en: 'Lue Amnat',
        },
        provinceId: 26,
     },
     {
        id: 387,
        code: '3901',
        text: 'เมืองหนองบัวลำภู',
        value: 'เมืองหนองบัวลำภู',
        name: {
          th: 'เมืองหนองบัวลำภู',
          en: 'Mueang Nong Bua Lam Phu',
        },
        provinceId: 27,
     },
     {
        id: 388,
        code: '3902',
        text: 'นากลาง',
        value: 'นากลาง',
        name: {
          th: 'นากลาง',
          en: 'Na Klang',
        },
        provinceId: 27,
     },
     {
        id: 389,
        code: '3903',
        text: 'โนนสัง',
        value: 'โนนสัง',
        name: {
          th: 'โนนสัง',
          en: 'Non Sang',
        },
        provinceId: 27,
     },
     {
        id: 390,
        code: '3904',
        text: 'ศรีบุญเรือง',
        value: 'ศรีบุญเรือง',
        name: {
          th: 'ศรีบุญเรือง',
          en: 'Si Bun Rueang',
        },
        provinceId: 27,
     },
     {
        id: 391,
        code: '3905',
        text: 'สุวรรณคูหา',
        value: 'สุวรรณคูหา',
        name: {
          th: 'สุวรรณคูหา',
          en: 'Suwannakhuha',
        },
        provinceId: 27,
     },
     {
        id: 392,
        code: '3906',
        text: 'นาวัง',
        value: 'นาวัง',
        name: {
          th: 'นาวัง',
          en: 'Na Wang',
        },
        provinceId: 27,
     },
     {
        id: 393,
        code: '4001',
        text: 'เมืองขอนแก่น',
        value: 'เมืองขอนแก่น',
        name: {
          th: 'เมืองขอนแก่น',
          en: 'Mueang Khon Ka en',
        },
        provinceId: 28,
     },
     {
        id: 394,
        code: '4002',
        text: 'บ้านฝาง',
        value: 'บ้านฝาง',
        name: {
          th: 'บ้านฝาง',
          en: 'Ban Fang',
        },
        provinceId: 28,
     },
     {
        id: 395,
        code: '4003',
        text: 'พระยืน',
        value: 'พระยืน',
        name: {
          th: 'พระยืน',
          en: 'Phra Yu en',
        },
        provinceId: 28,
     },
     {
        id: 396,
        code: '4004',
        text: 'หนองเรือ',
        value: 'หนองเรือ',
        name: {
          th: 'หนองเรือ',
          en: 'Nong Ruea',
        },
        provinceId: 28,
     },
     {
        id: 397,
        code: '4005',
        text: 'ชุมแพ',
        value: 'ชุมแพ',
        name: {
          th: 'ชุมแพ',
          en: 'Chum Phae',
        },
        provinceId: 28,
     },
     {
        id: 398,
        code: '4006',
        text: 'สีชมพู',
        value: 'สีชมพู',
        name: {
          th: 'สีชมพู',
          en: 'Si Chomphu',
        },
        provinceId: 28,
     },
     {
        id: 399,
        code: '4007',
        text: 'น้ำพอง',
        value: 'น้ำพอง',
        name: {
          th: 'น้ำพอง',
          en: 'Nam Phong',
        },
        provinceId: 28,
     },
     {
        id: 400,
        code: '4008',
        text: 'อุบลรัตน์',
        value: 'อุบลรัตน์',
        name: {
          th: 'อุบลรัตน์',
          en: 'Ubolratana',
        },
        provinceId: 28,
     },
     {
        id: 401,
        code: '4009',
        text: 'กระนวน',
        value: 'กระนวน',
        name: {
          th: 'กระนวน',
          en: 'Kranuan',
        },
        provinceId: 28,
     },
     {
        id: 402,
        code: '4010',
        text: 'บ้านไผ่',
        value: 'บ้านไผ่',
        name: {
          th: 'บ้านไผ่',
          en: 'Ban Phai',
        },
        provinceId: 28,
     },
     {
        id: 403,
        code: '4011',
        text: 'เปือยน้อย',
        value: 'เปือยน้อย',
        name: {
          th: 'เปือยน้อย',
          en: 'Pueai Noi',
        },
        provinceId: 28,
     },
     {
        id: 404,
        code: '4012',
        text: 'พล',
        value: 'พล',
        name: {
          th: 'พล',
          en: 'Phon',
        },
        provinceId: 28,
     },
     {
        id: 405,
        code: '4013',
        text: 'แวงใหญ่',
        value: 'แวงใหญ่',
        name: {
          th: 'แวงใหญ่',
          en: 'Wa eng Yai',
        },
        provinceId: 28,
     },
     {
        id: 406,
        code: '4014',
        text: 'แวงน้อย',
        value: 'แวงน้อย',
        name: {
          th: 'แวงน้อย',
          en: 'Wa eng Noi',
        },
        provinceId: 28,
     },
     {
        id: 407,
        code: '4015',
        text: 'หนองสองห้อง',
        value: 'หนองสองห้อง',
        name: {
          th: 'หนองสองห้อง',
          en: 'Nong Song Hong',
        },
        provinceId: 28,
     },
     {
        id: 408,
        code: '4016',
        text: 'ภูเวียง',
        value: 'ภูเวียง',
        name: {
          th: 'ภูเวียง',
          en: 'Phu Wiang',
        },
        provinceId: 28,
     },
     {
        id: 409,
        code: '4017',
        text: 'มัญจาคีรี',
        value: 'มัญจาคีรี',
        name: {
          th: 'มัญจาคีรี',
          en: 'Mancha Khiri',
        },
        provinceId: 28,
     },
     {
        id: 410,
        code: '4018',
        text: 'ชนบท',
        value: 'ชนบท',
        name: {
          th: 'ชนบท',
          en: 'Chonnabot',
        },
        provinceId: 28,
     },
     {
        id: 411,
        code: '4019',
        text: 'เขาสวนกวาง',
        value: 'เขาสวนกวาง',
        name: {
          th: 'เขาสวนกวาง',
          en: 'Khao Suan Kwang',
        },
        provinceId: 28,
     },
     {
        id: 412,
        code: '4020',
        text: 'ภูผาม่าน',
        value: 'ภูผาม่าน',
        name: {
          th: 'ภูผาม่าน',
          en: 'Phu Pha Man',
        },
        provinceId: 28,
     },
     {
        id: 413,
        code: '4021',
        text: 'ซำสูง',
        value: 'ซำสูง',
        name: {
          th: 'ซำสูง',
          en: 'Sam Sung',
        },
        provinceId: 28,
     },
     {
        id: 414,
        code: '4022',
        text: 'โคกโพธิ์ไชย',
        value: 'โคกโพธิ์ไชย',
        name: {
          th: 'โคกโพธิ์ไชย',
          en: 'Khok Pho Chai',
        },
        provinceId: 28,
     },
     {
        id: 415,
        code: '4023',
        text: 'หนองนาคำ',
        value: 'หนองนาคำ',
        name: {
          th: 'หนองนาคำ',
          en: 'Nong Na Kham',
        },
        provinceId: 28,
     },
     {
        id: 416,
        code: '4024',
        text: 'บ้านแฮด',
        value: 'บ้านแฮด',
        name: {
          th: 'บ้านแฮด',
          en: 'Ban Haet',
        },
        provinceId: 28,
     },
     {
        id: 417,
        code: '4025',
        text: 'โนนศิลา',
        value: 'โนนศิลา',
        name: {
          th: 'โนนศิลา',
          en: 'Non Sila',
        },
        provinceId: 28,
     },
     {
        id: 418,
        code: '4029',
        text: 'เวียงเก่า',
        value: 'เวียงเก่า',
        name: {
          th: 'เวียงเก่า',
          en: 'Wiang Kao',
        },
        provinceId: 28,
     },
     {
        id: 419,
        code: '4068',
        text: 'ท้องถิ่นเทศบาลตำบลบ้านเป็ด',
        value: 'ท้องถิ่นเทศบาลตำบลบ้านเป็ด',
        name: {
          th: 'ท้องถิ่นเทศบาลตำบลบ้านเป็ด',
          en: 'Ban Pet',
        },
        provinceId: 28,
     },
     {
        id: 420,
        code: '4098',
        text: 'เทศบาลตำบลเมืองพล',
        value: 'เทศบาลตำบลเมืองพล',
        name: {
          th: 'เทศบาลตำบลเมืองพล',
          en: 'Tet Saban Tambon Muang Phon',
        },
        provinceId: 28,
     },
     {
        id: 421,
        code: '4101',
        text: 'เมืองอุดรธานี',
        value: 'เมืองอุดรธานี',
        name: {
          th: 'เมืองอุดรธานี',
          en: 'Mueang Udon  thani',
        },
        provinceId: 29,
     },
     {
        id: 422,
        code: '4102',
        text: 'กุดจับ',
        value: 'กุดจับ',
        name: {
          th: 'กุดจับ',
          en: 'Kut Chap',
        },
        provinceId: 29,
     },
     {
        id: 423,
        code: '4103',
        text: 'หนองวัวซอ',
        value: 'หนองวัวซอ',
        name: {
          th: 'หนองวัวซอ',
          en: 'Nong Wua So',
        },
        provinceId: 29,
     },
     {
        id: 424,
        code: '4104',
        text: 'กุมภวาปี',
        value: 'กุมภวาปี',
        name: {
          th: 'กุมภวาปี',
          en: 'Kumphawapi',
        },
        provinceId: 29,
     },
     {
        id: 425,
        code: '4105',
        text: 'โนนสะอาด',
        value: 'โนนสะอาด',
        name: {
          th: 'โนนสะอาด',
          en: 'Non Sa-at',
        },
        provinceId: 29,
     },
     {
        id: 426,
        code: '4106',
        text: 'หนองหาน',
        value: 'หนองหาน',
        name: {
          th: 'หนองหาน',
          en: 'Nong Han',
        },
        provinceId: 29,
     },
     {
        id: 427,
        code: '4107',
        text: 'ทุ่งฝน',
        value: 'ทุ่งฝน',
        name: {
          th: 'ทุ่งฝน',
          en: ' thung Fon',
        },
        provinceId: 29,
     },
     {
        id: 428,
        code: '4108',
        text: 'ไชยวาน',
        value: 'ไชยวาน',
        name: {
          th: 'ไชยวาน',
          en: 'Chai Wan',
        },
        provinceId: 29,
     },
     {
        id: 429,
        code: '4109',
        text: 'ศรีธาตุ',
        value: 'ศรีธาตุ',
        name: {
          th: 'ศรีธาตุ',
          en: 'Si  that',
        },
        provinceId: 29,
     },
     {
        id: 430,
        code: '4110',
        text: 'วังสามหมอ',
        value: 'วังสามหมอ',
        name: {
          th: 'วังสามหมอ',
          en: 'Wang Sam Mo',
        },
        provinceId: 29,
     },
     {
        id: 431,
        code: '4111',
        text: 'บ้านดุง',
        value: 'บ้านดุง',
        name: {
          th: 'บ้านดุง',
          en: 'Ban Dung',
        },
        provinceId: 29,
     },
     {
        id: 432,
        code: '4112',
        text: 'หนองบัวลำภู',
        value: 'หนองบัวลำภู',
        name: {
          th: 'หนองบัวลำภู',
          en: 'Nong Bua Lam Phu',
        },
        provinceId: 29,
     },
     {
        id: 433,
        code: '4113',
        text: 'ศรีบุญเรือง',
        value: 'ศรีบุญเรือง',
        name: {
          th: 'ศรีบุญเรือง',
          en: 'Si Bun Rueang',
        },
        provinceId: 29,
     },
     {
        id: 434,
        code: '4114',
        text: 'นากลาง',
        value: 'นากลาง',
        name: {
          th: 'นากลาง',
          en: 'Na Klang',
        },
        provinceId: 29,
     },
     {
        id: 435,
        code: '4115',
        text: 'สุวรรณคูหา',
        value: 'สุวรรณคูหา',
        name: {
          th: 'สุวรรณคูหา',
          en: 'Suwannakhuha',
        },
        provinceId: 29,
     },
     {
        id: 436,
        code: '4116',
        text: 'โนนสัง',
        value: 'โนนสัง',
        name: {
          th: 'โนนสัง',
          en: 'Non Sang',
        },
        provinceId: 29,
     },
     {
        id: 437,
        code: '4117',
        text: 'บ้านผือ',
        value: 'บ้านผือ',
        name: {
          th: 'บ้านผือ',
          en: 'Ban Phue',
        },
        provinceId: 29,
     },
     {
        id: 438,
        code: '4118',
        text: 'น้ำโสม',
        value: 'น้ำโสม',
        name: {
          th: 'น้ำโสม',
          en: 'Nam Som',
        },
        provinceId: 29,
     },
     {
        id: 439,
        code: '4119',
        text: 'เพ็ญ',
        value: 'เพ็ญ',
        name: {
          th: 'เพ็ญ',
          en: 'Ph en',
        },
        provinceId: 29,
     },
     {
        id: 440,
        code: '4120',
        text: 'สร้างคอม',
        value: 'สร้างคอม',
        name: {
          th: 'สร้างคอม',
          en: 'Sang Khom',
        },
        provinceId: 29,
     },
     {
        id: 441,
        code: '4121',
        text: 'หนองแสง',
        value: 'หนองแสง',
        name: {
          th: 'หนองแสง',
          en: 'Nong Sa eng',
        },
        provinceId: 29,
     },
     {
        id: 442,
        code: '4122',
        text: 'นายูง',
        value: 'นายูง',
        name: {
          th: 'นายูง',
          en: 'Na Yung',
        },
        provinceId: 29,
     },
     {
        id: 443,
        code: '4123',
        text: 'พิบูลย์รักษ์',
        value: 'พิบูลย์รักษ์',
        name: {
          th: 'พิบูลย์รักษ์',
          en: 'Phibun Rak',
        },
        provinceId: 29,
     },
     {
        id: 444,
        code: '4124',
        text: 'กู่แก้ว',
        value: 'กู่แก้ว',
        name: {
          th: 'กู่แก้ว',
          en: 'Ku Kaeo',
        },
        provinceId: 29,
     },
     {
        id: 445,
        code: '4125',
        text: 'ประจักษ์ศิลปาคม',
        value: 'ประจักษ์ศิลปาคม',
        name: {
          th: 'ประจักษ์ศิลปาคม',
          en: 'rachak-sinlapakhom',
        },
        provinceId: 29,
     },
     {
        id: 446,
        code: '4201',
        text: 'เมืองเลย',
        value: 'เมืองเลย',
        name: {
          th: 'เมืองเลย',
          en: 'Mueang Loei',
        },
        provinceId: 30,
     },
     {
        id: 447,
        code: '4202',
        text: 'นาด้วง',
        value: 'นาด้วง',
        name: {
          th: 'นาด้วง',
          en: 'Na Duang',
        },
        provinceId: 30,
     },
     {
        id: 448,
        code: '4203',
        text: 'เชียงคาน',
        value: 'เชียงคาน',
        name: {
          th: 'เชียงคาน',
          en: 'Chiang Khan',
        },
        provinceId: 30,
     },
     {
        id: 449,
        code: '4204',
        text: 'ปากชม',
        value: 'ปากชม',
        name: {
          th: 'ปากชม',
          en: 'Pak Chom',
        },
        provinceId: 30,
     },
     {
        id: 450,
        code: '4205',
        text: 'ด่านซ้าย',
        value: 'ด่านซ้าย',
        name: {
          th: 'ด่านซ้าย',
          en: 'Dan Sai',
        },
        provinceId: 30,
     },
     {
        id: 451,
        code: '4206',
        text: 'นาแห้ว',
        value: 'นาแห้ว',
        name: {
          th: 'นาแห้ว',
          en: 'Na Haeo',
        },
        provinceId: 30,
     },
     {
        id: 452,
        code: '4207',
        text: 'ภูเรือ',
        value: 'ภูเรือ',
        name: {
          th: 'ภูเรือ',
          en: 'Phu Ruea',
        },
        provinceId: 30,
     },
     {
        id: 453,
        code: '4208',
        text: 'ท่าลี่',
        value: 'ท่าลี่',
        name: {
          th: 'ท่าลี่',
          en: ' tha Li',
        },
        provinceId: 30,
     },
     {
        id: 454,
        code: '4209',
        text: 'วังสะพุง',
        value: 'วังสะพุง',
        name: {
          th: 'วังสะพุง',
          en: 'Wang Saphung',
        },
        provinceId: 30,
     },
     {
        id: 455,
        code: '4210',
        text: 'ภูกระดึง',
        value: 'ภูกระดึง',
        name: {
          th: 'ภูกระดึง',
          en: 'Phu Kradu eng',
        },
        provinceId: 30,
     },
     {
        id: 456,
        code: '4211',
        text: 'ภูหลวง',
        value: 'ภูหลวง',
        name: {
          th: 'ภูหลวง',
          en: 'Phu Luang',
        },
        provinceId: 30,
     },
     {
        id: 457,
        code: '4212',
        text: 'ผาขาว',
        value: 'ผาขาว',
        name: {
          th: 'ผาขาว',
          en: 'Pha Khao',
        },
        provinceId: 30,
     },
     {
        id: 458,
        code: '4213',
        text: 'เอราวัณ',
        value: 'เอราวัณ',
        name: {
          th: 'เอราวัณ',
          en: 'Erawan',
        },
        provinceId: 30,
     },
     {
        id: 459,
        code: '4214',
        text: 'หนองหิน',
        value: 'หนองหิน',
        name: {
          th: 'หนองหิน',
          en: 'Nong Hin',
        },
        provinceId: 30,
     },
     {
        id: 460,
        code: '4301',
        text: 'เมืองหนองคาย',
        value: 'เมืองหนองคาย',
        name: {
          th: 'เมืองหนองคาย',
          en: 'Mueang Nong Khai',
        },
        provinceId: 31,
     },
     {
        id: 461,
        code: '4302',
        text: 'ท่าบ่อ',
        value: 'ท่าบ่อ',
        name: {
          th: 'ท่าบ่อ',
          en: ' tha Bo',
        },
        provinceId: 31,
     },
     {
        id: 464,
        code: '4305',
        text: 'โพนพิสัย',
        value: 'โพนพิสัย',
        name: {
          th: 'โพนพิสัย',
          en: 'Phon Phisai',
        },
        provinceId: 31,
     },
     {
        id: 466,
        code: '4307',
        text: 'ศรีเชียงใหม่',
        value: 'ศรีเชียงใหม่',
        name: {
          th: 'ศรีเชียงใหม่',
          en: 'Si Chiang Mai',
        },
        provinceId: 31,
     },
     {
        id: 467,
        code: '4308',
        text: 'สังคม',
        value: 'สังคม',
        name: {
          th: 'สังคม',
          en: 'Sangkhom',
        },
        provinceId: 31,
     },
     {
        id: 473,
        code: '4314',
        text: 'สระใคร',
        value: 'สระใคร',
        name: {
          th: 'สระใคร',
          en: 'Sakhrai',
        },
        provinceId: 31,
     },
     {
        id: 474,
        code: '4315',
        text: 'เฝ้าไร่',
        value: 'เฝ้าไร่',
        name: {
          th: 'เฝ้าไร่',
          en: 'Fao Rai',
        },
        provinceId: 31,
     },
     {
        id: 475,
        code: '4316',
        text: 'รัตนวาปี',
        value: 'รัตนวาปี',
        name: {
          th: 'รัตนวาปี',
          en: 'Rattanawapi',
        },
        provinceId: 31,
     },
     {
        id: 476,
        code: '4317',
        text: 'โพธิ์ตาก',
        value: 'โพธิ์ตาก',
        name: {
          th: 'โพธิ์ตาก',
          en: 'Pho Tak',
        },
        provinceId: 31,
     },
     {
        id: 477,
        code: '4401',
        text: 'เมืองมหาสารคาม',
        value: 'เมืองมหาสารคาม',
        name: {
          th: 'เมืองมหาสารคาม',
          en: 'Mueang Maha Sarakham',
        },
        provinceId: 32,
     },
     {
        id: 478,
        code: '4402',
        text: 'แกดำ',
        value: 'แกดำ',
        name: {
          th: 'แกดำ',
          en: 'Kae Dam',
        },
        provinceId: 32,
     },
     {
        id: 479,
        code: '4403',
        text: 'โกสุมพิสัย',
        value: 'โกสุมพิสัย',
        name: {
          th: 'โกสุมพิสัย',
          en: 'Kosum Phisai',
        },
        provinceId: 32,
     },
     {
        id: 480,
        code: '4404',
        text: 'กันทรวิชัย',
        value: 'กันทรวิชัย',
        name: {
          th: 'กันทรวิชัย',
          en: 'Kan tharawichai',
        },
        provinceId: 32,
     },
     {
        id: 481,
        code: '4405',
        text: 'เชียงยืน',
        value: 'เชียงยืน',
        name: {
          th: 'เชียงยืน',
          en: 'Kan tharawichai',
        },
        provinceId: 32,
     },
     {
        id: 482,
        code: '4406',
        text: 'บรบือ',
        value: 'บรบือ',
        name: {
          th: 'บรบือ',
          en: 'Borabue',
        },
        provinceId: 32,
     },
     {
        id: 483,
        code: '4407',
        text: 'นาเชือก',
        value: 'นาเชือก',
        name: {
          th: 'นาเชือก',
          en: 'Na Chueak',
        },
        provinceId: 32,
     },
     {
        id: 484,
        code: '4408',
        text: 'พยัคฆภูมิพิสัย',
        value: 'พยัคฆภูมิพิสัย',
        name: {
          th: 'พยัคฆภูมิพิสัย',
          en: 'Phayakkhaphum Phisai',
        },
        provinceId: 32,
     },
     {
        id: 485,
        code: '4409',
        text: 'วาปีปทุม',
        value: 'วาปีปทุม',
        name: {
          th: 'วาปีปทุม',
          en: 'Wapi Pa thum',
        },
        provinceId: 32,
     },
     {
        id: 486,
        code: '4410',
        text: 'นาดูน',
        value: 'นาดูน',
        name: {
          th: 'นาดูน',
          en: 'Na Dun',
        },
        provinceId: 32,
     },
     {
        id: 487,
        code: '4411',
        text: 'ยางสีสุราช',
        value: 'ยางสีสุราช',
        name: {
          th: 'ยางสีสุราช',
          en: 'Yang Sisurat',
        },
        provinceId: 32,
     },
     {
        id: 488,
        code: '4412',
        text: 'กุดรัง',
        value: 'กุดรัง',
        name: {
          th: 'กุดรัง',
          en: 'Kut Rang',
        },
        provinceId: 32,
     },
     {
        id: 489,
        code: '4413',
        text: 'ชื่นชม',
        value: 'ชื่นชม',
        name: {
          th: 'ชื่นชม',
          en: 'Chu en Chom',
        },
        provinceId: 32,
     },
     {
        id: 490,
        code: '4481',
        text: 'หลุบ',
        value: 'หลุบ',
        name: {
          th: 'หลุบ',
          en: 'Lub',
        },
        provinceId: 32,
     },
     {
        id: 491,
        code: '4501',
        text: 'เมืองร้อยเอ็ด',
        value: 'เมืองร้อยเอ็ด',
        name: {
          th: 'เมืองร้อยเอ็ด',
          en: 'Mueang Roi Et',
        },
        provinceId: 33,
     },
     {
        id: 492,
        code: '4502',
        text: 'เกษตรวิสัย',
        value: 'เกษตรวิสัย',
        name: {
          th: 'เกษตรวิสัย',
          en: 'Kaset Wisai',
        },
        provinceId: 33,
     },
     {
        id: 493,
        code: '4503',
        text: 'ปทุมรัตต์',
        value: 'ปทุมรัตต์',
        name: {
          th: 'ปทุมรัตต์',
          en: 'Pa thum Rat',
        },
        provinceId: 33,
     },
     {
        id: 494,
        code: '4504',
        text: 'จตุรพักตรพิมาน',
        value: 'จตุรพักตรพิมาน',
        name: {
          th: 'จตุรพักตรพิมาน',
          en: 'Chaturaphak Phiman',
        },
        provinceId: 33,
     },
     {
        id: 495,
        code: '4505',
        text: 'ธวัชบุรี',
        value: 'ธวัชบุรี',
        name: {
          th: 'ธวัชบุรี',
          en: ' thawat Buri',
        },
        provinceId: 33,
     },
     {
        id: 496,
        code: '4506',
        text: 'พนมไพร',
        value: 'พนมไพร',
        name: {
          th: 'พนมไพร',
          en: 'Phanom Phrai',
        },
        provinceId: 33,
     },
     {
        id: 497,
        code: '4507',
        text: 'โพนทอง',
        value: 'โพนทอง',
        name: {
          th: 'โพนทอง',
          en: 'Phon  thong',
        },
        provinceId: 33,
     },
     {
        id: 498,
        code: '4508',
        text: 'โพธิ์ชัย',
        value: 'โพธิ์ชัย',
        name: {
          th: 'โพธิ์ชัย',
          en: 'Pho Chai',
        },
        provinceId: 33,
     },
     {
        id: 499,
        code: '4509',
        text: 'หนองพอก',
        value: 'หนองพอก',
        name: {
          th: 'หนองพอก',
          en: 'Nong Phok',
        },
        provinceId: 33,
     },
     {
        id: 500,
        code: '4510',
        text: 'เสลภูมิ',
        value: 'เสลภูมิ',
        name: {
          th: 'เสลภูมิ',
          en: 'Selaphum',
        },
        provinceId: 33,
     },
     {
        id: 501,
        code: '4511',
        text: 'สุวรรณภูมิ',
        value: 'สุวรรณภูมิ',
        name: {
          th: 'สุวรรณภูมิ',
          en: 'Suwannaphum',
        },
        provinceId: 33,
     },
     {
        id: 502,
        code: '4512',
        text: 'เมืองสรวง',
        value: 'เมืองสรวง',
        name: {
          th: 'เมืองสรวง',
          en: 'Mueang Suang',
        },
        provinceId: 33,
     },
     {
        id: 503,
        code: '4513',
        text: 'โพนทราย',
        value: 'โพนทราย',
        name: {
          th: 'โพนทราย',
          en: 'Phon Sai',
        },
        provinceId: 33,
     },
     {
        id: 504,
        code: '4514',
        text: 'อาจสามารถ',
        value: 'อาจสามารถ',
        name: {
          th: 'อาจสามารถ',
          en: 'At Samat',
        },
        provinceId: 33,
     },
     {
        id: 505,
        code: '4515',
        text: 'เมยวดี',
        value: 'เมยวดี',
        name: {
          th: 'เมยวดี',
          en: 'Moei Wadi',
        },
        provinceId: 33,
     },
     {
        id: 506,
        code: '4516',
        text: 'ศรีสมเด็จ',
        value: 'ศรีสมเด็จ',
        name: {
          th: 'ศรีสมเด็จ',
          en: 'Si Somdet',
        },
        provinceId: 33,
     },
     {
        id: 507,
        code: '4517',
        text: 'จังหาร',
        value: 'จังหาร',
        name: {
          th: 'จังหาร',
          en: 'Changhan',
        },
        provinceId: 33,
     },
     {
        id: 508,
        code: '4518',
        text: 'เชียงขวัญ',
        value: 'เชียงขวัญ',
        name: {
          th: 'เชียงขวัญ',
          en: 'Chiang Khwan',
        },
        provinceId: 33,
     },
     {
        id: 509,
        code: '4519',
        text: 'หนองฮี',
        value: 'หนองฮี',
        name: {
          th: 'หนองฮี',
          en: 'Nong Hi',
        },
        provinceId: 33,
     },
     {
        id: 510,
        code: '4520',
        text: 'ทุ่งเขาหลวง',
        value: 'ทุ่งเขาหลวง',
        name: {
          th: 'ทุ่งเขาหลวง',
          en: ' thung Khao Luang',
        },
        provinceId: 33,
     },
     {
        id: 511,
        code: '4601',
        text: 'เมืองกาฬสินธุ์',
        value: 'เมืองกาฬสินธุ์',
        name: {
          th: 'เมืองกาฬสินธุ์',
          en: 'Mueang Kalasin',
        },
        provinceId: 34,
     },
     {
        id: 512,
        code: '4602',
        text: 'นามน',
        value: 'นามน',
        name: {
          th: 'นามน',
          en: 'Na Mon',
        },
        provinceId: 34,
     },
     {
        id: 513,
        code: '4603',
        text: 'กมลาไสย',
        value: 'กมลาไสย',
        name: {
          th: 'กมลาไสย',
          en: 'Kamalasai',
        },
        provinceId: 34,
     },
     {
        id: 514,
        code: '4604',
        text: 'ร่องคำ',
        value: 'ร่องคำ',
        name: {
          th: 'ร่องคำ',
          en: 'Rong Kham',
        },
        provinceId: 34,
     },
     {
        id: 515,
        code: '4605',
        text: 'กุฉินารายณ์',
        value: 'กุฉินารายณ์',
        name: {
          th: 'กุฉินารายณ์',
          en: 'Kuchinarai',
        },
        provinceId: 34,
     },
     {
        id: 516,
        code: '4606',
        text: 'เขาวง',
        value: 'เขาวง',
        name: {
          th: 'เขาวง',
          en: 'Khao Wong',
        },
        provinceId: 34,
     },
     {
        id: 517,
        code: '4607',
        text: 'ยางตลาด',
        value: 'ยางตลาด',
        name: {
          th: 'ยางตลาด',
          en: 'Yang Talat',
        },
        provinceId: 34,
     },
     {
        id: 518,
        code: '4608',
        text: 'ห้วยเม็ก',
        value: 'ห้วยเม็ก',
        name: {
          th: 'ห้วยเม็ก',
          en: 'Huai Mek',
        },
        provinceId: 34,
     },
     {
        id: 519,
        code: '4609',
        text: 'สหัสขันธ์',
        value: 'สหัสขันธ์',
        name: {
          th: 'สหัสขันธ์',
          en: 'Sahatsakhan',
        },
        provinceId: 34,
     },
     {
        id: 520,
        code: '4610',
        text: 'คำม่วง',
        value: 'คำม่วง',
        name: {
          th: 'คำม่วง',
          en: 'Kham Muang',
        },
        provinceId: 34,
     },
     {
        id: 521,
        code: '4611',
        text: 'ท่าคันโท',
        value: 'ท่าคันโท',
        name: {
          th: 'ท่าคันโท',
          en: ' tha Khan tho',
        },
        provinceId: 34,
     },
     {
        id: 522,
        code: '4612',
        text: 'หนองกุงศรี',
        value: 'หนองกุงศรี',
        name: {
          th: 'หนองกุงศรี',
          en: 'Nong Kung Si',
        },
        provinceId: 34,
     },
     {
        id: 523,
        code: '4613',
        text: 'สมเด็จ',
        value: 'สมเด็จ',
        name: {
          th: 'สมเด็จ',
          en: 'Somdet',
        },
        provinceId: 34,
     },
     {
        id: 524,
        code: '4614',
        text: 'ห้วยผึ้ง',
        value: 'ห้วยผึ้ง',
        name: {
          th: 'ห้วยผึ้ง',
          en: 'Huai Phu eng',
        },
        provinceId: 34,
     },
     {
        id: 525,
        code: '4615',
        text: 'สามชัย',
        value: 'สามชัย',
        name: {
          th: 'สามชัย',
          en: 'Sam Chai',
        },
        provinceId: 34,
     },
     {
        id: 526,
        code: '4616',
        text: 'นาคู',
        value: 'นาคู',
        name: {
          th: 'นาคู',
          en: 'Na Khu',
        },
        provinceId: 34,
     },
     {
        id: 527,
        code: '4617',
        text: 'ดอนจาน',
        value: 'ดอนจาน',
        name: {
          th: 'ดอนจาน',
          en: 'Don Chan',
        },
        provinceId: 34,
     },
     {
        id: 528,
        code: '4618',
        text: 'ฆ้องชัย',
        value: 'ฆ้องชัย',
        name: {
          th: 'ฆ้องชัย',
          en: 'Khong Chai',
        },
        provinceId: 34,
     },
     {
        id: 529,
        code: '4701',
        text: 'เมืองสกลนคร',
        value: 'เมืองสกลนคร',
        name: {
          th: 'เมืองสกลนคร',
          en: 'Mueang Sakon Nakhon',
        },
        provinceId: 35,
     },
     {
        id: 530,
        code: '4702',
        text: 'กุสุมาลย์',
        value: 'กุสุมาลย์',
        name: {
          th: 'กุสุมาลย์',
          en: 'Kusuman',
        },
        provinceId: 35,
     },
     {
        id: 531,
        code: '4703',
        text: 'กุดบาก',
        value: 'กุดบาก',
        name: {
          th: 'กุดบาก',
          en: 'Kut Bak',
        },
        provinceId: 35,
     },
     {
        id: 532,
        code: '4704',
        text: 'พรรณานิคม',
        value: 'พรรณานิคม',
        name: {
          th: 'พรรณานิคม',
          en: 'Phanna Nikhom',
        },
        provinceId: 35,
     },
     {
        id: 533,
        code: '4705',
        text: 'พังโคน',
        value: 'พังโคน',
        name: {
          th: 'พังโคน',
          en: 'Phang Khon',
        },
        provinceId: 35,
     },
     {
        id: 534,
        code: '4706',
        text: 'วาริชภูมิ',
        value: 'วาริชภูมิ',
        name: {
          th: 'วาริชภูมิ',
          en: 'Waritchaphum',
        },
        provinceId: 35,
     },
     {
        id: 535,
        code: '4707',
        text: 'นิคมน้ำอูน',
        value: 'นิคมน้ำอูน',
        name: {
          th: 'นิคมน้ำอูน',
          en: 'Nikhom Nam Un',
        },
        provinceId: 35,
     },
     {
        id: 536,
        code: '4708',
        text: 'วานรนิวาส',
        value: 'วานรนิวาส',
        name: {
          th: 'วานรนิวาส',
          en: 'Wanon Niwat',
        },
        provinceId: 35,
     },
     {
        id: 537,
        code: '4709',
        text: 'คำตากล้า',
        value: 'คำตากล้า',
        name: {
          th: 'คำตากล้า',
          en: 'Kham Ta Kla',
        },
        provinceId: 35,
     },
     {
        id: 538,
        code: '4710',
        text: 'บ้านม่วง',
        value: 'บ้านม่วง',
        name: {
          th: 'บ้านม่วง',
          en: 'Ban Muang',
        },
        provinceId: 35,
     },
     {
        id: 539,
        code: '4711',
        text: 'อากาศอำนวย',
        value: 'อากาศอำนวย',
        name: {
          th: 'อากาศอำนวย',
          en: 'Akat Amnuai',
        },
        provinceId: 35,
     },
     {
        id: 540,
        code: '4712',
        text: 'สว่างแดนดิน',
        value: 'สว่างแดนดิน',
        name: {
          th: 'สว่างแดนดิน',
          en: 'Sawang Da en Din',
        },
        provinceId: 35,
     },
     {
        id: 541,
        code: '4713',
        text: 'ส่องดาว',
        value: 'ส่องดาว',
        name: {
          th: 'ส่องดาว',
          en: 'Song Dao',
        },
        provinceId: 35,
     },
     {
        id: 542,
        code: '4714',
        text: 'เต่างอย',
        value: 'เต่างอย',
        name: {
          th: 'เต่างอย',
          en: 'Tao Ngoi',
        },
        provinceId: 35,
     },
     {
        id: 543,
        code: '4715',
        text: 'โคกศรีสุพรรณ',
        value: 'โคกศรีสุพรรณ',
        name: {
          th: 'โคกศรีสุพรรณ',
          en: 'Khok Si Suphan',
        },
        provinceId: 35,
     },
     {
        id: 544,
        code: '4716',
        text: 'เจริญศิลป์',
        value: 'เจริญศิลป์',
        name: {
          th: 'เจริญศิลป์',
          en: 'Charo en Sin',
        },
        provinceId: 35,
     },
     {
        id: 545,
        code: '4717',
        text: 'โพนนาแก้ว',
        value: 'โพนนาแก้ว',
        name: {
          th: 'โพนนาแก้ว',
          en: 'Phon Na Kaeo',
        },
        provinceId: 35,
     },
     {
        id: 546,
        code: '4718',
        text: 'ภูพาน',
        value: 'ภูพาน',
        name: {
          th: 'ภูพาน',
          en: 'Phu Phan',
        },
        provinceId: 35,
     },
     {
        id: 547,
        code: '4751',
        text: 'วานรนิวาส (สาขาตำบลกุดเรือคำ)',
        value: 'วานรนิวาส (สาขาตำบลกุดเรือคำ)',
        name: {
          th: 'วานรนิวาส (สาขาตำบลกุดเรือคำ)',
          en: 'Wanon Niwat',
        },
        provinceId: 35,
     },
     {
        id: 548,
        code: '4781',
        text: 'อ.บ้านหัน  จ.สกลนคร',
        value: 'อ.บ้านหัน  จ.สกลนคร',
        name: {
          th: 'อ.บ้านหัน  จ.สกลนคร',
          en: 'Banhan',
        },
        provinceId: 35,
     },
     {
        id: 549,
        code: '4801',
        text: 'เมืองนครพนม',
        value: 'เมืองนครพนม',
        name: {
          th: 'เมืองนครพนม',
          en: 'Mueang Nakhon Phanom',
        },
        provinceId: 36,
     },
     {
        id: 550,
        code: '4802',
        text: 'ปลาปาก',
        value: 'ปลาปาก',
        name: {
          th: 'ปลาปาก',
          en: 'Pla Pak',
        },
        provinceId: 36,
     },
     {
        id: 551,
        code: '4803',
        text: 'ท่าอุเทน',
        value: 'ท่าอุเทน',
        name: {
          th: 'ท่าอุเทน',
          en: ' tha U th en',
        },
        provinceId: 36,
     },
     {
        id: 552,
        code: '4804',
        text: 'บ้านแพง',
        value: 'บ้านแพง',
        name: {
          th: 'บ้านแพง',
          en: 'Ban Pha eng',
        },
        provinceId: 36,
     },
     {
        id: 553,
        code: '4805',
        text: 'ธาตุพนม',
        value: 'ธาตุพนม',
        name: {
          th: 'ธาตุพนม',
          en: ' that Phanom',
        },
        provinceId: 36,
     },
     {
        id: 554,
        code: '4806',
        text: 'เรณูนคร',
        value: 'เรณูนคร',
        name: {
          th: 'เรณูนคร',
          en: 'R enu Nakhon',
        },
        provinceId: 36,
     },
     {
        id: 555,
        code: '4807',
        text: 'นาแก',
        value: 'นาแก',
        name: {
          th: 'นาแก',
          en: 'Na Kae',
        },
        provinceId: 36,
     },
     {
        id: 556,
        code: '4808',
        text: 'ศรีสงคราม',
        value: 'ศรีสงคราม',
        name: {
          th: 'ศรีสงคราม',
          en: 'Si Songkhram',
        },
        provinceId: 36,
     },
     {
        id: 557,
        code: '4809',
        text: 'นาหว้า',
        value: 'นาหว้า',
        name: {
          th: 'นาหว้า',
          en: 'Na Wa',
        },
        provinceId: 36,
     },
     {
        id: 558,
        code: '4810',
        text: 'โพนสวรรค์',
        value: 'โพนสวรรค์',
        name: {
          th: 'โพนสวรรค์',
          en: 'Phon Sawan',
        },
        provinceId: 36,
     },
     {
        id: 559,
        code: '4811',
        text: 'นาทม',
        value: 'นาทม',
        name: {
          th: 'นาทม',
          en: 'Na  thom',
        },
        provinceId: 36,
     },
     {
        id: 560,
        code: '4812',
        text: 'วังยาง',
        value: 'วังยาง',
        name: {
          th: 'วังยาง',
          en: 'Wang Yang',
        },
        provinceId: 36,
     },
     {
        id: 561,
        code: '4901',
        text: 'เมืองมุกดาหาร',
        value: 'เมืองมุกดาหาร',
        name: {
          th: 'เมืองมุกดาหาร',
          en: 'Mueang Mukdahan',
        },
        provinceId: 37,
     },
     {
        id: 562,
        code: '4902',
        text: 'นิคมคำสร้อย',
        value: 'นิคมคำสร้อย',
        name: {
          th: 'นิคมคำสร้อย',
          en: 'Nikhom Kham Soi',
        },
        provinceId: 37,
     },
     {
        id: 563,
        code: '4903',
        text: 'ดอนตาล',
        value: 'ดอนตาล',
        name: {
          th: 'ดอนตาล',
          en: 'Don Tan',
        },
        provinceId: 37,
     },
     {
        id: 564,
        code: '4904',
        text: 'ดงหลวง',
        value: 'ดงหลวง',
        name: {
          th: 'ดงหลวง',
          en: 'Dong Luang',
        },
        provinceId: 37,
     },
     {
        id: 565,
        code: '4905',
        text: 'คำชะอี',
        value: 'คำชะอี',
        name: {
          th: 'คำชะอี',
          en: 'Khamcha-i',
        },
        provinceId: 37,
     },
     {
        id: 566,
        code: '4906',
        text: 'หว้านใหญ่',
        value: 'หว้านใหญ่',
        name: {
          th: 'หว้านใหญ่',
          en: 'Wan Yai',
        },
        provinceId: 37,
     },
     {
        id: 567,
        code: '4907',
        text: 'หนองสูง',
        value: 'หนองสูง',
        name: {
          th: 'หนองสูง',
          en: 'Nong Sung',
        },
        provinceId: 37,
     },
     {
        id: 568,
        code: '5001',
        text: 'เมืองเชียงใหม่',
        value: 'เมืองเชียงใหม่',
        name: {
          th: 'เมืองเชียงใหม่',
          en: 'Mueang Chiang Mai',
        },
        provinceId: 38,
     },
     {
        id: 569,
        code: '5002',
        text: 'จอมทอง',
        value: 'จอมทอง',
        name: {
          th: 'จอมทอง',
          en: 'Chom  thong',
        },
        provinceId: 38,
     },
     {
        id: 570,
        code: '5003',
        text: 'แม่แจ่ม',
        value: 'แม่แจ่ม',
        name: {
          th: 'แม่แจ่ม',
          en: 'Mae Chaem',
        },
        provinceId: 38,
     },
     {
        id: 571,
        code: '5004',
        text: 'เชียงดาว',
        value: 'เชียงดาว',
        name: {
          th: 'เชียงดาว',
          en: 'Chiang Dao',
        },
        provinceId: 38,
     },
     {
        id: 572,
        code: '5005',
        text: 'ดอยสะเก็ด',
        value: 'ดอยสะเก็ด',
        name: {
          th: 'ดอยสะเก็ด',
          en: 'Doi Saket',
        },
        provinceId: 38,
     },
     {
        id: 573,
        code: '5006',
        text: 'แม่แตง',
        value: 'แม่แตง',
        name: {
          th: 'แม่แตง',
          en: 'Mae Ta eng',
        },
        provinceId: 38,
     },
     {
        id: 574,
        code: '5007',
        text: 'แม่ริม',
        value: 'แม่ริม',
        name: {
          th: 'แม่ริม',
          en: 'Mae Rim',
        },
        provinceId: 38,
     },
     {
        id: 575,
        code: '5008',
        text: 'สะเมิง',
        value: 'สะเมิง',
        name: {
          th: 'สะเมิง',
          en: 'Samo eng',
        },
        provinceId: 38,
     },
     {
        id: 576,
        code: '5009',
        text: 'ฝาง',
        value: 'ฝาง',
        name: {
          th: 'ฝาง',
          en: 'Fang',
        },
        provinceId: 38,
     },
     {
        id: 577,
        code: '5010',
        text: 'แม่อาย',
        value: 'แม่อาย',
        name: {
          th: 'แม่อาย',
          en: 'Mae Ai',
        },
        provinceId: 38,
     },
     {
        id: 578,
        code: '5011',
        text: 'พร้าว',
        value: 'พร้าว',
        name: {
          th: 'พร้าว',
          en: 'Phrao',
        },
        provinceId: 38,
     },
     {
        id: 579,
        code: '5012',
        text: 'สันป่าตอง',
        value: 'สันป่าตอง',
        name: {
          th: 'สันป่าตอง',
          en: 'San Pa Tong',
        },
        provinceId: 38,
     },
     {
        id: 580,
        code: '5013',
        text: 'สันกำแพง',
        value: 'สันกำแพง',
        name: {
          th: 'สันกำแพง',
          en: 'San Kampha eng',
        },
        provinceId: 38,
     },
     {
        id: 581,
        code: '5014',
        text: 'สันทราย',
        value: 'สันทราย',
        name: {
          th: 'สันทราย',
          en: 'San Sai',
        },
        provinceId: 38,
     },
     {
        id: 582,
        code: '5015',
        text: 'หางดง',
        value: 'หางดง',
        name: {
          th: 'หางดง',
          en: 'Hang Dong',
        },
        provinceId: 38,
     },
     {
        id: 583,
        code: '5016',
        text: 'ฮอด',
        value: 'ฮอด',
        name: {
          th: 'ฮอด',
          en: 'Hot',
        },
        provinceId: 38,
     },
     {
        id: 584,
        code: '5017',
        text: 'ดอยเต่า',
        value: 'ดอยเต่า',
        name: {
          th: 'ดอยเต่า',
          en: 'Doi Tao',
        },
        provinceId: 38,
     },
     {
        id: 585,
        code: '5018',
        text: 'อมก๋อย',
        value: 'อมก๋อย',
        name: {
          th: 'อมก๋อย',
          en: 'Omkoi',
        },
        provinceId: 38,
     },
     {
        id: 586,
        code: '5019',
        text: 'สารภี',
        value: 'สารภี',
        name: {
          th: 'สารภี',
          en: 'Saraphi',
        },
        provinceId: 38,
     },
     {
        id: 587,
        code: '5020',
        text: 'เวียงแหง',
        value: 'เวียงแหง',
        name: {
          th: 'เวียงแหง',
          en: 'Wiang Ha eng',
        },
        provinceId: 38,
     },
     {
        id: 588,
        code: '5021',
        text: 'ไชยปราการ',
        value: 'ไชยปราการ',
        name: {
          th: 'ไชยปราการ',
          en: 'Chai Prakan',
        },
        provinceId: 38,
     },
     {
        id: 589,
        code: '5022',
        text: 'แม่วาง',
        value: 'แม่วาง',
        name: {
          th: 'แม่วาง',
          en: 'Mae Wang',
        },
        provinceId: 38,
     },
     {
        id: 590,
        code: '5023',
        text: 'แม่ออน',
        value: 'แม่ออน',
        name: {
          th: 'แม่ออน',
          en: 'Mae On',
        },
        provinceId: 38,
     },
     {
        id: 591,
        code: '5024',
        text: 'ดอยหล่อ',
        value: 'ดอยหล่อ',
        name: {
          th: 'ดอยหล่อ',
          en: 'Doi Lo',
        },
        provinceId: 38,
     },
     {
        id: 592,
        code: '5051',
        text: 'เทศบาลนครเชียงใหม่ (สาขาแขวงกาลวิละ)',
        value: 'เทศบาลนครเชียงใหม่ (สาขาแขวงกาลวิละ)',
        name: {
          th: 'เทศบาลนครเชียงใหม่ (สาขาแขวงกาลวิละ)',
          en: 'Tet Saban Nakorn Chiangmai(Kan lawi la)',
        },
        provinceId: 38,
     },
     {
        id: 593,
        code: '5052',
        text: 'เทศบาลนครเชียงใหม่ (สาขาแขวงศรีวิชั)',
        value: 'เทศบาลนครเชียงใหม่ (สาขาแขวงศรีวิชั)',
        name: {
          th: 'เทศบาลนครเชียงใหม่ (สาขาแขวงศรีวิชั)',
          en: 'Tet Saban Nakorn Chiangmai(Sri Wi)',
        },
        provinceId: 38,
     },
     {
        id: 594,
        code: '5053',
        text: 'เทศบาลนครเชียงใหม่ (สาขาเม็งราย)',
        value: 'เทศบาลนครเชียงใหม่ (สาขาเม็งราย)',
        name: {
          th: 'เทศบาลนครเชียงใหม่ (สาขาเม็งราย)',
          en: 'Tet Saban Nakorn Chiangmai(M eng Rai)',
        },
        provinceId: 38,
     },
     {
        id: 595,
        code: '5101',
        text: 'เมืองลำพูน',
        value: 'เมืองลำพูน',
        name: {
          th: 'เมืองลำพูน',
          en: 'Mueang Lamphun',
        },
        provinceId: 39,
     },
     {
        id: 596,
        code: '5102',
        text: 'แม่ทา',
        value: 'แม่ทา',
        name: {
          th: 'แม่ทา',
          en: 'Mae  tha',
        },
        provinceId: 39,
     },
     {
        id: 597,
        code: '5103',
        text: 'บ้านโฮ่ง',
        value: 'บ้านโฮ่ง',
        name: {
          th: 'บ้านโฮ่ง',
          en: 'Ban Hong',
        },
        provinceId: 39,
     },
     {
        id: 598,
        code: '5104',
        text: 'ลี้',
        value: 'ลี้',
        name: {
          th: 'ลี้',
          en: 'Li',
        },
        provinceId: 39,
     },
     {
        id: 599,
        code: '5105',
        text: 'ทุ่งหัวช้าง',
        value: 'ทุ่งหัวช้าง',
        name: {
          th: 'ทุ่งหัวช้าง',
          en: ' thung Hua Chang',
        },
        provinceId: 39,
     },
     {
        id: 600,
        code: '5106',
        text: 'ป่าซาง',
        value: 'ป่าซาง',
        name: {
          th: 'ป่าซาง',
          en: 'Pa Sang',
        },
        provinceId: 39,
     },
     {
        id: 601,
        code: '5107',
        text: 'บ้านธิ',
        value: 'บ้านธิ',
        name: {
          th: 'บ้านธิ',
          en: 'Ban  thi',
        },
        provinceId: 39,
     },
     {
        id: 602,
        code: '5108',
        text: 'เวียงหนองล่อง',
        value: 'เวียงหนองล่อง',
        name: {
          th: 'เวียงหนองล่อง',
          en: 'Wiang Nong Long',
        },
        provinceId: 39,
     },
     {
        id: 603,
        code: '5201',
        text: 'เมืองลำปาง',
        value: 'เมืองลำปาง',
        name: {
          th: 'เมืองลำปาง',
          en: 'Mueang Lampang',
        },
        provinceId: 40,
     },
     {
        id: 604,
        code: '5202',
        text: 'แม่เมาะ',
        value: 'แม่เมาะ',
        name: {
          th: 'แม่เมาะ',
          en: 'Mae Mo',
        },
        provinceId: 40,
     },
     {
        id: 605,
        code: '5203',
        text: 'เกาะคา',
        value: 'เกาะคา',
        name: {
          th: 'เกาะคา',
          en: 'Ko Kha',
        },
        provinceId: 40,
     },
     {
        id: 606,
        code: '5204',
        text: 'เสริมงาม',
        value: 'เสริมงาม',
        name: {
          th: 'เสริมงาม',
          en: 'Soem Ngam',
        },
        provinceId: 40,
     },
     {
        id: 607,
        code: '5205',
        text: 'งาว',
        value: 'งาว',
        name: {
          th: 'งาว',
          en: 'Ngao',
        },
        provinceId: 40,
     },
     {
        id: 608,
        code: '5206',
        text: 'แจ้ห่ม',
        value: 'แจ้ห่ม',
        name: {
          th: 'แจ้ห่ม',
          en: 'Chae Hom',
        },
        provinceId: 40,
     },
     {
        id: 609,
        code: '5207',
        text: 'วังเหนือ',
        value: 'วังเหนือ',
        name: {
          th: 'วังเหนือ',
          en: 'Wang Nuea',
        },
        provinceId: 40,
     },
     {
        id: 610,
        code: '5208',
        text: 'เถิน',
        value: 'เถิน',
        name: {
          th: 'เถิน',
          en: ' tho en',
        },
        provinceId: 40,
     },
     {
        id: 611,
        code: '5209',
        text: 'แม่พริก',
        value: 'แม่พริก',
        name: {
          th: 'แม่พริก',
          en: 'Mae Phrik',
        },
        provinceId: 40,
     },
     {
        id: 612,
        code: '5210',
        text: 'แม่ทะ',
        value: 'แม่ทะ',
        name: {
          th: 'แม่ทะ',
          en: 'Mae  tha',
        },
        provinceId: 40,
     },
     {
        id: 613,
        code: '5211',
        text: 'สบปราบ',
        value: 'สบปราบ',
        name: {
          th: 'สบปราบ',
          en: 'Sop Prap',
        },
        provinceId: 40,
     },
     {
        id: 614,
        code: '5212',
        text: 'ห้างฉัตร',
        value: 'ห้างฉัตร',
        name: {
          th: 'ห้างฉัตร',
          en: 'Hang Chat',
        },
        provinceId: 40,
     },
     {
        id: 615,
        code: '5213',
        text: 'เมืองปาน',
        value: 'เมืองปาน',
        name: {
          th: 'เมืองปาน',
          en: 'Mueang Pan',
        },
        provinceId: 40,
     },
     {
        id: 616,
        code: '5301',
        text: 'เมืองอุตรดิตถ์',
        value: 'เมืองอุตรดิตถ์',
        name: {
          th: 'เมืองอุตรดิตถ์',
          en: 'Mueang Uttaradit',
        },
        provinceId: 41,
     },
     {
        id: 617,
        code: '5302',
        text: 'ตรอน',
        value: 'ตรอน',
        name: {
          th: 'ตรอน',
          en: 'Tron',
        },
        provinceId: 41,
     },
     {
        id: 618,
        code: '5303',
        text: 'ท่าปลา',
        value: 'ท่าปลา',
        name: {
          th: 'ท่าปลา',
          en: ' tha Pla',
        },
        provinceId: 41,
     },
     {
        id: 619,
        code: '5304',
        text: 'น้ำปาด',
        value: 'น้ำปาด',
        name: {
          th: 'น้ำปาด',
          en: 'Nam Pat',
        },
        provinceId: 41,
     },
     {
        id: 620,
        code: '5305',
        text: 'ฟากท่า',
        value: 'ฟากท่า',
        name: {
          th: 'ฟากท่า',
          en: 'Fak  tha',
        },
        provinceId: 41,
     },
     {
        id: 621,
        code: '5306',
        text: 'บ้านโคก',
        value: 'บ้านโคก',
        name: {
          th: 'บ้านโคก',
          en: 'Ban Khok',
        },
        provinceId: 41,
     },
     {
        id: 622,
        code: '5307',
        text: 'พิชัย',
        value: 'พิชัย',
        name: {
          th: 'พิชัย',
          en: 'Phichai',
        },
        provinceId: 41,
     },
     {
        id: 623,
        code: '5308',
        text: 'ลับแล',
        value: 'ลับแล',
        name: {
          th: 'ลับแล',
          en: 'Laplae',
        },
        provinceId: 41,
     },
     {
        id: 624,
        code: '5309',
        text: 'ทองแสนขัน',
        value: 'ทองแสนขัน',
        name: {
          th: 'ทองแสนขัน',
          en: ' thong Sa en Khan',
        },
        provinceId: 41,
     },
     {
        id: 625,
        code: '5401',
        text: 'เมืองแพร่',
        value: 'เมืองแพร่',
        name: {
          th: 'เมืองแพร่',
          en: 'Mueang Phrae',
        },
        provinceId: 42,
     },
     {
        id: 626,
        code: '5402',
        text: 'ร้องกวาง',
        value: 'ร้องกวาง',
        name: {
          th: 'ร้องกวาง',
          en: 'Rong Kwang',
        },
        provinceId: 42,
     },
     {
        id: 627,
        code: '5403',
        text: 'ลอง',
        value: 'ลอง',
        name: {
          th: 'ลอง',
          en: 'Long',
        },
        provinceId: 42,
     },
     {
        id: 628,
        code: '5404',
        text: 'สูงเม่น',
        value: 'สูงเม่น',
        name: {
          th: 'สูงเม่น',
          en: 'Sung M en',
        },
        provinceId: 42,
     },
     {
        id: 629,
        code: '5405',
        text: 'เด่นชัย',
        value: 'เด่นชัย',
        name: {
          th: 'เด่นชัย',
          en: 'D en Chai',
        },
        provinceId: 42,
     },
     {
        id: 630,
        code: '5406',
        text: 'สอง',
        value: 'สอง',
        name: {
          th: 'สอง',
          en: 'Song',
        },
        provinceId: 42,
     },
     {
        id: 631,
        code: '5407',
        text: 'วังชิ้น',
        value: 'วังชิ้น',
        name: {
          th: 'วังชิ้น',
          en: 'Wang Chin',
        },
        provinceId: 42,
     },
     {
        id: 632,
        code: '5408',
        text: 'หนองม่วงไข่',
        value: 'หนองม่วงไข่',
        name: {
          th: 'หนองม่วงไข่',
          en: 'Nong Muang Khai',
        },
        provinceId: 42,
     },
     {
        id: 633,
        code: '5501',
        text: 'เมืองน่าน',
        value: 'เมืองน่าน',
        name: {
          th: 'เมืองน่าน',
          en: 'Mueang Nan',
        },
        provinceId: 43,
     },
     {
        id: 634,
        code: '5502',
        text: 'แม่จริม',
        value: 'แม่จริม',
        name: {
          th: 'แม่จริม',
          en: 'Mae Charim',
        },
        provinceId: 43,
     },
     {
        id: 635,
        code: '5503',
        text: 'บ้านหลวง',
        value: 'บ้านหลวง',
        name: {
          th: 'บ้านหลวง',
          en: 'Ban Luang',
        },
        provinceId: 43,
     },
     {
        id: 636,
        code: '5504',
        text: 'นาน้อย',
        value: 'นาน้อย',
        name: {
          th: 'นาน้อย',
          en: 'Na Noi',
        },
        provinceId: 43,
     },
     {
        id: 637,
        code: '5505',
        text: 'ปัว',
        value: 'ปัว',
        name: {
          th: 'ปัว',
          en: 'Pua',
        },
        provinceId: 43,
     },
     {
        id: 638,
        code: '5506',
        text: 'ท่าวังผา',
        value: 'ท่าวังผา',
        name: {
          th: 'ท่าวังผา',
          en: ' tha Wang Pha',
        },
        provinceId: 43,
     },
     {
        id: 639,
        code: '5507',
        text: 'เวียงสา',
        value: 'เวียงสา',
        name: {
          th: 'เวียงสา',
          en: 'Wiang Sa',
        },
        provinceId: 43,
     },
     {
        id: 640,
        code: '5508',
        text: 'ทุ่งช้าง',
        value: 'ทุ่งช้าง',
        name: {
          th: 'ทุ่งช้าง',
          en: ' thung Chang',
        },
        provinceId: 43,
     },
     {
        id: 641,
        code: '5509',
        text: 'เชียงกลาง',
        value: 'เชียงกลาง',
        name: {
          th: 'เชียงกลาง',
          en: 'Chiang Klang',
        },
        provinceId: 43,
     },
     {
        id: 642,
        code: '5510',
        text: 'นาหมื่น',
        value: 'นาหมื่น',
        name: {
          th: 'นาหมื่น',
          en: 'Na Mu en',
        },
        provinceId: 43,
     },
     {
        id: 643,
        code: '5511',
        text: 'สันติสุข',
        value: 'สันติสุข',
        name: {
          th: 'สันติสุข',
          en: 'Santi Suk',
        },
        provinceId: 43,
     },
     {
        id: 644,
        code: '5512',
        text: 'บ่อเกลือ',
        value: 'บ่อเกลือ',
        name: {
          th: 'บ่อเกลือ',
          en: 'Bo Kluea',
        },
        provinceId: 43,
     },
     {
        id: 645,
        code: '5513',
        text: 'สองแคว',
        value: 'สองแคว',
        name: {
          th: 'สองแคว',
          en: 'Song Khwae',
        },
        provinceId: 43,
     },
     {
        id: 646,
        code: '5514',
        text: 'ภูเพียง',
        value: 'ภูเพียง',
        name: {
          th: 'ภูเพียง',
          en: 'Phu Phiang',
        },
        provinceId: 43,
     },
     {
        id: 647,
        code: '5515',
        text: 'เฉลิมพระเกียรติ',
        value: 'เฉลิมพระเกียรติ',
        name: {
          th: 'เฉลิมพระเกียรติ',
          en: 'Chaloem Phra Kiat',
        },
        provinceId: 43,
     },
     {
        id: 648,
        code: '5601',
        text: 'เมืองพะเยา',
        value: 'เมืองพะเยา',
        name: {
          th: 'เมืองพะเยา',
          en: 'Mueang Phayao',
        },
        provinceId: 44,
     },
     {
        id: 649,
        code: '5602',
        text: 'จุน',
        value: 'จุน',
        name: {
          th: 'จุน',
          en: 'Chun',
        },
        provinceId: 44,
     },
     {
        id: 650,
        code: '5603',
        text: 'เชียงคำ',
        value: 'เชียงคำ',
        name: {
          th: 'เชียงคำ',
          en: 'Chiang Kham',
        },
        provinceId: 44,
     },
     {
        id: 651,
        code: '5604',
        text: 'เชียงม่วน',
        value: 'เชียงม่วน',
        name: {
          th: 'เชียงม่วน',
          en: 'Chiang Muan',
        },
        provinceId: 44,
     },
     {
        id: 652,
        code: '5605',
        text: 'ดอกคำใต้',
        value: 'ดอกคำใต้',
        name: {
          th: 'ดอกคำใต้',
          en: 'Dok Khamtai',
        },
        provinceId: 44,
     },
     {
        id: 653,
        code: '5606',
        text: 'ปง',
        value: 'ปง',
        name: {
          th: 'ปง',
          en: 'Pong',
        },
        provinceId: 44,
     },
     {
        id: 654,
        code: '5607',
        text: 'แม่ใจ',
        value: 'แม่ใจ',
        name: {
          th: 'แม่ใจ',
          en: 'Mae Chai',
        },
        provinceId: 44,
     },
     {
        id: 655,
        code: '5608',
        text: 'ภูซาง',
        value: 'ภูซาง',
        name: {
          th: 'ภูซาง',
          en: 'Phu Sang',
        },
        provinceId: 44,
     },
     {
        id: 656,
        code: '5609',
        text: 'ภูกามยาว',
        value: 'ภูกามยาว',
        name: {
          th: 'ภูกามยาว',
          en: 'Phu Kamyao',
        },
        provinceId: 44,
     },
     {
        id: 657,
        code: '5701',
        text: 'เมืองเชียงราย',
        value: 'เมืองเชียงราย',
        name: {
          th: 'เมืองเชียงราย',
          en: 'Mueang Chiang Rai',
        },
        provinceId: 45,
     },
     {
        id: 658,
        code: '5702',
        text: 'เวียงชัย',
        value: 'เวียงชัย',
        name: {
          th: 'เวียงชัย',
          en: 'Wiang Chai',
        },
        provinceId: 45,
     },
     {
        id: 659,
        code: '5703',
        text: 'เชียงของ',
        value: 'เชียงของ',
        name: {
          th: 'เชียงของ',
          en: 'Chiang Khong',
        },
        provinceId: 45,
     },
     {
        id: 660,
        code: '5704',
        text: 'เทิง',
        value: 'เทิง',
        name: {
          th: 'เทิง',
          en: ' tho eng',
        },
        provinceId: 45,
     },
     {
        id: 661,
        code: '5705',
        text: 'พาน',
        value: 'พาน',
        name: {
          th: 'พาน',
          en: 'Phan',
        },
        provinceId: 45,
     },
     {
        id: 662,
        code: '5706',
        text: 'ป่าแดด',
        value: 'ป่าแดด',
        name: {
          th: 'ป่าแดด',
          en: 'Pa Daet',
        },
        provinceId: 45,
     },
     {
        id: 663,
        code: '5707',
        text: 'แม่จัน',
        value: 'แม่จัน',
        name: {
          th: 'แม่จัน',
          en: 'Mae Chan',
        },
        provinceId: 45,
     },
     {
        id: 664,
        code: '5708',
        text: 'เชียงแสน',
        value: 'เชียงแสน',
        name: {
          th: 'เชียงแสน',
          en: 'Chiang Sa en',
        },
        provinceId: 45,
     },
     {
        id: 665,
        code: '5709',
        text: 'แม่สาย',
        value: 'แม่สาย',
        name: {
          th: 'แม่สาย',
          en: 'Mae Sai',
        },
        provinceId: 45,
     },
     {
        id: 666,
        code: '5710',
        text: 'แม่สรวย',
        value: 'แม่สรวย',
        name: {
          th: 'แม่สรวย',
          en: 'Mae Suai',
        },
        provinceId: 45,
     },
     {
        id: 667,
        code: '5711',
        text: 'เวียงป่าเป้า',
        value: 'เวียงป่าเป้า',
        name: {
          th: 'เวียงป่าเป้า',
          en: 'Wiang Pa Pao',
        },
        provinceId: 45,
     },
     {
        id: 668,
        code: '5712',
        text: 'พญาเม็งราย',
        value: 'พญาเม็งราย',
        name: {
          th: 'พญาเม็งราย',
          en: 'Phaya M engrai',
        },
        provinceId: 45,
     },
     {
        id: 669,
        code: '5713',
        text: 'เวียงแก่น',
        value: 'เวียงแก่น',
        name: {
          th: 'เวียงแก่น',
          en: 'Wiang Ka en',
        },
        provinceId: 45,
     },
     {
        id: 670,
        code: '5714',
        text: 'ขุนตาล',
        value: 'ขุนตาล',
        name: {
          th: 'ขุนตาล',
          en: 'Khun Tan',
        },
        provinceId: 45,
     },
     {
        id: 671,
        code: '5715',
        text: 'แม่ฟ้าหลวง',
        value: 'แม่ฟ้าหลวง',
        name: {
          th: 'แม่ฟ้าหลวง',
          en: 'Mae Fa Luang',
        },
        provinceId: 45,
     },
     {
        id: 672,
        code: '5716',
        text: 'แม่ลาว',
        value: 'แม่ลาว',
        name: {
          th: 'แม่ลาว',
          en: 'Mae Lao',
        },
        provinceId: 45,
     },
     {
        id: 673,
        code: '5717',
        text: 'เวียงเชียงรุ้ง',
        value: 'เวียงเชียงรุ้ง',
        name: {
          th: 'เวียงเชียงรุ้ง',
          en: 'Wiang Chiang Rung',
        },
        provinceId: 45,
     },
     {
        id: 674,
        code: '5718',
        text: 'ดอยหลวง',
        value: 'ดอยหลวง',
        name: {
          th: 'ดอยหลวง',
          en: 'Doi Luang',
        },
        provinceId: 45,
     },
     {
        id: 675,
        code: '5801',
        text: 'เมืองแม่ฮ่องสอน',
        value: 'เมืองแม่ฮ่องสอน',
        name: {
          th: 'เมืองแม่ฮ่องสอน',
          en: 'Mueang Mae Hong Son',
        },
        provinceId: 46,
     },
     {
        id: 676,
        code: '5802',
        text: 'ขุนยวม',
        value: 'ขุนยวม',
        name: {
          th: 'ขุนยวม',
          en: 'Khun Yuam',
        },
        provinceId: 46,
     },
     {
        id: 677,
        code: '5803',
        text: 'ปาย',
        value: 'ปาย',
        name: {
          th: 'ปาย',
          en: 'Pai',
        },
        provinceId: 46,
     },
     {
        id: 678,
        code: '5804',
        text: 'แม่สะเรียง',
        value: 'แม่สะเรียง',
        name: {
          th: 'แม่สะเรียง',
          en: 'Mae Sariang',
        },
        provinceId: 46,
     },
     {
        id: 679,
        code: '5805',
        text: 'แม่ลาน้อย',
        value: 'แม่ลาน้อย',
        name: {
          th: 'แม่ลาน้อย',
          en: 'Mae La Noi',
        },
        provinceId: 46,
     },
     {
        id: 680,
        code: '5806',
        text: 'สบเมย',
        value: 'สบเมย',
        name: {
          th: 'สบเมย',
          en: 'Sop Moei',
        },
        provinceId: 46,
     },
     {
        id: 681,
        code: '5807',
        text: 'ปางมะผ้า',
        value: 'ปางมะผ้า',
        name: {
          th: 'ปางมะผ้า',
          en: 'Pang Mapha',
        },
        provinceId: 46,
     },
     {
        id: 682,
        code: '5881',
        text: 'อ.ม่วยต่อ  จ.แม่ฮ่องสอน',
        value: 'อ.ม่วยต่อ  จ.แม่ฮ่องสอน',
        name: {
          th: 'อ.ม่วยต่อ  จ.แม่ฮ่องสอน',
          en: 'Mu en Tor',
        },
        provinceId: 46,
     },
     {
        id: 683,
        code: '6001',
        text: 'เมืองนครสวรรค์',
        value: 'เมืองนครสวรรค์',
        name: {
          th: 'เมืองนครสวรรค์',
          en: 'Mueang Nakhon Sawan',
        },
        provinceId: 47,
     },
     {
        id: 684,
        code: '6002',
        text: 'โกรกพระ',
        value: 'โกรกพระ',
        name: {
          th: 'โกรกพระ',
          en: 'Krok Phra',
        },
        provinceId: 47,
     },
     {
        id: 685,
        code: '6003',
        text: 'ชุมแสง',
        value: 'ชุมแสง',
        name: {
          th: 'ชุมแสง',
          en: 'Chum Sa eng',
        },
        provinceId: 47,
     },
     {
        id: 686,
        code: '6004',
        text: 'หนองบัว',
        value: 'หนองบัว',
        name: {
          th: 'หนองบัว',
          en: 'Nong Bua',
        },
        provinceId: 47,
     },
     {
        id: 687,
        code: '6005',
        text: 'บรรพตพิสัย',
        value: 'บรรพตพิสัย',
        name: {
          th: 'บรรพตพิสัย',
          en: 'Banphot Phisai',
        },
        provinceId: 47,
     },
     {
        id: 688,
        code: '6006',
        text: 'เก้าเลี้ยว',
        value: 'เก้าเลี้ยว',
        name: {
          th: 'เก้าเลี้ยว',
          en: 'Kao Liao',
        },
        provinceId: 47,
     },
     {
        id: 689,
        code: '6007',
        text: 'ตาคลี',
        value: 'ตาคลี',
        name: {
          th: 'ตาคลี',
          en: 'Takhli',
        },
        provinceId: 47,
     },
     {
        id: 690,
        code: '6008',
        text: 'ท่าตะโก',
        value: 'ท่าตะโก',
        name: {
          th: 'ท่าตะโก',
          en: 'Takhli',
        },
        provinceId: 47,
     },
     {
        id: 691,
        code: '6009',
        text: 'ไพศาลี',
        value: 'ไพศาลี',
        name: {
          th: 'ไพศาลี',
          en: 'Phaisali',
        },
        provinceId: 47,
     },
     {
        id: 692,
        code: '6010',
        text: 'พยุหะคีรี',
        value: 'พยุหะคีรี',
        name: {
          th: 'พยุหะคีรี',
          en: 'Phayuha Khiri',
        },
        provinceId: 47,
     },
     {
        id: 693,
        code: '6011',
        text: 'ลาดยาว',
        value: 'ลาดยาว',
        name: {
          th: 'ลาดยาว',
          en: 'Phayuha Khiri',
        },
        provinceId: 47,
     },
     {
        id: 694,
        code: '6012',
        text: 'ตากฟ้า',
        value: 'ตากฟ้า',
        name: {
          th: 'ตากฟ้า',
          en: 'Tak Fa',
        },
        provinceId: 47,
     },
     {
        id: 695,
        code: '6013',
        text: 'แม่วงก์',
        value: 'แม่วงก์',
        name: {
          th: 'แม่วงก์',
          en: 'Mae Wong',
        },
        provinceId: 47,
     },
     {
        id: 696,
        code: '6014',
        text: 'แม่เปิน',
        value: 'แม่เปิน',
        name: {
          th: 'แม่เปิน',
          en: 'Mae Po en',
        },
        provinceId: 47,
     },
     {
        id: 697,
        code: '6015',
        text: 'ชุมตาบง',
        value: 'ชุมตาบง',
        name: {
          th: 'ชุมตาบง',
          en: 'Chum Ta Bong',
        },
        provinceId: 47,
     },
     {
        id: 698,
        code: '6051',
        text: 'สาขาตำบลห้วยน้ำหอม',
        value: 'สาขาตำบลห้วยน้ำหอม',
        name: {
          th: 'สาขาตำบลห้วยน้ำหอม',
          en: 'Hu en Nam Hom',
        },
        provinceId: 47,
     },
     {
        id: 699,
        code: '6052',
        text: 'กิ่งอำเภอชุมตาบง (สาขาตำบลชุมตาบง)',
        value: 'กิ่งอำเภอชุมตาบง (สาขาตำบลชุมตาบง)',
        name: {
          th: 'กิ่งอำเภอชุมตาบง (สาขาตำบลชุมตาบง)',
          en: 'Chum Ta Bong',
        },
        provinceId: 47,
     },
     {
        id: 700,
        code: '6053',
        text: 'แม่วงก์ (สาขาตำบลแม่เล่ย์)',
        value: 'แม่วงก์ (สาขาตำบลแม่เล่ย์)',
        name: {
          th: 'แม่วงก์ (สาขาตำบลแม่เล่ย์)',
          en: 'Mea Ley',
        },
        provinceId: 47,
     },
     {
        id: 701,
        code: '6101',
        text: 'เมืองอุทัยธานี',
        value: 'เมืองอุทัยธานี',
        name: {
          th: 'เมืองอุทัยธานี',
          en: 'Mueang U thai  thani',
        },
        provinceId: 48,
     },
     {
        id: 702,
        code: '6102',
        text: 'ทัพทัน',
        value: 'ทัพทัน',
        name: {
          th: 'ทัพทัน',
          en: ' thap  than',
        },
        provinceId: 48,
     },
     {
        id: 703,
        code: '6103',
        text: 'สว่างอารมณ์',
        value: 'สว่างอารมณ์',
        name: {
          th: 'สว่างอารมณ์',
          en: 'Sawang Arom',
        },
        provinceId: 48,
     },
     {
        id: 704,
        code: '6104',
        text: 'หนองฉาง',
        value: 'หนองฉาง',
        name: {
          th: 'หนองฉาง',
          en: 'Nong Chang',
        },
        provinceId: 48,
     },
     {
        id: 705,
        code: '6105',
        text: 'หนองขาหย่าง',
        value: 'หนองขาหย่าง',
        name: {
          th: 'หนองขาหย่าง',
          en: 'Nong Khayang',
        },
        provinceId: 48,
     },
     {
        id: 706,
        code: '6106',
        text: 'บ้านไร่',
        value: 'บ้านไร่',
        name: {
          th: 'บ้านไร่',
          en: 'Ban Rai',
        },
        provinceId: 48,
     },
     {
        id: 707,
        code: '6107',
        text: 'ลานสัก',
        value: 'ลานสัก',
        name: {
          th: 'ลานสัก',
          en: 'Lan Sak',
        },
        provinceId: 48,
     },
     {
        id: 708,
        code: '6108',
        text: 'ห้วยคต',
        value: 'ห้วยคต',
        name: {
          th: 'ห้วยคต',
          en: 'Huai Khot',
        },
        provinceId: 48,
     },
     {
        id: 709,
        code: '6201',
        text: 'เมืองกำแพงเพชร',
        value: 'เมืองกำแพงเพชร',
        name: {
          th: 'เมืองกำแพงเพชร',
          en: 'Mueang Kampha eng Phet',
        },
        provinceId: 49,
     },
     {
        id: 710,
        code: '6202',
        text: 'ไทรงาม',
        value: 'ไทรงาม',
        name: {
          th: 'ไทรงาม',
          en: 'Sai Ngam',
        },
        provinceId: 49,
     },
     {
        id: 711,
        code: '6203',
        text: 'คลองลาน',
        value: 'คลองลาน',
        name: {
          th: 'คลองลาน',
          en: 'Khlong Lan',
        },
        provinceId: 49,
     },
     {
        id: 712,
        code: '6204',
        text: 'ขาณุวรลักษบุรี',
        value: 'ขาณุวรลักษบุรี',
        name: {
          th: 'ขาณุวรลักษบุรี',
          en: 'Khanu Woralaksaburi',
        },
        provinceId: 49,
     },
     {
        id: 713,
        code: '6205',
        text: 'คลองขลุง',
        value: 'คลองขลุง',
        name: {
          th: 'คลองขลุง',
          en: 'Khlong Khlung',
        },
        provinceId: 49,
     },
     {
        id: 714,
        code: '6206',
        text: 'พรานกระต่าย',
        value: 'พรานกระต่าย',
        name: {
          th: 'พรานกระต่าย',
          en: 'Phran Kratai',
        },
        provinceId: 49,
     },
     {
        id: 715,
        code: '6207',
        text: 'ลานกระบือ',
        value: 'ลานกระบือ',
        name: {
          th: 'ลานกระบือ',
          en: 'Lan Krabue',
        },
        provinceId: 49,
     },
     {
        id: 716,
        code: '6208',
        text: 'ทรายทองวัฒนา',
        value: 'ทรายทองวัฒนา',
        name: {
          th: 'ทรายทองวัฒนา',
          en: 'Sai  thong Wat thana',
        },
        provinceId: 49,
     },
     {
        id: 717,
        code: '6209',
        text: 'ปางศิลาทอง',
        value: 'ปางศิลาทอง',
        name: {
          th: 'ปางศิลาทอง',
          en: 'Pang Sila  thong',
        },
        provinceId: 49,
     },
     {
        id: 718,
        code: '6210',
        text: 'บึงสามัคคี',
        value: 'บึงสามัคคี',
        name: {
          th: 'บึงสามัคคี',
          en: 'Bu eng Samakkhi',
        },
        provinceId: 49,
     },
     {
        id: 719,
        code: '6211',
        text: 'โกสัมพีนคร',
        value: 'โกสัมพีนคร',
        name: {
          th: 'โกสัมพีนคร',
          en: 'Kosamphi Nakhon',
        },
        provinceId: 49,
     },
     {
        id: 720,
        code: '6301',
        text: 'เมืองตาก',
        value: 'เมืองตาก',
        name: {
          th: 'เมืองตาก',
          en: 'Mueang Tak',
        },
        provinceId: 50,
     },
     {
        id: 721,
        code: '6302',
        text: 'บ้านตาก',
        value: 'บ้านตาก',
        name: {
          th: 'บ้านตาก',
          en: 'Ban Tak',
        },
        provinceId: 50,
     },
     {
        id: 722,
        code: '6303',
        text: 'สามเงา',
        value: 'สามเงา',
        name: {
          th: 'สามเงา',
          en: 'Sam Ngao',
        },
        provinceId: 50,
     },
     {
        id: 723,
        code: '6304',
        text: 'แม่ระมาด',
        value: 'แม่ระมาด',
        name: {
          th: 'แม่ระมาด',
          en: 'Mae Ramat',
        },
        provinceId: 50,
     },
     {
        id: 724,
        code: '6305',
        text: 'ท่าสองยาง',
        value: 'ท่าสองยาง',
        name: {
          th: 'ท่าสองยาง',
          en: ' tha Song Yang',
        },
        provinceId: 50,
     },
     {
        id: 725,
        code: '6306',
        text: 'แม่สอด',
        value: 'แม่สอด',
        name: {
          th: 'แม่สอด',
          en: 'Mae Sot',
        },
        provinceId: 50,
     },
     {
        id: 726,
        code: '6307',
        text: 'พบพระ',
        value: 'พบพระ',
        name: {
          th: 'พบพระ',
          en: 'Phop Phra',
        },
        provinceId: 50,
     },
     {
        id: 727,
        code: '6308',
        text: 'อุ้มผาง',
        value: 'อุ้มผาง',
        name: {
          th: 'อุ้มผาง',
          en: 'Umphang',
        },
        provinceId: 50,
     },
     {
        id: 728,
        code: '6309',
        text: 'วังเจ้า',
        value: 'วังเจ้า',
        name: {
          th: 'วังเจ้า',
          en: 'Wang Chao',
        },
        provinceId: 50,
     },
     {
        id: 729,
        code: '6381',
        text: 'กิ่ง อ.ท่าปุย  จ.ตาก',
        value: 'กิ่ง อ.ท่าปุย  จ.ตาก',
        name: {
          th: 'กิ่ง อ.ท่าปุย  จ.ตาก',
          en: 'King Ta Pui',
        },
        provinceId: 50,
     },
     {
        id: 730,
        code: '6401',
        text: 'เมืองสุโขทัย',
        value: 'เมืองสุโขทัย',
        name: {
          th: 'เมืองสุโขทัย',
          en: 'Mueang Sukho thai',
        },
        provinceId: 51,
     },
     {
        id: 731,
        code: '6402',
        text: 'บ้านด่านลานหอย',
        value: 'บ้านด่านลานหอย',
        name: {
          th: 'บ้านด่านลานหอย',
          en: 'Ban Dan Lan Hoi',
        },
        provinceId: 51,
     },
     {
        id: 732,
        code: '6403',
        text: 'คีรีมาศ',
        value: 'คีรีมาศ',
        name: {
          th: 'คีรีมาศ',
          en: 'Khiri Mat',
        },
        provinceId: 51,
     },
     {
        id: 733,
        code: '6404',
        text: 'กงไกรลาศ',
        value: 'กงไกรลาศ',
        name: {
          th: 'กงไกรลาศ',
          en: 'Kong Krailat',
        },
        provinceId: 51,
     },
     {
        id: 734,
        code: '6405',
        text: 'ศรีสัชนาลัย',
        value: 'ศรีสัชนาลัย',
        name: {
          th: 'ศรีสัชนาลัย',
          en: 'Si Satchanalai',
        },
        provinceId: 51,
     },
     {
        id: 735,
        code: '6406',
        text: 'ศรีสำโรง',
        value: 'ศรีสำโรง',
        name: {
          th: 'ศรีสำโรง',
          en: 'Si Samrong',
        },
        provinceId: 51,
     },
     {
        id: 736,
        code: '6407',
        text: 'สวรรคโลก',
        value: 'สวรรคโลก',
        name: {
          th: 'สวรรคโลก',
          en: 'Sawankhalok',
        },
        provinceId: 51,
     },
     {
        id: 737,
        code: '6408',
        text: 'ศรีนคร',
        value: 'ศรีนคร',
        name: {
          th: 'ศรีนคร',
          en: 'Si Nakhon',
        },
        provinceId: 51,
     },
     {
        id: 738,
        code: '6409',
        text: 'ทุ่งเสลี่ยม',
        value: 'ทุ่งเสลี่ยม',
        name: {
          th: 'ทุ่งเสลี่ยม',
          en: ' thung Saliam',
        },
        provinceId: 51,
     },
     {
        id: 739,
        code: '6501',
        text: 'เมืองพิษณุโลก',
        value: 'เมืองพิษณุโลก',
        name: {
          th: 'เมืองพิษณุโลก',
          en: 'Mueang Phitsanulok',
        },
        provinceId: 52,
     },
     {
        id: 740,
        code: '6502',
        text: 'นครไทย',
        value: 'นครไทย',
        name: {
          th: 'นครไทย',
          en: 'Nakhon  thai',
        },
        provinceId: 52,
     },
     {
        id: 741,
        code: '6503',
        text: 'ชาติตระการ',
        value: 'ชาติตระการ',
        name: {
          th: 'ชาติตระการ',
          en: 'Chat Trakan',
        },
        provinceId: 52,
     },
     {
        id: 742,
        code: '6504',
        text: 'บางระกำ',
        value: 'บางระกำ',
        name: {
          th: 'บางระกำ',
          en: 'Bang Rakam',
        },
        provinceId: 52,
     },
     {
        id: 743,
        code: '6505',
        text: 'บางกระทุ่ม',
        value: 'บางกระทุ่ม',
        name: {
          th: 'บางกระทุ่ม',
          en: 'Bang Kra thum',
        },
        provinceId: 52,
     },
     {
        id: 744,
        code: '6506',
        text: 'พรหมพิราม',
        value: 'พรหมพิราม',
        name: {
          th: 'พรหมพิราม',
          en: 'Phrom Phiram',
        },
        provinceId: 52,
     },
     {
        id: 745,
        code: '6507',
        text: 'วัดโบสถ์',
        value: 'วัดโบสถ์',
        name: {
          th: 'วัดโบสถ์',
          en: 'Wat Bot',
        },
        provinceId: 52,
     },
     {
        id: 746,
        code: '6508',
        text: 'วังทอง',
        value: 'วังทอง',
        name: {
          th: 'วังทอง',
          en: 'Wang  thong',
        },
        provinceId: 52,
     },
     {
        id: 747,
        code: '6509',
        text: 'เนินมะปราง',
        value: 'เนินมะปราง',
        name: {
          th: 'เนินมะปราง',
          en: 'No en Maprang',
        },
        provinceId: 52,
     },
     {
        id: 748,
        code: '6601',
        text: 'เมืองพิจิตร',
        value: 'เมืองพิจิตร',
        name: {
          th: 'เมืองพิจิตร',
          en: 'Mueang Phichit',
        },
        provinceId: 53,
     },
     {
        id: 749,
        code: '6602',
        text: 'วังทรายพูน',
        value: 'วังทรายพูน',
        name: {
          th: 'วังทรายพูน',
          en: 'Wang Sai Phun',
        },
        provinceId: 53,
     },
     {
        id: 750,
        code: '6603',
        text: 'โพธิ์ประทับช้าง',
        value: 'โพธิ์ประทับช้าง',
        name: {
          th: 'โพธิ์ประทับช้าง',
          en: 'Pho Pra thap Chang',
        },
        provinceId: 53,
     },
     {
        id: 751,
        code: '6604',
        text: 'ตะพานหิน',
        value: 'ตะพานหิน',
        name: {
          th: 'ตะพานหิน',
          en: 'Taphan Hin',
        },
        provinceId: 53,
     },
     {
        id: 752,
        code: '6605',
        text: 'บางมูลนาก',
        value: 'บางมูลนาก',
        name: {
          th: 'บางมูลนาก',
          en: 'Bang Mun Nak',
        },
        provinceId: 53,
     },
     {
        id: 753,
        code: '6606',
        text: 'โพทะเล',
        value: 'โพทะเล',
        name: {
          th: 'โพทะเล',
          en: 'Pho  thale',
        },
        provinceId: 53,
     },
     {
        id: 754,
        code: '6607',
        text: 'สามง่าม',
        value: 'สามง่าม',
        name: {
          th: 'สามง่าม',
          en: 'Sam Ngam',
        },
        provinceId: 53,
     },
     {
        id: 755,
        code: '6608',
        text: 'ทับคล้อ',
        value: 'ทับคล้อ',
        name: {
          th: 'ทับคล้อ',
          en: 'Tap Khlo',
        },
        provinceId: 53,
     },
     {
        id: 756,
        code: '6609',
        text: 'สากเหล็ก',
        value: 'สากเหล็ก',
        name: {
          th: 'สากเหล็ก',
          en: 'Sak Lek',
        },
        provinceId: 53,
     },
     {
        id: 757,
        code: '6610',
        text: 'บึงนาราง',
        value: 'บึงนาราง',
        name: {
          th: 'บึงนาราง',
          en: 'Bu eng Na Rang',
        },
        provinceId: 53,
     },
     {
        id: 758,
        code: '6611',
        text: 'ดงเจริญ',
        value: 'ดงเจริญ',
        name: {
          th: 'ดงเจริญ',
          en: 'Dong Charo en',
        },
        provinceId: 53,
     },
     {
        id: 759,
        code: '6612',
        text: 'วชิรบารมี',
        value: 'วชิรบารมี',
        name: {
          th: 'วชิรบารมี',
          en: 'Wachirabarami',
        },
        provinceId: 53,
     },
     {
        id: 760,
        code: '6701',
        text: 'เมืองเพชรบูรณ์',
        value: 'เมืองเพชรบูรณ์',
        name: {
          th: 'เมืองเพชรบูรณ์',
          en: 'Mueang Phetchabun',
        },
        provinceId: 54,
     },
     {
        id: 761,
        code: '6702',
        text: 'ชนแดน',
        value: 'ชนแดน',
        name: {
          th: 'ชนแดน',
          en: 'Chon Da en',
        },
        provinceId: 54,
     },
     {
        id: 762,
        code: '6703',
        text: 'หล่มสัก',
        value: 'หล่มสัก',
        name: {
          th: 'หล่มสัก',
          en: 'Lom Sak',
        },
        provinceId: 54,
     },
     {
        id: 763,
        code: '6704',
        text: 'หล่มเก่า',
        value: 'หล่มเก่า',
        name: {
          th: 'หล่มเก่า',
          en: 'Lom Kao',
        },
        provinceId: 54,
     },
     {
        id: 764,
        code: '6705',
        text: 'วิเชียรบุรี',
        value: 'วิเชียรบุรี',
        name: {
          th: 'วิเชียรบุรี',
          en: 'Wichian Buri',
        },
        provinceId: 54,
     },
     {
        id: 765,
        code: '6706',
        text: 'ศรีเทพ',
        value: 'ศรีเทพ',
        name: {
          th: 'ศรีเทพ',
          en: 'Si  thep',
        },
        provinceId: 54,
     },
     {
        id: 766,
        code: '6707',
        text: 'หนองไผ่',
        value: 'หนองไผ่',
        name: {
          th: 'หนองไผ่',
          en: 'Nong Phai',
        },
        provinceId: 54,
     },
     {
        id: 767,
        code: '6708',
        text: 'บึงสามพัน',
        value: 'บึงสามพัน',
        name: {
          th: 'บึงสามพัน',
          en: 'Bu eng Sam Phan',
        },
        provinceId: 54,
     },
     {
        id: 768,
        code: '6709',
        text: 'น้ำหนาว',
        value: 'น้ำหนาว',
        name: {
          th: 'น้ำหนาว',
          en: 'Nam Nao',
        },
        provinceId: 54,
     },
     {
        id: 769,
        code: '6710',
        text: 'วังโป่ง',
        value: 'วังโป่ง',
        name: {
          th: 'วังโป่ง',
          en: 'Wang Pong',
        },
        provinceId: 54,
     },
     {
        id: 770,
        code: '6711',
        text: 'เขาค้อ',
        value: 'เขาค้อ',
        name: {
          th: 'เขาค้อ',
          en: 'Khao Kho',
        },
        provinceId: 54,
     },
     {
        id: 771,
        code: '7001',
        text: 'เมืองราชบุรี',
        value: 'เมืองราชบุรี',
        name: {
          th: 'เมืองราชบุรี',
          en: 'Mueang Ratchaburi',
        },
        provinceId: 55,
     },
     {
        id: 772,
        code: '7002',
        text: 'จอมบึง',
        value: 'จอมบึง',
        name: {
          th: 'จอมบึง',
          en: 'Chom Bu eng',
        },
        provinceId: 55,
     },
     {
        id: 773,
        code: '7003',
        text: 'สวนผึ้ง',
        value: 'สวนผึ้ง',
        name: {
          th: 'สวนผึ้ง',
          en: 'Suan Phu eng',
        },
        provinceId: 55,
     },
     {
        id: 774,
        code: '7004',
        text: 'ดำเนินสะดวก',
        value: 'ดำเนินสะดวก',
        name: {
          th: 'ดำเนินสะดวก',
          en: 'Damno en Saduak',
        },
        provinceId: 55,
     },
     {
        id: 775,
        code: '7005',
        text: 'บ้านโป่ง',
        value: 'บ้านโป่ง',
        name: {
          th: 'บ้านโป่ง',
          en: 'Ban Pong',
        },
        provinceId: 55,
     },
     {
        id: 776,
        code: '7006',
        text: 'บางแพ',
        value: 'บางแพ',
        name: {
          th: 'บางแพ',
          en: 'Bang Phae',
        },
        provinceId: 55,
     },
     {
        id: 777,
        code: '7007',
        text: 'โพธาราม',
        value: 'โพธาราม',
        name: {
          th: 'โพธาราม',
          en: 'Pho tharam',
        },
        provinceId: 55,
     },
     {
        id: 778,
        code: '7008',
        text: 'ปากท่อ',
        value: 'ปากท่อ',
        name: {
          th: 'ปากท่อ',
          en: 'Pak  tho',
        },
        provinceId: 55,
     },
     {
        id: 779,
        code: '7009',
        text: 'วัดเพลง',
        value: 'วัดเพลง',
        name: {
          th: 'วัดเพลง',
          en: 'Wat Phl eng',
        },
        provinceId: 55,
     },
     {
        id: 780,
        code: '7010',
        text: 'บ้านคา',
        value: 'บ้านคา',
        name: {
          th: 'บ้านคา',
          en: 'Ban Kha',
        },
        provinceId: 55,
     },
     {
        id: 781,
        code: '7074',
        text: 'ท้องถิ่นเทศบาลตำบลบ้านฆ้อง',
        value: 'ท้องถิ่นเทศบาลตำบลบ้านฆ้อง',
        name: {
          th: 'ท้องถิ่นเทศบาลตำบลบ้านฆ้อง',
          en: 'Tet Saban Ban Kong',
        },
        provinceId: 55,
     },
     {
        id: 782,
        code: '7101',
        text: 'เมืองกาญจนบุรี',
        value: 'เมืองกาญจนบุรี',
        name: {
          th: 'เมืองกาญจนบุรี',
          en: 'Mueang Kanchanaburi',
        },
        provinceId: 56,
     },
     {
        id: 783,
        code: '7102',
        text: 'ไทรโยค',
        value: 'ไทรโยค',
        name: {
          th: 'ไทรโยค',
          en: 'Sai Yok',
        },
        provinceId: 56,
     },
     {
        id: 784,
        code: '7103',
        text: 'บ่อพลอย',
        value: 'บ่อพลอย',
        name: {
          th: 'บ่อพลอย',
          en: 'Bo Phloi',
        },
        provinceId: 56,
     },
     {
        id: 785,
        code: '7104',
        text: 'ศรีสวัสดิ์',
        value: 'ศรีสวัสดิ์',
        name: {
          th: 'ศรีสวัสดิ์',
          en: 'Si Sawat',
        },
        provinceId: 56,
     },
     {
        id: 786,
        code: '7105',
        text: 'ท่ามะกา',
        value: 'ท่ามะกา',
        name: {
          th: 'ท่ามะกา',
          en: ' tha Maka',
        },
        provinceId: 56,
     },
     {
        id: 787,
        code: '7106',
        text: 'ท่าม่วง',
        value: 'ท่าม่วง',
        name: {
          th: 'ท่าม่วง',
          en: ' tha Muang',
        },
        provinceId: 56,
     },
     {
        id: 788,
        code: '7107',
        text: 'ทองผาภูมิ',
        value: 'ทองผาภูมิ',
        name: {
          th: 'ทองผาภูมิ',
          en: 'Pha Phum',
        },
        provinceId: 56,
     },
     {
        id: 789,
        code: '7108',
        text: 'สังขละบุรี',
        value: 'สังขละบุรี',
        name: {
          th: 'สังขละบุรี',
          en: 'Sangkhla Buri',
        },
        provinceId: 56,
     },
     {
        id: 790,
        code: '7109',
        text: 'พนมทวน',
        value: 'พนมทวน',
        name: {
          th: 'พนมทวน',
          en: 'Phanom  thuan',
        },
        provinceId: 56,
     },
     {
        id: 791,
        code: '7110',
        text: 'เลาขวัญ',
        value: 'เลาขวัญ',
        name: {
          th: 'เลาขวัญ',
          en: 'Lao Khwan',
        },
        provinceId: 56,
     },
     {
        id: 792,
        code: '7111',
        text: 'ด่านมะขามเตี้ย',
        value: 'ด่านมะขามเตี้ย',
        name: {
          th: 'ด่านมะขามเตี้ย',
          en: 'Dan Makham Tia',
        },
        provinceId: 56,
     },
     {
        id: 793,
        code: '7112',
        text: 'หนองปรือ',
        value: 'หนองปรือ',
        name: {
          th: 'หนองปรือ',
          en: 'Nong Prue',
        },
        provinceId: 56,
     },
     {
        id: 794,
        code: '7113',
        text: 'ห้วยกระเจา',
        value: 'ห้วยกระเจา',
        name: {
          th: 'ห้วยกระเจา',
          en: 'Huai Krachao',
        },
        provinceId: 56,
     },
     {
        id: 795,
        code: '7151',
        text: 'สาขาตำบลท่ากระดาน',
        value: 'สาขาตำบลท่ากระดาน',
        name: {
          th: 'สาขาตำบลท่ากระดาน',
          en: ' tha Kra Dan',
        },
        provinceId: 56,
     },
     {
        id: 796,
        code: '7181',
        text: 'บ้านทวน  จ.กาญจนบุรี',
        value: 'บ้านทวน  จ.กาญจนบุรี',
        name: {
          th: 'บ้านทวน  จ.กาญจนบุรี',
          en: 'Ban Tuan',
        },
        provinceId: 56,
     },
     {
        id: 797,
        code: '7201',
        text: 'เมืองสุพรรณบุรี',
        value: 'เมืองสุพรรณบุรี',
        name: {
          th: 'เมืองสุพรรณบุรี',
          en: 'Mueang Suphan Buri',
        },
        provinceId: 57,
     },
     {
        id: 798,
        code: '7202',
        text: 'เดิมบางนางบวช',
        value: 'เดิมบางนางบวช',
        name: {
          th: 'เดิมบางนางบวช',
          en: 'Doem Bang Nang Buat',
        },
        provinceId: 57,
     },
     {
        id: 799,
        code: '7203',
        text: 'ด่านช้าง',
        value: 'ด่านช้าง',
        name: {
          th: 'ด่านช้าง',
          en: 'Dan Chang',
        },
        provinceId: 57,
     },
     {
        id: 800,
        code: '7204',
        text: 'บางปลาม้า',
        value: 'บางปลาม้า',
        name: {
          th: 'บางปลาม้า',
          en: 'Bang Pla Ma',
        },
        provinceId: 57,
     },
     {
        id: 801,
        code: '7205',
        text: 'ศรีประจันต์',
        value: 'ศรีประจันต์',
        name: {
          th: 'ศรีประจันต์',
          en: 'Si Prachan',
        },
        provinceId: 57,
     },
     {
        id: 802,
        code: '7206',
        text: 'ดอนเจดีย์',
        value: 'ดอนเจดีย์',
        name: {
          th: 'ดอนเจดีย์',
          en: 'Don Chedi',
        },
        provinceId: 57,
     },
     {
        id: 803,
        code: '7207',
        text: 'สองพี่น้อง',
        value: 'สองพี่น้อง',
        name: {
          th: 'สองพี่น้อง',
          en: 'Song Phi Nong',
        },
        provinceId: 57,
     },
     {
        id: 804,
        code: '7208',
        text: 'สามชุก',
        value: 'สามชุก',
        name: {
          th: 'สามชุก',
          en: 'Sam Chuk',
        },
        provinceId: 57,
     },
     {
        id: 805,
        code: '7209',
        text: 'อู่ทอง',
        value: 'อู่ทอง',
        name: {
          th: 'อู่ทอง',
          en: 'U  thong',
        },
        provinceId: 57,
     },
     {
        id: 806,
        code: '7210',
        text: 'หนองหญ้าไซ',
        value: 'หนองหญ้าไซ',
        name: {
          th: 'หนองหญ้าไซ',
          en: 'Nong Ya Sai',
        },
        provinceId: 57,
     },
     {
        id: 807,
        code: '7301',
        text: 'เมืองนครปฐม',
        value: 'เมืองนครปฐม',
        name: {
          th: 'เมืองนครปฐม',
          en: 'Mueang Nakhon Pa thom',
        },
        provinceId: 58,
     },
     {
        id: 808,
        code: '7302',
        text: 'กำแพงแสน',
        value: 'กำแพงแสน',
        name: {
          th: 'กำแพงแสน',
          en: 'Kampha eng Sa en',
        },
        provinceId: 58,
     },
     {
        id: 809,
        code: '7303',
        text: 'นครชัยศรี',
        value: 'นครชัยศรี',
        name: {
          th: 'นครชัยศรี',
          en: 'Nakhon Chai Si',
        },
        provinceId: 58,
     },
     {
        id: 810,
        code: '7304',
        text: 'ดอนตูม',
        value: 'ดอนตูม',
        name: {
          th: 'ดอนตูม',
          en: 'Don Tum',
        },
        provinceId: 58,
     },
     {
        id: 811,
        code: '7305',
        text: 'บางเลน',
        value: 'บางเลน',
        name: {
          th: 'บางเลน',
          en: 'Bang L en',
        },
        provinceId: 58,
     },
     {
        id: 812,
        code: '7306',
        text: 'สามพราน',
        value: 'สามพราน',
        name: {
          th: 'สามพราน',
          en: 'Sam Phran',
        },
        provinceId: 58,
     },
     {
        id: 813,
        code: '7307',
        text: 'พุทธมณฑล',
        value: 'พุทธมณฑล',
        name: {
          th: 'พุทธมณฑล',
          en: 'Phut thamon thon',
        },
        provinceId: 58,
     },
     {
        id: 814,
        code: '7401',
        text: 'เมืองสมุทรสาคร',
        value: 'เมืองสมุทรสาคร',
        name: {
          th: 'เมืองสมุทรสาคร',
          en: 'Mueang Samut Sakhon',
        },
        provinceId: 59,
     },
     {
        id: 815,
        code: '7402',
        text: 'กระทุ่มแบน',
        value: 'กระทุ่มแบน',
        name: {
          th: 'กระทุ่มแบน',
          en: 'Kra thum Ba en',
        },
        provinceId: 59,
     },
     {
        id: 816,
        code: '7403',
        text: 'บ้านแพ้ว',
        value: 'บ้านแพ้ว',
        name: {
          th: 'บ้านแพ้ว',
          en: 'Ban Phaeo',
        },
        provinceId: 59,
     },
     {
        id: 817,
        code: '7501',
        text: 'เมืองสมุทรสงคราม',
        value: 'เมืองสมุทรสงคราม',
        name: {
          th: 'เมืองสมุทรสงคราม',
          en: 'Mueang Samut Songkhram',
        },
        provinceId: 60,
     },
     {
        id: 818,
        code: '7502',
        text: 'บางคนที',
        value: 'บางคนที',
        name: {
          th: 'บางคนที',
          en: 'Bang Khon thi',
        },
        provinceId: 60,
     },
     {
        id: 819,
        code: '7503',
        text: 'อัมพวา',
        value: 'อัมพวา',
        name: {
          th: 'อัมพวา',
          en: 'Amphawa',
        },
        provinceId: 60,
     },
     {
        id: 820,
        code: '7601',
        text: 'เมืองเพชรบุรี',
        value: 'เมืองเพชรบุรี',
        name: {
          th: 'เมืองเพชรบุรี',
          en: 'Mueang Phetchaburi',
        },
        provinceId: 61,
     },
     {
        id: 821,
        code: '7602',
        text: 'เขาย้อย',
        value: 'เขาย้อย',
        name: {
          th: 'เขาย้อย',
          en: 'Khao Yoi',
        },
        provinceId: 61,
     },
     {
        id: 822,
        code: '7603',
        text: 'หนองหญ้าปล้อง',
        value: 'หนองหญ้าปล้อง',
        name: {
          th: 'หนองหญ้าปล้อง',
          en: 'Nong Ya Plong',
        },
        provinceId: 61,
     },
     {
        id: 823,
        code: '7604',
        text: 'ชะอำ',
        value: 'ชะอำ',
        name: {
          th: 'ชะอำ',
          en: 'Cha-am',
        },
        provinceId: 61,
     },
     {
        id: 824,
        code: '7605',
        text: 'ท่ายาง',
        value: 'ท่ายาง',
        name: {
          th: 'ท่ายาง',
          en: ' tha Yang',
        },
        provinceId: 61,
     },
     {
        id: 825,
        code: '7606',
        text: 'บ้านลาด',
        value: 'บ้านลาด',
        name: {
          th: 'บ้านลาด',
          en: 'Ban Lat',
        },
        provinceId: 61,
     },
     {
        id: 826,
        code: '7607',
        text: 'บ้านแหลม',
        value: 'บ้านแหลม',
        name: {
          th: 'บ้านแหลม',
          en: 'Ban Laem',
        },
        provinceId: 61,
     },
     {
        id: 827,
        code: '7608',
        text: 'แก่งกระจาน',
        value: 'แก่งกระจาน',
        name: {
          th: 'แก่งกระจาน',
          en: 'Ka eng Krachan',
        },
        provinceId: 61,
     },
     {
        id: 828,
        code: '7701',
        text: 'เมืองประจวบคีรีขันธ์',
        value: 'เมืองประจวบคีรีขันธ์',
        name: {
          th: 'เมืองประจวบคีรีขันธ์',
          en: 'Mueang Prachuap Khiri Khan',
        },
        provinceId: 62,
     },
     {
        id: 829,
        code: '7702',
        text: 'กุยบุรี',
        value: 'กุยบุรี',
        name: {
          th: 'กุยบุรี',
          en: 'Kui Buri',
        },
        provinceId: 62,
     },
     {
        id: 830,
        code: '7703',
        text: 'ทับสะแก',
        value: 'ทับสะแก',
        name: {
          th: 'ทับสะแก',
          en: ' thap Sakae',
        },
        provinceId: 62,
     },
     {
        id: 831,
        code: '7704',
        text: 'บางสะพาน',
        value: 'บางสะพาน',
        name: {
          th: 'บางสะพาน',
          en: 'Bang Saphan',
        },
        provinceId: 62,
     },
     {
        id: 832,
        code: '7705',
        text: 'บางสะพานน้อย',
        value: 'บางสะพานน้อย',
        name: {
          th: 'บางสะพานน้อย',
          en: 'Bang Saphan Noi',
        },
        provinceId: 62,
     },
     {
        id: 833,
        code: '7706',
        text: 'ปราณบุรี',
        value: 'ปราณบุรี',
        name: {
          th: 'ปราณบุรี',
          en: 'Pran Buri',
        },
        provinceId: 62,
     },
     {
        id: 834,
        code: '7707',
        text: 'หัวหิน',
        value: 'หัวหิน',
        name: {
          th: 'หัวหิน',
          en: 'Hua Hin',
        },
        provinceId: 62,
     },
     {
        id: 835,
        code: '7708',
        text: 'สามร้อยยอด',
        value: 'สามร้อยยอด',
        name: {
          th: 'สามร้อยยอด',
          en: 'Sam Roi Yot',
        },
        provinceId: 62,
     },
     {
        id: 836,
        code: '8001',
        text: 'เมืองนครศรีธรรมราช',
        value: 'เมืองนครศรีธรรมราช',
        name: {
          th: 'เมืองนครศรีธรรมราช',
          en: 'Mueang Nakhon Si  thammarat',
        },
        provinceId: 63,
     },
     {
        id: 837,
        code: '8002',
        text: 'พรหมคีรี',
        value: 'พรหมคีรี',
        name: {
          th: 'พรหมคีรี',
          en: 'Phrom Khiri',
        },
        provinceId: 63,
     },
     {
        id: 838,
        code: '8003',
        text: 'ลานสกา',
        value: 'ลานสกา',
        name: {
          th: 'ลานสกา',
          en: 'Lan Saka',
        },
        provinceId: 63,
     },
     {
        id: 839,
        code: '8004',
        text: 'ฉวาง',
        value: 'ฉวาง',
        name: {
          th: 'ฉวาง',
          en: 'Chawang',
        },
        provinceId: 63,
     },
     {
        id: 840,
        code: '8005',
        text: 'พิปูน',
        value: 'พิปูน',
        name: {
          th: 'พิปูน',
          en: 'Phipun',
        },
        provinceId: 63,
     },
     {
        id: 841,
        code: '8006',
        text: 'เชียรใหญ่',
        value: 'เชียรใหญ่',
        name: {
          th: 'เชียรใหญ่',
          en: 'Chian Yai',
        },
        provinceId: 63,
     },
     {
        id: 842,
        code: '8007',
        text: 'ชะอวด',
        value: 'ชะอวด',
        name: {
          th: 'ชะอวด',
          en: 'Cha-uat',
        },
        provinceId: 63,
     },
     {
        id: 843,
        code: '8008',
        text: 'ท่าศาลา',
        value: 'ท่าศาลา',
        name: {
          th: 'ท่าศาลา',
          en: ' tha Sala',
        },
        provinceId: 63,
     },
     {
        id: 844,
        code: '8009',
        text: 'ทุ่งสง',
        value: 'ทุ่งสง',
        name: {
          th: 'ทุ่งสง',
          en: ' thung Song',
        },
        provinceId: 63,
     },
     {
        id: 845,
        code: '8010',
        text: 'นาบอน',
        value: 'นาบอน',
        name: {
          th: 'นาบอน',
          en: 'Na Bon',
        },
        provinceId: 63,
     },
     {
        id: 846,
        code: '8011',
        text: 'ทุ่งใหญ่',
        value: 'ทุ่งใหญ่',
        name: {
          th: 'ทุ่งใหญ่',
          en: ' thung Yai',
        },
        provinceId: 63,
     },
     {
        id: 847,
        code: '8012',
        text: 'ปากพนัง',
        value: 'ปากพนัง',
        name: {
          th: 'ปากพนัง',
          en: 'Pak Phanang',
        },
        provinceId: 63,
     },
     {
        id: 848,
        code: '8013',
        text: 'ร่อนพิบูลย์',
        value: 'ร่อนพิบูลย์',
        name: {
          th: 'ร่อนพิบูลย์',
          en: 'Ron Phibun',
        },
        provinceId: 63,
     },
     {
        id: 849,
        code: '8014',
        text: 'สิชล',
        value: 'สิชล',
        name: {
          th: 'สิชล',
          en: 'Sichon',
        },
        provinceId: 63,
     },
     {
        id: 850,
        code: '8015',
        text: 'ขนอม',
        value: 'ขนอม',
        name: {
          th: 'ขนอม',
          en: 'Khanom',
        },
        provinceId: 63,
     },
     {
        id: 851,
        code: '8016',
        text: 'หัวไทร',
        value: 'หัวไทร',
        name: {
          th: 'หัวไทร',
          en: 'Hua Sai',
        },
        provinceId: 63,
     },
     {
        id: 852,
        code: '8017',
        text: 'บางขัน',
        value: 'บางขัน',
        name: {
          th: 'บางขัน',
          en: 'Bang Khan',
        },
        provinceId: 63,
     },
     {
        id: 853,
        code: '8018',
        text: 'ถ้ำพรรณรา',
        value: 'ถ้ำพรรณรา',
        name: {
          th: 'ถ้ำพรรณรา',
          en: ' tham Phannara',
        },
        provinceId: 63,
     },
     {
        id: 854,
        code: '8019',
        text: 'จุฬาภรณ์',
        value: 'จุฬาภรณ์',
        name: {
          th: 'จุฬาภรณ์',
          en: 'Chulabhorn',
        },
        provinceId: 63,
     },
     {
        id: 855,
        code: '8020',
        text: 'พระพรหม',
        value: 'พระพรหม',
        name: {
          th: 'พระพรหม',
          en: 'Phra Phrom',
        },
        provinceId: 63,
     },
     {
        id: 856,
        code: '8021',
        text: 'นบพิตำ',
        value: 'นบพิตำ',
        name: {
          th: 'นบพิตำ',
          en: 'Nopphitam',
        },
        provinceId: 63,
     },
     {
        id: 857,
        code: '8022',
        text: 'ช้างกลาง',
        value: 'ช้างกลาง',
        name: {
          th: 'ช้างกลาง',
          en: 'Chang Klang',
        },
        provinceId: 63,
     },
     {
        id: 858,
        code: '8023',
        text: 'เฉลิมพระเกียรติ',
        value: 'เฉลิมพระเกียรติ',
        name: {
          th: 'เฉลิมพระเกียรติ',
          en: 'Chaloem Phra Kiat',
        },
        provinceId: 63,
     },
     {
        id: 859,
        code: '8051',
        text: 'เชียรใหญ่ (สาขาตำบลเสือหึง)',
        value: 'เชียรใหญ่ (สาขาตำบลเสือหึง)',
        name: {
          th: 'เชียรใหญ่ (สาขาตำบลเสือหึง)',
          en: 'Chian Yai',
        },
        provinceId: 63,
     },
     {
        id: 860,
        code: '8052',
        text: 'สาขาตำบลสวนหลวง',
        value: 'สาขาตำบลสวนหลวง',
        name: {
          th: 'สาขาตำบลสวนหลวง',
          en: 'Suan Luang',
        },
        provinceId: 63,
     },
     {
        id: 861,
        code: '8053',
        text: 'ร่อนพิบูลย์ (สาขาตำบลหินตก)',
        value: 'ร่อนพิบูลย์ (สาขาตำบลหินตก)',
        name: {
          th: 'ร่อนพิบูลย์ (สาขาตำบลหินตก)',
          en: 'Ron Phibun',
        },
        provinceId: 63,
     },
     {
        id: 862,
        code: '8054',
        text: 'หัวไทร (สาขาตำบลควนชะลิก)',
        value: 'หัวไทร (สาขาตำบลควนชะลิก)',
        name: {
          th: 'หัวไทร (สาขาตำบลควนชะลิก)',
          en: 'Hua Sai',
        },
        provinceId: 63,
     },
     {
        id: 863,
        code: '8055',
        text: 'ทุ่งสง (สาขาตำบลกะปาง)',
        value: 'ทุ่งสง (สาขาตำบลกะปาง)',
        name: {
          th: 'ทุ่งสง (สาขาตำบลกะปาง)',
          en: ' thung Song',
        },
        provinceId: 63,
     },
     {
        id: 864,
        code: '8101',
        text: 'เมืองกระบี่',
        value: 'เมืองกระบี่',
        name: {
          th: 'เมืองกระบี่',
          en: 'Mueang Krabi',
        },
        provinceId: 64,
     },
     {
        id: 865,
        code: '8102',
        text: 'เขาพนม',
        value: 'เขาพนม',
        name: {
          th: 'เขาพนม',
          en: 'Khao Phanom',
        },
        provinceId: 64,
     },
     {
        id: 866,
        code: '8103',
        text: 'เกาะลันตา',
        value: 'เกาะลันตา',
        name: {
          th: 'เกาะลันตา',
          en: 'Ko Lanta',
        },
        provinceId: 64,
     },
     {
        id: 867,
        code: '8104',
        text: 'คลองท่อม',
        value: 'คลองท่อม',
        name: {
          th: 'คลองท่อม',
          en: 'Khlong  thom',
        },
        provinceId: 64,
     },
     {
        id: 868,
        code: '8105',
        text: 'อ่าวลึก',
        value: 'อ่าวลึก',
        name: {
          th: 'อ่าวลึก',
          en: 'Ao Luek',
        },
        provinceId: 64,
     },
     {
        id: 869,
        code: '8106',
        text: 'ปลายพระยา',
        value: 'ปลายพระยา',
        name: {
          th: 'ปลายพระยา',
          en: 'Plai Phraya',
        },
        provinceId: 64,
     },
     {
        id: 870,
        code: '8107',
        text: 'ลำทับ',
        value: 'ลำทับ',
        name: {
          th: 'ลำทับ',
          en: 'Lam  thap',
        },
        provinceId: 64,
     },
     {
        id: 871,
        code: '8108',
        text: 'เหนือคลอง',
        value: 'เหนือคลอง',
        name: {
          th: 'เหนือคลอง',
          en: 'Nuea Khlong',
        },
        provinceId: 64,
     },
     {
        id: 872,
        code: '8201',
        text: 'เมืองพังงา',
        value: 'เมืองพังงา',
        name: {
          th: 'เมืองพังงา',
          en: 'Mueang Phang-nga',
        },
        provinceId: 65,
     },
     {
        id: 873,
        code: '8202',
        text: 'เกาะยาว',
        value: 'เกาะยาว',
        name: {
          th: 'เกาะยาว',
          en: 'Ko Yao',
        },
        provinceId: 65,
     },
     {
        id: 874,
        code: '8203',
        text: 'กะปง',
        value: 'กะปง',
        name: {
          th: 'กะปง',
          en: 'Kapong',
        },
        provinceId: 65,
     },
     {
        id: 875,
        code: '8204',
        text: 'ตะกั่วทุ่ง',
        value: 'ตะกั่วทุ่ง',
        name: {
          th: 'ตะกั่วทุ่ง',
          en: 'Takua  thung',
        },
        provinceId: 65,
     },
     {
        id: 876,
        code: '8205',
        text: 'ตะกั่วป่า',
        value: 'ตะกั่วป่า',
        name: {
          th: 'ตะกั่วป่า',
          en: 'Takua Pa',
        },
        provinceId: 65,
     },
     {
        id: 877,
        code: '8206',
        text: 'คุระบุรี',
        value: 'คุระบุรี',
        name: {
          th: 'คุระบุรี',
          en: 'Khura Buri',
        },
        provinceId: 65,
     },
     {
        id: 878,
        code: '8207',
        text: 'ทับปุด',
        value: 'ทับปุด',
        name: {
          th: 'ทับปุด',
          en: ' thap Put',
        },
        provinceId: 65,
     },
     {
        id: 879,
        code: '8208',
        text: 'ท้ายเหมือง',
        value: 'ท้ายเหมือง',
        name: {
          th: 'ท้ายเหมือง',
          en: ' thai Mueang',
        },
        provinceId: 65,
     },
     {
        id: 880,
        code: '8301',
        text: 'เมืองภูเก็ต',
        value: 'เมืองภูเก็ต',
        name: {
          th: 'เมืองภูเก็ต',
          en: 'Mueang Phuket',
        },
        provinceId: 66,
     },
     {
        id: 881,
        code: '8302',
        text: 'กะทู้',
        value: 'กะทู้',
        name: {
          th: 'กะทู้',
          en: 'Ka thu',
        },
        provinceId: 66,
     },
     {
        id: 882,
        code: '8303',
        text: 'ถลาง',
        value: 'ถลาง',
        name: {
          th: 'ถลาง',
          en: ' thalang',
        },
        provinceId: 66,
     },
     {
        id: 883,
        code: '8381',
        text: 'ทุ่งคา',
        value: 'ทุ่งคา',
        name: {
          th: 'ทุ่งคา',
          en: 'Tung Ka',
        },
        provinceId: 66,
     },
     {
        id: 884,
        code: '8401',
        text: 'เมืองสุราษฎร์ธานี',
        value: 'เมืองสุราษฎร์ธานี',
        name: {
          th: 'เมืองสุราษฎร์ธานี',
          en: 'Mueang Surat  thani',
        },
        provinceId: 67,
     },
     {
        id: 885,
        code: '8402',
        text: 'กาญจนดิษฐ์',
        value: 'กาญจนดิษฐ์',
        name: {
          th: 'กาญจนดิษฐ์',
          en: 'Kanchanadit',
        },
        provinceId: 67,
     },
     {
        id: 886,
        code: '8403',
        text: 'ดอนสัก',
        value: 'ดอนสัก',
        name: {
          th: 'ดอนสัก',
          en: 'Don Sak',
        },
        provinceId: 67,
     },
     {
        id: 887,
        code: '8404',
        text: 'เกาะสมุย',
        value: 'เกาะสมุย',
        name: {
          th: 'เกาะสมุย',
          en: 'Ko Samui',
        },
        provinceId: 67,
     },
     {
        id: 888,
        code: '8405',
        text: 'เกาะพะงัน',
        value: 'เกาะพะงัน',
        name: {
          th: 'เกาะพะงัน',
          en: 'Ko Pha-ngan',
        },
        provinceId: 67,
     },
     {
        id: 889,
        code: '8406',
        text: 'ไชยา',
        value: 'ไชยา',
        name: {
          th: 'ไชยา',
          en: 'Chaiya',
        },
        provinceId: 67,
     },
     {
        id: 890,
        code: '8407',
        text: 'ท่าชนะ',
        value: 'ท่าชนะ',
        name: {
          th: 'ท่าชนะ',
          en: ' tha Chana',
        },
        provinceId: 67,
     },
     {
        id: 891,
        code: '8408',
        text: 'คีรีรัฐนิคม',
        value: 'คีรีรัฐนิคม',
        name: {
          th: 'คีรีรัฐนิคม',
          en: 'Khiri Rat Nikhom',
        },
        provinceId: 67,
     },
     {
        id: 892,
        code: '8409',
        text: 'บ้านตาขุน',
        value: 'บ้านตาขุน',
        name: {
          th: 'บ้านตาขุน',
          en: 'Ban Ta Khun',
        },
        provinceId: 67,
     },
     {
        id: 893,
        code: '8410',
        text: 'พนม',
        value: 'พนม',
        name: {
          th: 'พนม',
          en: 'Phanom',
        },
        provinceId: 67,
     },
     {
        id: 894,
        code: '8411',
        text: 'ท่าฉาง',
        value: 'ท่าฉาง',
        name: {
          th: 'ท่าฉาง',
          en: ' tha Chang',
        },
        provinceId: 67,
     },
     {
        id: 895,
        code: '8412',
        text: 'บ้านนาสาร',
        value: 'บ้านนาสาร',
        name: {
          th: 'บ้านนาสาร',
          en: 'Ban Na San',
        },
        provinceId: 67,
     },
     {
        id: 896,
        code: '8413',
        text: 'บ้านนาเดิม',
        value: 'บ้านนาเดิม',
        name: {
          th: 'บ้านนาเดิม',
          en: 'Ban Na Doem',
        },
        provinceId: 67,
     },
     {
        id: 897,
        code: '8414',
        text: 'เคียนซา',
        value: 'เคียนซา',
        name: {
          th: 'เคียนซา',
          en: 'Khian Sa',
        },
        provinceId: 67,
     },
     {
        id: 898,
        code: '8415',
        text: 'เวียงสระ',
        value: 'เวียงสระ',
        name: {
          th: 'เวียงสระ',
          en: 'Wiang Sa',
        },
        provinceId: 67,
     },
     {
        id: 899,
        code: '8416',
        text: 'พระแสง',
        value: 'พระแสง',
        name: {
          th: 'พระแสง',
          en: 'Phrasa eng',
        },
        provinceId: 67,
     },
     {
        id: 900,
        code: '8417',
        text: 'พุนพิน',
        value: 'พุนพิน',
        name: {
          th: 'พุนพิน',
          en: 'Phunphin',
        },
        provinceId: 67,
     },
     {
        id: 901,
        code: '8418',
        text: 'ชัยบุรี',
        value: 'ชัยบุรี',
        name: {
          th: 'ชัยบุรี',
          en: 'Chai Buri',
        },
        provinceId: 67,
     },
     {
        id: 902,
        code: '8419',
        text: 'วิภาวดี',
        value: 'วิภาวดี',
        name: {
          th: 'วิภาวดี',
          en: 'Vibhavadi',
        },
        provinceId: 67,
     },
     {
        id: 903,
        code: '8451',
        text: 'เกาะพงัน (สาขาตำบลเกาะเต่า)',
        value: 'เกาะพงัน (สาขาตำบลเกาะเต่า)',
        name: {
          th: 'เกาะพงัน (สาขาตำบลเกาะเต่า)',
          en: 'Ko Pha-ngan',
        },
        provinceId: 67,
     },
     {
        id: 904,
        code: '8481',
        text: 'อ.บ้านดอน  จ.สุราษฎร์ธานี',
        value: 'อ.บ้านดอน  จ.สุราษฎร์ธานี',
        name: {
          th: 'อ.บ้านดอน  จ.สุราษฎร์ธานี',
          en: 'Ban Don',
        },
        provinceId: 67,
     },
     {
        id: 905,
        code: '8501',
        text: 'เมืองระนอง',
        value: 'เมืองระนอง',
        name: {
          th: 'เมืองระนอง',
          en: 'Mueang Ranong',
        },
        provinceId: 68,
     },
     {
        id: 906,
        code: '8502',
        text: 'ละอุ่น',
        value: 'ละอุ่น',
        name: {
          th: 'ละอุ่น',
          en: 'La-un',
        },
        provinceId: 68,
     },
     {
        id: 907,
        code: '8503',
        text: 'กะเปอร์',
        value: 'กะเปอร์',
        name: {
          th: 'กะเปอร์',
          en: 'Kapoe',
        },
        provinceId: 68,
     },
     {
        id: 908,
        code: '8504',
        text: 'กระบุรี',
        value: 'กระบุรี',
        name: {
          th: 'กระบุรี',
          en: 'Kra Buri',
        },
        provinceId: 68,
     },
     {
        id: 909,
        code: '8505',
        text: 'สุขสำราญ',
        value: 'สุขสำราญ',
        name: {
          th: 'สุขสำราญ',
          en: 'Suk Samran',
        },
        provinceId: 68,
     },
     {
        id: 910,
        code: '8601',
        text: 'เมืองชุมพร',
        value: 'เมืองชุมพร',
        name: {
          th: 'เมืองชุมพร',
          en: 'Mueang Chumphon',
        },
        provinceId: 69,
     },
     {
        id: 911,
        code: '8602',
        text: 'ท่าแซะ',
        value: 'ท่าแซะ',
        name: {
          th: 'ท่าแซะ',
          en: ' tha Sae',
        },
        provinceId: 69,
     },
     {
        id: 912,
        code: '8603',
        text: 'ปะทิว',
        value: 'ปะทิว',
        name: {
          th: 'ปะทิว',
          en: 'Pa thio',
        },
        provinceId: 69,
     },
     {
        id: 913,
        code: '8604',
        text: 'หลังสวน',
        value: 'หลังสวน',
        name: {
          th: 'หลังสวน',
          en: 'Lang Suan',
        },
        provinceId: 69,
     },
     {
        id: 914,
        code: '8605',
        text: 'ละแม',
        value: 'ละแม',
        name: {
          th: 'ละแม',
          en: 'Lamae',
        },
        provinceId: 69,
     },
     {
        id: 915,
        code: '8606',
        text: 'พะโต๊ะ',
        value: 'พะโต๊ะ',
        name: {
          th: 'พะโต๊ะ',
          en: 'Phato',
        },
        provinceId: 69,
     },
     {
        id: 916,
        code: '8607',
        text: 'สวี',
        value: 'สวี',
        name: {
          th: 'สวี',
          en: 'Sawi',
        },
        provinceId: 69,
     },
     {
        id: 917,
        code: '8608',
        text: 'ทุ่งตะโก',
        value: 'ทุ่งตะโก',
        name: {
          th: 'ทุ่งตะโก',
          en: ' thung Tako',
        },
        provinceId: 69,
     },
     {
        id: 918,
        code: '9001',
        text: 'เมืองสงขลา',
        value: 'เมืองสงขลา',
        name: {
          th: 'เมืองสงขลา',
          en: 'Mueang Songkhla',
        },
        provinceId: 70,
     },
     {
        id: 919,
        code: '9002',
        text: 'สทิงพระ',
        value: 'สทิงพระ',
        name: {
          th: 'สทิงพระ',
          en: 'Sa thing Phra',
        },
        provinceId: 70,
     },
     {
        id: 920,
        code: '9003',
        text: 'จะนะ',
        value: 'จะนะ',
        name: {
          th: 'จะนะ',
          en: 'Chana',
        },
        provinceId: 70,
     },
     {
        id: 921,
        code: '9004',
        text: 'นาทวี',
        value: 'นาทวี',
        name: {
          th: 'นาทวี',
          en: 'Na  thawi',
        },
        provinceId: 70,
     },
     {
        id: 922,
        code: '9005',
        text: 'เทพา',
        value: 'เทพา',
        name: {
          th: 'เทพา',
          en: ' thepha',
        },
        provinceId: 70,
     },
     {
        id: 923,
        code: '9006',
        text: 'สะบ้าย้อย',
        value: 'สะบ้าย้อย',
        name: {
          th: 'สะบ้าย้อย',
          en: 'Saba Yoi',
        },
        provinceId: 70,
     },
     {
        id: 924,
        code: '9007',
        text: 'ระโนด',
        value: 'ระโนด',
        name: {
          th: 'ระโนด',
          en: 'Ranot',
        },
        provinceId: 70,
     },
     {
        id: 925,
        code: '9008',
        text: 'กระแสสินธุ์',
        value: 'กระแสสินธุ์',
        name: {
          th: 'กระแสสินธุ์',
          en: 'Krasae Sin',
        },
        provinceId: 70,
     },
     {
        id: 926,
        code: '9009',
        text: 'รัตภูมิ',
        value: 'รัตภูมิ',
        name: {
          th: 'รัตภูมิ',
          en: 'Rattaphum',
        },
        provinceId: 70,
     },
     {
        id: 927,
        code: '9010',
        text: 'สะเดา',
        value: 'สะเดา',
        name: {
          th: 'สะเดา',
          en: 'Sadao',
        },
        provinceId: 70,
     },
     {
        id: 928,
        code: '9011',
        text: 'หาดใหญ่',
        value: 'หาดใหญ่',
        name: {
          th: 'หาดใหญ่',
          en: 'Hat Yai',
        },
        provinceId: 70,
     },
     {
        id: 929,
        code: '9012',
        text: 'นาหม่อม',
        value: 'นาหม่อม',
        name: {
          th: 'นาหม่อม',
          en: 'Na Mom',
        },
        provinceId: 70,
     },
     {
        id: 930,
        code: '9013',
        text: 'ควนเนียง',
        value: 'ควนเนียง',
        name: {
          th: 'ควนเนียง',
          en: 'Khuan Niang',
        },
        provinceId: 70,
     },
     {
        id: 931,
        code: '9014',
        text: 'บางกล่ำ',
        value: 'บางกล่ำ',
        name: {
          th: 'บางกล่ำ',
          en: 'Bang Klam',
        },
        provinceId: 70,
     },
     {
        id: 932,
        code: '9015',
        text: 'สิงหนคร',
        value: 'สิงหนคร',
        name: {
          th: 'สิงหนคร',
          en: 'Singhanakhon',
        },
        provinceId: 70,
     },
     {
        id: 933,
        code: '9016',
        text: 'คลองหอยโข่ง',
        value: 'คลองหอยโข่ง',
        name: {
          th: 'คลองหอยโข่ง',
          en: 'Khlong Hoi Khong',
        },
        provinceId: 70,
     },
     {
        id: 934,
        code: '9077',
        text: 'ท้องถิ่นเทศบาลตำบลสำนักขาม',
        value: 'ท้องถิ่นเทศบาลตำบลสำนักขาม',
        name: {
          th: 'ท้องถิ่นเทศบาลตำบลสำนักขาม',
          en: 'Sum Nung Kam',
        },
        provinceId: 70,
     },
     {
        id: 935,
        code: '9096',
        text: 'เทศบาลตำบลบ้านพรุ',
        value: 'เทศบาลตำบลบ้านพรุ',
        name: {
          th: 'เทศบาลตำบลบ้านพรุ',
          en: 'Ban Pru',
        },
        provinceId: 70,
     },
     {
        id: 936,
        code: '9101',
        text: 'เมืองสตูล',
        value: 'เมืองสตูล',
        name: {
          th: 'เมืองสตูล',
          en: 'Mueang Satun',
        },
        provinceId: 71,
     },
     {
        id: 937,
        code: '9102',
        text: 'ควนโดน',
        value: 'ควนโดน',
        name: {
          th: 'ควนโดน',
          en: 'Khuan Don',
        },
        provinceId: 71,
     },
     {
        id: 938,
        code: '9103',
        text: 'ควนกาหลง',
        value: 'ควนกาหลง',
        name: {
          th: 'ควนกาหลง',
          en: 'Khuan Kalong',
        },
        provinceId: 71,
     },
     {
        id: 939,
        code: '9104',
        text: 'ท่าแพ',
        value: 'ท่าแพ',
        name: {
          th: 'ท่าแพ',
          en: ' tha Phae',
        },
        provinceId: 71,
     },
     {
        id: 940,
        code: '9105',
        text: 'ละงู',
        value: 'ละงู',
        name: {
          th: 'ละงู',
          en: 'La-ngu',
        },
        provinceId: 71,
     },
     {
        id: 941,
        code: '9106',
        text: 'ทุ่งหว้า',
        value: 'ทุ่งหว้า',
        name: {
          th: 'ทุ่งหว้า',
          en: ' thung Wa',
        },
        provinceId: 71,
     },
     {
        id: 942,
        code: '9107',
        text: 'มะนัง',
        value: 'มะนัง',
        name: {
          th: 'มะนัง',
          en: 'Manang',
        },
        provinceId: 71,
     },
     {
        id: 943,
        code: '9201',
        text: 'เมืองตรัง',
        value: 'เมืองตรัง',
        name: {
          th: 'เมืองตรัง',
          en: 'Mueang Trang',
        },
        provinceId: 72,
     },
     {
        id: 944,
        code: '9202',
        text: 'กันตัง',
        value: 'กันตัง',
        name: {
          th: 'กันตัง',
          en: 'Kantang',
        },
        provinceId: 72,
     },
     {
        id: 945,
        code: '9203',
        text: 'ย่านตาขาว',
        value: 'ย่านตาขาว',
        name: {
          th: 'ย่านตาขาว',
          en: 'Yan Ta Khao',
        },
        provinceId: 72,
     },
     {
        id: 946,
        code: '9204',
        text: 'ปะเหลียน',
        value: 'ปะเหลียน',
        name: {
          th: 'ปะเหลียน',
          en: 'Palian',
        },
        provinceId: 72,
     },
     {
        id: 947,
        code: '9205',
        text: 'สิเกา',
        value: 'สิเกา',
        name: {
          th: 'สิเกา',
          en: 'Sikao',
        },
        provinceId: 72,
     },
     {
        id: 948,
        code: '9206',
        text: 'ห้วยยอด',
        value: 'ห้วยยอด',
        name: {
          th: 'ห้วยยอด',
          en: 'Huai Yot',
        },
        provinceId: 72,
     },
     {
        id: 949,
        code: '9207',
        text: 'วังวิเศษ',
        value: 'วังวิเศษ',
        name: {
          th: 'วังวิเศษ',
          en: 'Wang Wiset',
        },
        provinceId: 72,
     },
     {
        id: 950,
        code: '9208',
        text: 'นาโยง',
        value: 'นาโยง',
        name: {
          th: 'นาโยง',
          en: 'Na Yong',
        },
        provinceId: 72,
     },
     {
        id: 951,
        code: '9209',
        text: 'รัษฎา',
        value: 'รัษฎา',
        name: {
          th: 'รัษฎา',
          en: 'Ratsada',
        },
        provinceId: 72,
     },
     {
        id: 952,
        code: '9210',
        text: 'หาดสำราญ',
        value: 'หาดสำราญ',
        name: {
          th: 'หาดสำราญ',
          en: 'Hat Samran',
        },
        provinceId: 72,
     },
     {
        id: 953,
        code: '9251',
        text: 'อำเภอเมืองตรัง(สาขาคลองเต็ง)',
        value: 'อำเภอเมืองตรัง(สาขาคลองเต็ง)',
        name: {
          th: 'อำเภอเมืองตรัง(สาขาคลองเต็ง)',
          en: 'Mueang Trang(Krong T eng)',
        },
        provinceId: 72,
     },
     {
        id: 954,
        code: '9301',
        text: 'เมืองพัทลุง',
        value: 'เมืองพัทลุง',
        name: {
          th: 'เมืองพัทลุง',
          en: 'Mueang Phat thalung',
        },
        provinceId: 73,
     },
     {
        id: 955,
        code: '9302',
        text: 'กงหรา',
        value: 'กงหรา',
        name: {
          th: 'กงหรา',
          en: 'Kong Ra',
        },
        provinceId: 73,
     },
     {
        id: 956,
        code: '9303',
        text: 'เขาชัยสน',
        value: 'เขาชัยสน',
        name: {
          th: 'เขาชัยสน',
          en: 'Khao Chaison',
        },
        provinceId: 73,
     },
     {
        id: 957,
        code: '9304',
        text: 'ตะโหมด',
        value: 'ตะโหมด',
        name: {
          th: 'ตะโหมด',
          en: 'Tamot',
        },
        provinceId: 73,
     },
     {
        id: 958,
        code: '9305',
        text: 'ควนขนุน',
        value: 'ควนขนุน',
        name: {
          th: 'ควนขนุน',
          en: 'Khuan Khanun',
        },
        provinceId: 73,
     },
     {
        id: 959,
        code: '9306',
        text: 'ปากพะยูน',
        value: 'ปากพะยูน',
        name: {
          th: 'ปากพะยูน',
          en: 'Pak Phayun',
        },
        provinceId: 73,
     },
     {
        id: 960,
        code: '9307',
        text: 'ศรีบรรพต',
        value: 'ศรีบรรพต',
        name: {
          th: 'ศรีบรรพต',
          en: 'Si Banphot',
        },
        provinceId: 73,
     },
     {
        id: 961,
        code: '9308',
        text: 'ป่าบอน',
        value: 'ป่าบอน',
        name: {
          th: 'ป่าบอน',
          en: 'Pa Bon',
        },
        provinceId: 73,
     },
     {
        id: 962,
        code: '9309',
        text: 'บางแก้ว',
        value: 'บางแก้ว',
        name: {
          th: 'บางแก้ว',
          en: 'Bang Kaeo',
        },
        provinceId: 73,
     },
     {
        id: 963,
        code: '9310',
        text: 'ป่าพะยอม',
        value: 'ป่าพะยอม',
        name: {
          th: 'ป่าพะยอม',
          en: 'Pa Phayom',
        },
        provinceId: 73,
     },
     {
        id: 964,
        code: '9311',
        text: 'ศรีนครินทร์',
        value: 'ศรีนครินทร์',
        name: {
          th: 'ศรีนครินทร์',
          en: 'Srinagarindra',
        },
        provinceId: 73,
     },
     {
        id: 965,
        code: '9401',
        text: 'เมืองปัตตานี',
        value: 'เมืองปัตตานี',
        name: {
          th: 'เมืองปัตตานี',
          en: 'Mueang Pattani',
        },
        provinceId: 74,
     },
     {
        id: 966,
        code: '9402',
        text: 'โคกโพธิ์',
        value: 'โคกโพธิ์',
        name: {
          th: 'โคกโพธิ์',
          en: 'Khok Pho',
        },
        provinceId: 74,
     },
     {
        id: 967,
        code: '9403',
        text: 'หนองจิก',
        value: 'หนองจิก',
        name: {
          th: 'หนองจิก',
          en: 'Nong Chik',
        },
        provinceId: 74,
     },
     {
        id: 968,
        code: '9404',
        text: 'ปะนาเระ',
        value: 'ปะนาเระ',
        name: {
          th: 'ปะนาเระ',
          en: 'Panare',
        },
        provinceId: 74,
     },
     {
        id: 969,
        code: '9405',
        text: 'มายอ',
        value: 'มายอ',
        name: {
          th: 'มายอ',
          en: 'Mayo',
        },
        provinceId: 74,
     },
     {
        id: 970,
        code: '9406',
        text: 'ทุ่งยางแดง',
        value: 'ทุ่งยางแดง',
        name: {
          th: 'ทุ่งยางแดง',
          en: ' thung Yang Da eng',
        },
        provinceId: 74,
     },
     {
        id: 971,
        code: '9407',
        text: 'สายบุรี',
        value: 'สายบุรี',
        name: {
          th: 'สายบุรี',
          en: 'Sai Buri',
        },
        provinceId: 74,
     },
     {
        id: 972,
        code: '9408',
        text: 'ไม้แก่น',
        value: 'ไม้แก่น',
        name: {
          th: 'ไม้แก่น',
          en: 'Mai Ka en',
        },
        provinceId: 74,
     },
     {
        id: 973,
        code: '9409',
        text: 'ยะหริ่ง',
        value: 'ยะหริ่ง',
        name: {
          th: 'ยะหริ่ง',
          en: 'Yaring',
        },
        provinceId: 74,
     },
     {
        id: 974,
        code: '9410',
        text: 'ยะรัง',
        value: 'ยะรัง',
        name: {
          th: 'ยะรัง',
          en: 'Yarang',
        },
        provinceId: 74,
     },
     {
        id: 975,
        code: '9411',
        text: 'กะพ้อ',
        value: 'กะพ้อ',
        name: {
          th: 'กะพ้อ',
          en: 'Kapho',
        },
        provinceId: 74,
     },
     {
        id: 976,
        code: '9412',
        text: 'แม่ลาน',
        value: 'แม่ลาน',
        name: {
          th: 'แม่ลาน',
          en: 'Mae Lan',
        },
        provinceId: 74,
     },
     {
        id: 977,
        code: '9501',
        text: 'เมืองยะลา',
        value: 'เมืองยะลา',
        name: {
          th: 'เมืองยะลา',
          en: 'Mueang Yala',
        },
        provinceId: 75,
     },
     {
        id: 978,
        code: '9502',
        text: 'เบตง',
        value: 'เบตง',
        name: {
          th: 'เบตง',
          en: 'Betong',
        },
        provinceId: 75,
     },
     {
        id: 979,
        code: '9503',
        text: 'บันนังสตา',
        value: 'บันนังสตา',
        name: {
          th: 'บันนังสตา',
          en: 'Bannang Sata',
        },
        provinceId: 75,
     },
     {
        id: 980,
        code: '9504',
        text: 'ธารโต',
        value: 'ธารโต',
        name: {
          th: 'ธารโต',
          en: ' than To',
        },
        provinceId: 75,
     },
     {
        id: 981,
        code: '9505',
        text: 'ยะหา',
        value: 'ยะหา',
        name: {
          th: 'ยะหา',
          en: 'Yaha',
        },
        provinceId: 75,
     },
     {
        id: 982,
        code: '9506',
        text: 'รามัน',
        value: 'รามัน',
        name: {
          th: 'รามัน',
          en: 'Raman',
        },
        provinceId: 75,
     },
     {
        id: 983,
        code: '9507',
        text: 'กาบัง',
        value: 'กาบัง',
        name: {
          th: 'กาบัง',
          en: 'Kabang',
        },
        provinceId: 75,
     },
     {
        id: 984,
        code: '9508',
        text: 'กรงปินัง',
        value: 'กรงปินัง',
        name: {
          th: 'กรงปินัง',
          en: 'Krong Pinang',
        },
        provinceId: 75,
     },
     {
        id: 985,
        code: '9601',
        text: 'เมืองนราธิวาส',
        value: 'เมืองนราธิวาส',
        name: {
          th: 'เมืองนราธิวาส',
          en: 'Mueang Nara thiwat',
        },
        provinceId: 76,
     },
     {
        id: 986,
        code: '9602',
        text: 'ตากใบ',
        value: 'ตากใบ',
        name: {
          th: 'ตากใบ',
          en: 'Tak Bai',
        },
        provinceId: 76,
     },
     {
        id: 987,
        code: '9603',
        text: 'บาเจาะ',
        value: 'บาเจาะ',
        name: {
          th: 'บาเจาะ',
          en: 'Bacho',
        },
        provinceId: 76,
     },
     {
        id: 988,
        code: '9604',
        text: 'ยี่งอ',
        value: 'ยี่งอ',
        name: {
          th: 'ยี่งอ',
          en: 'Yi-ngo',
        },
        provinceId: 76,
     },
     {
        id: 989,
        code: '9605',
        text: 'ระแงะ',
        value: 'ระแงะ',
        name: {
          th: 'ระแงะ',
          en: 'Ra-ngae',
        },
        provinceId: 76,
     },
     {
        id: 990,
        code: '9606',
        text: 'รือเสาะ',
        value: 'รือเสาะ',
        name: {
          th: 'รือเสาะ',
          en: 'Rueso',
        },
        provinceId: 76,
     },
     {
        id: 991,
        code: '9607',
        text: 'ศรีสาคร',
        value: 'ศรีสาคร',
        name: {
          th: 'ศรีสาคร',
          en: 'Si Sakhon',
        },
        provinceId: 76,
     },
     {
        id: 992,
        code: '9608',
        text: 'แว้ง',
        value: 'แว้ง',
        name: {
          th: 'แว้ง',
          en: 'Wa eng',
        },
        provinceId: 76,
     },
     {
        id: 993,
        code: '9609',
        text: 'สุคิริน',
        value: 'สุคิริน',
        name: {
          th: 'สุคิริน',
          en: 'Sukhirin',
        },
        provinceId: 76,
     },
     {
        id: 994,
        code: '9610',
        text: 'สุไหงโก-ลก',
        value: 'สุไหงโก-ลก',
        name: {
          th: 'สุไหงโก-ลก',
          en: 'Su-ngai Kolok',
        },
        provinceId: 76,
     },
     {
        id: 995,
        code: '9611',
        text: 'สุไหงปาดี',
        value: 'สุไหงปาดี',
        name: {
          th: 'สุไหงปาดี',
          en: 'Su-ngai Padi',
        },
        provinceId: 76,
     },
     {
        id: 996,
        code: '9612',
        text: 'จะแนะ',
        value: 'จะแนะ',
        name: {
          th: 'จะแนะ',
          en: 'Chanae',
        },
        provinceId: 76,
     },
     {
        id: 997,
        code: '9613',
        text: 'เจาะไอร้อง',
        value: 'เจาะไอร้อง',
        name: {
          th: 'เจาะไอร้อง',
          en: 'Cho-airong',
        },
        provinceId: 76,
     },
     {
        id: 998,
        code: '9681',
        text: 'อ.บางนรา  จ.นราธิวาส',
        value: 'อ.บางนรา  จ.นราธิวาส',
        name: {
          th: 'อ.บางนรา  จ.นราธิวาส',
          en: 'Bang Nra',
        },
        provinceId: 76,
     },
     {
        id: 1005,
        code: '3807',
        text: 'ปากคาด',
        value: 'ปากคาด',
        name: {
          th: 'ปากคาด',
          en: 'Pak Khat',
        },
        provinceId: 77,
     },
     {
        id: 1004,
        code: '3806',
        text: 'บึงโขงหลง',
        value: 'บึงโขงหลง',
        name: {
          th: 'บึงโขงหลง',
          en: 'Bu eng Khong Long',
        },
        provinceId: 77,
     },
     {
        id: 1003,
        code: '3805',
        text: 'ศรีวิไล',
        value: 'ศรีวิไล',
        name: {
          th: 'ศรีวิไล',
          en: 'Si Wilai',
        },
        provinceId: 77,
     },
     {
        id: 1002,
        code: '3804',
        text: 'พรเจริญ',
        value: 'พรเจริญ',
        name: {
          th: 'พรเจริญ',
          en: 'Phon Charo en',
        },
        provinceId: 77,
     },
     {
        id: 1001,
        code: '3803',
        text: 'โซ่พิสัย',
        value: 'โซ่พิสัย',
        name: {
          th: 'โซ่พิสัย',
          en: 'So Phisai',
        },
        provinceId: 77,
     },
     {
        id: 1000,
        code: '3802',
        text: 'เซกา',
        value: 'เซกา',
        name: {
          th: 'เซกา',
          en: 'Seka',
        },
        provinceId: 77,
     },
     {
        id: 999,
        code: '3801',
        text: 'เมืองบึงกาฬ',
        value: 'เมืองบึงกาฬ',
        name: {
          th: 'เมืองบึงกาฬ',
          en: 'Mueang Bu eng Kan',
        },
        provinceId: 77,
     },
     {
        id: 1006,
        code: '3808',
        text: 'บุ่งคล้า',
        value: 'บุ่งคล้า',
        name: {
          th: 'บุ่งคล้า',
          en: 'Bung Khla',
        },
        provinceId: 77,
      },
    ],
  }
}
